webpackJsonp([3,1],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(382);
	module.exports = __webpack_require__(350);


/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(37);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _promise = __webpack_require__(14);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(61);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(62);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _vue = __webpack_require__(344);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _Data = __webpack_require__(355);
	
	var _Data2 = _interopRequireDefault(_Data);
	
	var _Question = __webpack_require__(351);
	
	var _Question2 = _interopRequireDefault(_Question);
	
	var _Screens = __webpack_require__(353);
	
	var _Screens2 = _interopRequireDefault(_Screens);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ServiceAccess = function () {
	  function ServiceAccess() {
	    (0, _classCallCheck3.default)(this, ServiceAccess);
	
	    if (window.location.href.indexOf('localhost') > 0) {
	      this.serviceURL = 'http://localhost:8000';
	    } else {
	      this.serviceURL = 'https://api.getmyvisatofrance.com';
	    }
	
	    this.yaml = _Data2.default;
	    this.screens = null;
	    this.question = null;
	    this.values = {};
	
	    console.log('New Service');
	  }
	
	  (0, _createClass3.default)(ServiceAccess, [{
	    key: 'loadGraph',
	    value: function loadGraph() {
	      var _this = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        resolve(_this.yaml);
	      });
	    }
	  }, {
	    key: 'loadScreens',
	    value: function loadScreens() {
	      var _this2 = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        if (_this2.screens) {
	          resolve(_this2.screens);
	        } else {
	          _this2.loadGraph().then(function (obj) {
	            _this2.screens = new _Screens2.default(obj.screens);
	            resolve(_this2.screens);
	          }, function (err) {
	            console.error('Fail loading screens: ', err);
	            reject(err);
	          });
	        }
	      });
	    }
	  }, {
	    key: 'loadErrorMessages',
	    value: function loadErrorMessages() {
	      var _this3 = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        if (_this3.errorMessages) {
	          resolve(_this3.errorMessages);
	        } else {
	          _this3.loadGraph().then(function (obj) {
	            _this3.errorMessages = obj.default['error-messages'];
	            resolve(_this3.errorMessages);
	          }, function (err) {
	            console.error('Fail loading messages: ', err);
	            reject(err);
	          });
	        }
	      });
	    }
	  }, {
	    key: 'loadQuestions',
	    value: function loadQuestions() {
	      var _this4 = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        if (_this4.questions) {
	          resolve(_this4.questions);
	        } else {
	          _this4.loadGraph().then(function (obj) {
	            _this4.questions = {};
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	              for (var _iterator = (0, _getIterator3.default)(obj.questions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var q = _step.value;
	
	                _this4.questions[q.id] = new _Question2.default(q);
	              }
	            } catch (err) {
	              _didIteratorError = true;
	              _iteratorError = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                  _iterator.return();
	                }
	              } finally {
	                if (_didIteratorError) {
	                  throw _iteratorError;
	                }
	              }
	            }
	
	            for (var qid1 in _this4.questions) {
	              for (var qid2 in _this4.questions) {
	                if (_this4.questions[qid2].dependsOn(qid1)) {
	                  _this4.questions[qid1].addDependency(qid2);
	                }
	              }
	            }
	
	            resolve(_this4.questions);
	          }, function (err) {
	            console.error('Fail loading questions: ', err);
	            reject(err);
	          });
	        }
	      });
	    }
	  }, {
	    key: 'track',
	    value: function track(sessionId, eventName, properties) {
	      var url = this.serviceURL + '/track/' + sessionId + '/' + eventName;
	      _vue2.default.http.post(url, properties).then(function (response) {}, function (err) {
	        console.error('Track Error: ', err);
	      });
	    }
	  }, {
	    key: 'storeValues',
	    value: function storeValues(sessionId, values) {
	      var url = this.serviceURL + '/values/' + sessionId;
	      _vue2.default.http.post(url, values).then(function (response) {});
	    }
	  }, {
	    key: 'loadValues',
	    value: function loadValues(sessionId) {
	      var _this5 = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        var url = _this5.serviceURL + '/values/' + sessionId;
	        _vue2.default.http.get(url).then(function (response) {
	          for (var key in response.body) {
	            _vue2.default.set(_this5.values, key, response.body[key]);
	          }
	
	          resolve(_this5.values);
	        }, function (err) {
	          reject(err);
	        });
	      });
	    }
	  }, {
	    key: 'loadStage',
	    value: function loadStage(sessionId) {
	      var _this6 = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        var url = _this6.serviceURL + '/stage/' + sessionId;
	        _vue2.default.http.get(url).then(function (response) {
	          resolve(response.body);
	        }, function (err) {
	          reject(err);
	        });
	      });
	    }
	  }, {
	    key: 'saveUserCase',
	    value: function saveUserCase(sessionId, values) {
	      var url = this.serviceURL + '/save/' + sessionId;
	      _vue2.default.http.post(url, values).then(function (response) {});
	    }
	  }, {
	    key: 'purchases',
	    value: function purchases(sessionId) {
	      var _this7 = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        var url = _this7.serviceURL + '/purchases/' + sessionId;
	        _vue2.default.http.get(url).then(function (response) {
	          resolve(response.body);
	        }, function (err) {
	          reject(err);
	        });
	      });
	    }
	  }, {
	    key: 'fetchCouponAmount',
	    value: function fetchCouponAmount(coupon, product) {
	      var _this8 = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        var url = _this8.serviceURL + '/coupon-amount/' + coupon + '?product=' + product;
	        _vue2.default.http.get(url).then(function (response) {
	          resolve(response.body);
	        }, function (err) {
	          reject(err);
	        });
	      });
	    }
	  }, {
	    key: 'checkout',
	    value: function checkout(sessionId, params) {
	      var _this9 = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        var url = _this9.serviceURL + '/checkout/' + sessionId;
	        _vue2.default.http.post(url, params).then(function (response) {
	          resolve(response.body);
	        }, function (err) {
	          reject(err);
	        });
	      });
	    }
	  }, {
	    key: 'checkoutFriendURL',
	    value: function checkoutFriendURL(sessionId) {
	      var _this10 = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        var url = _this10.serviceURL + '/checkout-friend-url/' + sessionId;
	        _vue2.default.http.get(url).then(function (response) {
	          resolve(response.body);
	        }, function (err) {
	          reject(err);
	        });
	      });
	    }
	  }, {
	    key: 'checkoutFriend',
	    value: function checkoutFriend(sessionId, cart) {
	      var _this11 = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        var url = _this11.serviceURL + '/checkout-friend/' + sessionId;
	        var body = { cart: cart };
	        _vue2.default.http.post(url, body).then(function (response) {
	          resolve(response.body);
	        }, function (err) {
	          reject(err);
	        });
	      });
	    }
	  }, {
	    key: 'checkoutWire',
	    value: function checkoutWire(sessionId, medium, cart) {
	      var _this12 = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        var url = _this12.serviceURL + '/checkout-wire/' + sessionId;
	        var body = { medium: medium, cart: cart };
	        _vue2.default.http.post(url, body).then(function (response) {
	          resolve(response.body);
	        }, function (err) {
	          reject(err);
	        });
	      });
	    }
	  }, {
	    key: 'confirmFileReview',
	    value: function confirmFileReview(sessionId, sign, filename) {
	      var _this13 = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        var url = _this13.serviceURL + '/confirm/' + sessionId + '/' + sign + '/' + filename;
	        _vue2.default.http.post(url).then(function (response) {
	          resolve(response.body);
	        }, function (err) {
	          reject(err);
	        });
	      });
	    }
	  }, {
	    key: 'convertAsciiDoc',
	    value: function convertAsciiDoc(sessionId, sign, filename) {
	      var _this14 = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        var url = _this14.serviceURL + '/convert/' + sessionId + '/' + sign + '/' + filename;
	        _vue2.default.http.put(url).then(function (response) {
	          resolve(response.body);
	        }, function (err) {
	          reject(err);
	        });
	      });
	    }
	  }, {
	    key: 'convertFileSigned',
	    value: function convertFileSigned(sessionId, sign, targetFileName, file, fileProgressCallback) {
	      return this._storeFile('/convert/' + sessionId + '/' + sign + '/' + targetFileName, file, fileProgressCallback);
	    }
	  }, {
	    key: 'storeFile',
	    value: function storeFile(sessionId, file, fileProgressCallback) {
	      return this._storeFile('/file/' + sessionId, file, fileProgressCallback);
	    }
	  }, {
	    key: '_storeFile',
	    value: function _storeFile(path, file, fileProgressCallback) {
	      var form = new global.FormData();
	
	      try {
	        form.append('Content-Type', file.type || 'application/octet-stream');
	        form.append('file', file);
	      } catch (err) {
	        console.error('Error on file upload: ', err);
	      }
	
	      return new _promise2.default(function (resolve, reject) {
	
	        var xhr = new global.XMLHttpRequest();
	        xhr.timeout = 5 * 60 * 1000;
	
	        if (fileProgressCallback) {
	          xhr.upload.addEventListener('progress', function (e) {
	            fileProgressCallback(file, e);
	          }, false);
	        }
	
	        xhr.onreadystatechange = function () {
	          if (xhr.readyState < 4) {
	            return;
	          }
	          if (xhr.status < 400) {
	            try {
	              var res = JSON.parse(xhr.responseText);
	              resolve(res);
	            } catch (err) {
	              reject(err);
	            }
	          } else {
	            window.alert('ERROR status: ' + xhr.status + '\n' + xhr.responseText);
	            var err = JSON.parse(xhr.responseText);
	            err.status = xhr.status;
	            err.statusText = xhr.statusText;
	            reject(err);
	          }
	        };
	
	        xhr.onerror = function () {
	          reject(JSON.parse(xhr.responseText));
	        };
	
	        xhr.open('POST', ServiceAccess.instance.serviceURL + path, true);
	        xhr.send(form);
	      });
	    }
	  }, {
	    key: 'previewURL',
	    value: function previewURL(sessionId) {
	      return this.serviceURL + '/preview/' + sessionId + '/preview.pdf';
	    }
	  }, {
	    key: 'requestReview',
	    value: function requestReview(sessionId) {
	      var _this15 = this;
	
	      return new _promise2.default(function (resolve, reject) {
	        var url = _this15.serviceURL + '/review/' + sessionId;
	        _vue2.default.http.post(url).then(function (response) {
	          resolve(response.body);
	        }, function (err) {
	          reject(err);
	        });
	      });
	    }
	  }], [{
	    key: 'instance',
	    get: function get() {
	      if (ServiceAccess._instance == null) {
	        ServiceAccess._instance = new ServiceAccess();
	      }
	      return ServiceAccess._instance;
	    }
	  }]);
	  return ServiceAccess;
	}();
	
	exports.default = ServiceAccess;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(72);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(61);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(62);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var State = function () {
	  function State() {
	    (0, _classCallCheck3.default)(this, State);
	  }
	
	  (0, _createClass3.default)(State, null, [{
	    key: 'evalCondition',
	    value: function evalCondition(condition, values, v, qid) {
	
	      var mfrancs_lte = function mfrancs_lte(m, c) {
	        var date = (0, _moment2.default)(m, 'YYYY-MM-DD');
	        var diff = (0, _moment2.default)().diff(date, 'months');
	        return diff + 1 <= c;
	      };
	
	      var jfrancs_lte = function jfrancs_lte(m, c) {
	        var date = (0, _moment2.default)(m, 'YYYY-MM-DD');
	        var diff = (0, _moment2.default)().diff(date, 'days');
	        return diff + 1 <= c;
	      };
	
	      var isFrancophone = function isFrancophone(countryId) {
	        return countryId === 1 || countryId === 3 || countryId === 5;
	      };
	
	      var isFrenchSpeaking = function isFrenchSpeaking(countryId) {
	        return countryId === 6;
	      };
	
	      try {
	        return eval(condition);
	      } catch (err) {
	        console.error('Failure on (question ' + qid + ') condition eval: ' + condition + '\nv: ' + (0, _stringify2.default)(v) + '\nError: ', err);
	      }
	      return false;
	    }
	  }]);
	  return State;
	}();
	
	exports.default = State;

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(649)
	  __webpack_require__(650)
	}
	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(359),
	  /* template */
	  __webpack_require__(730),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-3f10bac4",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 343:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(361),
	  /* template */
	  __webpack_require__(733),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _extends2 = __webpack_require__(389);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _stringify = __webpack_require__(72);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vue = __webpack_require__(344);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(750);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(749);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _App = __webpack_require__(698);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _ravenJs = __webpack_require__(682);
	
	var _ravenJs2 = _interopRequireDefault(_ravenJs);
	
	var _Home = __webpack_require__(713);
	
	var _Home2 = _interopRequireDefault(_Home);
	
	var _Form = __webpack_require__(712);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _Summary = __webpack_require__(721);
	
	var _Summary2 = _interopRequireDefault(_Summary);
	
	var _Review = __webpack_require__(714);
	
	var _Review2 = _interopRequireDefault(_Review);
	
	var _ReviewConfirm = __webpack_require__(715);
	
	var _ReviewConfirm2 = _interopRequireDefault(_ReviewConfirm);
	
	var _Checkout = __webpack_require__(702);
	
	var _Checkout2 = _interopRequireDefault(_Checkout);
	
	var _CheckoutForm = __webpack_require__(703);
	
	var _CheckoutForm2 = _interopRequireDefault(_CheckoutForm);
	
	var _CheckoutPreview = __webpack_require__(708);
	
	var _CheckoutPreview2 = _interopRequireDefault(_CheckoutPreview);
	
	var _CheckoutPayment = __webpack_require__(705);
	
	var _CheckoutPayment2 = _interopRequireDefault(_CheckoutPayment);
	
	var _CheckoutPaymentWhy = __webpack_require__(706);
	
	var _CheckoutPaymentWhy2 = _interopRequireDefault(_CheckoutPaymentWhy);
	
	var _CheckoutPaypal = __webpack_require__(707);
	
	var _CheckoutPaypal2 = _interopRequireDefault(_CheckoutPaypal);
	
	var _CheckoutStripe = __webpack_require__(709);
	
	var _CheckoutStripe2 = _interopRequireDefault(_CheckoutStripe);
	
	var _CheckoutStripeFriend = __webpack_require__(710);
	
	var _CheckoutStripeFriend2 = _interopRequireDefault(_CheckoutStripeFriend);
	
	var _CheckoutMandatExpress = __webpack_require__(704);
	
	var _CheckoutMandatExpress2 = _interopRequireDefault(_CheckoutMandatExpress);
	
	var _CheckoutWesternUnion = __webpack_require__(711);
	
	var _CheckoutWesternUnion2 = _interopRequireDefault(_CheckoutWesternUnion);
	
	var _ScreenAdmin = __webpack_require__(716);
	
	var _ScreenAdmin2 = _interopRequireDefault(_ScreenAdmin);
	
	var _ScreenRefused = __webpack_require__(719);
	
	var _ScreenRefused2 = _interopRequireDefault(_ScreenRefused);
	
	var _ScreenDemandeVisa = __webpack_require__(718);
	
	var _ScreenDemandeVisa2 = _interopRequireDefault(_ScreenDemandeVisa);
	
	var _ScreenAvocat = __webpack_require__(717);
	
	var _ScreenAvocat2 = _interopRequireDefault(_ScreenAvocat);
	
	var _ScreenWeContactYou = __webpack_require__(720);
	
	var _ScreenWeContactYou2 = _interopRequireDefault(_ScreenWeContactYou);
	
	var _vueMaterial = __webpack_require__(748);
	
	var _vueMaterial2 = _interopRequireDefault(_vueMaterial);
	
	__webpack_require__(661);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	console.log('App Version: ' + ("607\n"));
	console.log('Process Env: ' + (0, _stringify2.default)(({"NODE_ENV":"production"})));
	if (({"NODE_ENV":"production"}) && ({"NODE_ENV":"production"})['NODE_ENV'] !== 'development') {
	  console.log('Raven Setup');
	  _ravenJs2.default.config('https://6d3ca8cfaac64042b454b96154128ba5@sentry.io/121211').install();
	}
	
	_vue2.default.use(_vueMaterial2.default);
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vueRouter2.default);
	
	_vue2.default.material.theme.register('default', {
	  primary: 'blue',
	  accent: 'blue',
	  background: 'grey',
	  warn: 'deep-orange'
	});
	
	function guid() {
	  function s4() {
	    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
	  }
	  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
	}
	
	var redirectNewSession = function redirectNewSession(to) {
	  var newSession = guid();
	
	  return '/f/' + newSession;
	};
	var redirectOQTF = function redirectOQTF(to) {
	  if (({"NODE_ENV":"production"}) && ({"NODE_ENV":"production"})['NODE_ENV'] !== 'development') {
	    window.location.href = 'https://app.refusdetitredesejour.fr/f/' + to.params.sessionId + '/start';
	  } else {
	    window.location.href = 'https://staging.app.refusdetitredesejour.fr/f/' + to.params.sessionId + '/start';
	  }
	  return '/f/' + to.params.sessionId + '/start';
	};
	
	var routes = [{ path: '/', redirect: redirectNewSession }, { path: '/f', redirect: redirectNewSession }, { name: 'checkout-stripe-cypher', path: '/p/:sessionId', component: _CheckoutStripe2.default }, { name: 'home', path: '/f/:sessionId', component: _Home2.default }, { name: 'checkout', path: '/f/:sessionId/checkout', component: _Checkout2.default }, { name: 'checkout-form', path: '/f/:sessionId/checkoutform/:cart', component: _CheckoutForm2.default }, { name: 'checkout-preview', path: '/f/:sessionId/preview/:cart', component: _CheckoutPreview2.default }, { name: 'checkout-pay', path: '/f/:sessionId/payment/:cart', component: _CheckoutPayment2.default }, { name: 'checkout-why', path: '/f/:sessionId/payment-why/:medium/:cart', component: _CheckoutPaymentWhy2.default }, { name: 'checkout-stripe', path: '/f/:sessionId/stripe/:cart', component: _CheckoutStripe2.default }, { name: 'checkout-stripe-friend', path: '/f/:sessionId/stripe-friend/:cart', component: _CheckoutStripeFriend2.default }, { name: 'checkout-mandat', path: '/f/:sessionId/mandat-express/:cart', component: _CheckoutMandatExpress2.default }, { name: 'checkout-western', path: '/f/:sessionId/western-union/:cart', component: _CheckoutWesternUnion2.default }, { name: 'checkout-paypal', path: '/f/:sessionId/paypal/:cart', component: _CheckoutPaypal2.default }, { path: '/f/:sessionId/admin', component: _ScreenAdmin2.default }, { path: '/f/:sessionId/ko', component: _ScreenRefused2.default }, { path: '/f/:sessionId/oqtf', redirect: redirectOQTF }, { path: '/f/:sessionId/demande%20visa', component: _ScreenDemandeVisa2.default }, { path: '/f/:sessionId/demande visa', component: _ScreenDemandeVisa2.default }, { path: '/f/:sessionId/contact%20avocat', component: _ScreenAvocat2.default }, { path: '/f/:sessionId/contact avocat', component: _ScreenAvocat2.default }, { path: '/f/:sessionId/wecontact', component: _ScreenWeContactYou2.default }, { path: '/f/:sessionId/parcours%20gracieux', component: _ScreenAvocat2.default }, { path: '/f/:sessionId/parcours gracieux', component: _ScreenAvocat2.default }, { path: '/f/:sessionId/summary', component: _Summary2.default }, { path: '/f/:sessionId/:screenId', component: _Form2.default }, { path: '/s/:sessionId', component: _Summary2.default }, { path: '/review/:sessionId/:sign', component: _Review2.default }, { path: '/confirm/:sessionId/:sign/:filename', component: _ReviewConfirm2.default }];
	
	var router = new _vueRouter2.default({
	  mode: 'history',
	  routes: routes
	});
	
	router.beforeEach(function (to, from, next) {
	  if (window.ga) {
	    var sessionId = to.params.sessionId;
	    var path = to.path.substring(to.path.indexOf(sessionId) + sessionId.length);
	    window.ga('send', 'pageview', '/app' + path);
	  }
	  next(true);
	});
	
	global.navigationBarBus = new _vue2.default();
	
	new _vue2.default((0, _extends3.default)({
	  router: router
	}, _App2.default)).$mount('#app');
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(37);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(61);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(62);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Condition = __webpack_require__(109);
	
	var _Condition2 = _interopRequireDefault(_Condition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Question = function () {
	  function Question(obj) {
	    (0, _classCallCheck3.default)(this, Question);
	
	    this.id = obj.id;
	    this.q = obj.q;
	    this.info = obj.info;
	    this.a = obj.a;
	    this.dependencies = [];
	  }
	
	  (0, _createClass3.default)(Question, [{
	    key: 'checkCondition',
	    value: function checkCondition(v, values) {
	      if (this.a) {
	        if (this.a.condition != null) {
	          return _Condition2.default.evalCondition(this.a.condition, values, v);
	        }
	
	        if (this.a.min != null) {
	          if (this.a.type === 'text' && v != null) {
	            if (v.length < parseInt(this.a.min)) {
	              return false;
	            }
	          }
	
	          if (this.a.type === 'array' && v != null) {
	
	            if (this.a.min > 1 && v.length < parseInt(this.a.min)) {
	              return false;
	            }
	          }
	
	          if (v == null) {
	            return false;
	          }
	        }
	
	        if (this.a.max != null) {
	
	          if (this.a.type === 'array' && v != null) {
	            if (v.length > parseInt(this.a.max)) {
	              return false;
	            }
	          }
	
	          if (this.a.type === 'date' && this.a.max === 'today') {
	            if ((0, _moment2.default)().diff((0, _moment2.default)(v, 'YYYY-MM-DD')) < 0) {
	              return false;
	            }
	          }
	        }
	      }
	
	      return true;
	    }
	  }, {
	    key: 'array',
	    value: function array(values) {
	      if (this.a.type === 'array' || this.a.type === 'arraycomplete') {
	        if ('values' in this.a) {
	          if (this.a.values.length > 0) {
	            var array = this.a.values.map(function (v) {
	              if ('v' in v) {
	                return v.v;
	              } else {
	                return v;
	              }
	            });
	            return array;
	          } else {
	            return this.a.values;
	          }
	        } else if ('conditions' in this.a) {
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = (0, _getIterator3.default)(this.a.conditions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var c = _step.value;
	
	              if (_Condition2.default.evalCondition(c.condition, values, values[this.id])) {
	                return c.values;
	              }
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	        }
	      }
	      return null;
	    }
	  }, {
	    key: 'hasFile',
	    value: function hasFile() {
	      return 'file' in this.a || 'files' in this.a;
	    }
	  }, {
	    key: 'files',
	    value: function files(values) {
	      var files = void 0;
	      if ('file' in this.a) {
	        if (this.a.type === 'boolean' && values[this.id]) {
	          this.a.file.id = this.id;
	          files = [this.a.file];
	        } else {
	          files = [this.a.file];
	        }
	      } else if ('files' in this.a) {
	        for (var i = 0; i < this.a.files.length; i++) {
	          this.a.files[i].id = this.id + '_' + i;
	        }
	        files = this.a.files;
	      } else {
	        files = [];
	      }
	
	      var v = values[this.id];
	      var filtered = files.filter(function (f) {
	        return 'condition' in f ? _Condition2.default.evalCondition(f.condition, values, v) : true;
	      });
	      return filtered;
	    }
	  }, {
	    key: 'checkFileCondition',
	    value: function checkFileCondition(values) {
	      if (this.hasFile()) {
	        if ('condition' in this.a.file) {
	          var v = values[this.id];
	          return _Condition2.default.evalCondition(this.a.file.condition, values, v);
	        } else {
	          return true;
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'dependsOn',
	    value: function dependsOn(qid) {
	      if (this.a) {
	        if (this.a.condition != null && this.a.condition.indexOf(qid) >= 0) {
	          return true;
	        }
	        if (this.a.conditions != null) {
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = (0, _getIterator3.default)(this.a.conditions), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var c = _step2.value;
	
	              if (c.condition != null && c.condition.indexOf(qid) >= 0) {
	                return true;
	              }
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	        }
	      }
	      return false;
	    }
	  }, {
	    key: 'addDependency',
	    value: function addDependency(qid) {
	      this.dependencies.push(qid);
	    }
	  }]);
	  return Question;
	}();
	
	exports.default = Question;

/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(15);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _promise = __webpack_require__(14);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _getIterator2 = __webpack_require__(37);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(61);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(62);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _State = __webpack_require__(354);
	
	var _State2 = _interopRequireDefault(_State);
	
	var _Condition = __webpack_require__(109);
	
	var _Condition2 = _interopRequireDefault(_Condition);
	
	var _ServiceAccess = __webpack_require__(10);
	
	var _ServiceAccess2 = _interopRequireDefault(_ServiceAccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Screen = function () {
	  function Screen(obj) {
	    (0, _classCallCheck3.default)(this, Screen);
	
	    this.id = obj.id;
	    this.entryPoint = obj['entry-point'];
	    this.entryPoints = obj['entry-points'];
	    this.states = {};
	    this.leave = obj['leave'];
	
	    if (obj.states) {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(obj.states), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var s = _step.value;
	
	          var state = new _State2.default(s);
	          this.states[state.id] = state;
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }
	
	  (0, _createClass3.default)(Screen, [{
	    key: 'leaveCall',
	    value: function leaveCall(call, sessionId) {
	      var requestReview = function requestReview() {
	        return _ServiceAccess2.default.instance.requestReview(sessionId);
	      };
	
	      return eval(call);
	    }
	  }, {
	    key: 'onLeave',
	    value: function onLeave(values, sessionId) {
	      var promises = [];
	      if (this.leave) {
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = (0, _getIterator3.default)(this.leave), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var l = _step2.value;
	
	            if (_Condition2.default.evalCondition(l.condition, values)) {
	              var promise = this.leaveCall(l.call, sessionId);
	              if (promise instanceof _promise2.default) {
	                promises.push(promise);
	              }
	            }
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	      }
	      return _promise2.default.all(promises);
	    }
	  }, {
	    key: 'entryState',
	    value: function entryState(values) {
	      var nextStateId = null;
	      var nextScreenId = null;
	
	      if (this.entryPoint) {
	        nextStateId = this.entryPoint;
	      } else if (this.entryPoints) {
	        if (!(this.entryPoints instanceof Array)) {
	          console.error('EntryPoints are not array - maybe you meant entryPoint (without s) for single entry');
	        }
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	          for (var _iterator3 = (0, _getIterator3.default)(this.entryPoints), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var ep = _step3.value;
	
	            if (ep.condition != null) {
	              if (_Condition2.default.evalCondition(ep.condition, values)) {
	                if ('target' in ep) {
	                  nextStateId = ep.target;
	                } else if ('target-screen' in ep) {
	                  nextScreenId = ep['target-screen'];
	                }
	                break;
	              }
	            } else {
	              if ('target' in ep) {
	                nextStateId = ep.target;
	              } else if ('target-screen' in ep) {
	                nextScreenId = ep['target-screen'];
	              }
	              break;
	            }
	          }
	        } catch (err) {
	          _didIteratorError3 = true;
	          _iteratorError3 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	              _iterator3.return();
	            }
	          } finally {
	            if (_didIteratorError3) {
	              throw _iteratorError3;
	            }
	          }
	        }
	      }
	      return [nextStateId, nextScreenId];
	    }
	  }, {
	    key: 'statePath',
	    value: function statePath(values) {
	      var _entryState = this.entryState(values),
	          _entryState2 = (0, _slicedToArray3.default)(_entryState, 2),
	          stateId = _entryState2[0],
	          screenId = _entryState2[1];
	
	      if (stateId == null || screenId) {
	        return [null, screenId];
	      }
	
	      var state = this.states[stateId];
	      var statePath = [state];
	      var transitionToScreenId = null;
	
	      while (true) {
	        var v = values[state.qid];
	
	        var _state$nextStateIdAnd = state.nextStateIdAndScreenId(v, values),
	            _state$nextStateIdAnd2 = (0, _slicedToArray3.default)(_state$nextStateIdAnd, 2),
	            nextStateId = _state$nextStateIdAnd2[0],
	            nextScreenId = _state$nextStateIdAnd2[1];
	
	        if (nextScreenId != null) {
	          transitionToScreenId = nextScreenId;
	          break;
	        } else if (nextStateId != null) {
	          var nextState = this.states[nextStateId];
	          statePath.push(nextState);
	          state = nextState;
	        } else {
	          break;
	        }
	      }
	
	      return [statePath, transitionToScreenId];
	    }
	  }]);
	  return Screen;
	}();
	
	exports.default = Screen;

/***/ }),

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(15);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _getIterator2 = __webpack_require__(37);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(61);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(62);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Screen = __webpack_require__(352);
	
	var _Screen2 = _interopRequireDefault(_Screen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Screens = function () {
	  function Screens(array) {
	    (0, _classCallCheck3.default)(this, Screens);
	
	
	    this.entryScreenId = array[0].id;
	
	    this.screens = {};
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = (0, _getIterator3.default)(array), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var screen = _step.value;
	
	        this.screens[screen.id] = new _Screen2.default(screen);
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator.return) {
	          _iterator.return();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	  }
	
	  (0, _createClass3.default)(Screens, [{
	    key: 'screen',
	    value: function screen(screenId) {
	      if (screenId) {
	        return this.screens[screenId];
	      } else {
	        return this.screens[this.entryScreenId];
	      }
	    }
	  }, {
	    key: 'lastestScreenId',
	    value: function lastestScreenId(values, entryScreenId) {
	      var screen = this.screen(entryScreenId);
	
	      while (screen) {
	        var _screen$entryState = screen.entryState(values),
	            _screen$entryState2 = (0, _slicedToArray3.default)(_screen$entryState, 2),
	            stateId = _screen$entryState2[0],
	            screenId = _screen$entryState2[1];
	
	        if (screenId) {
	          screen = this.screen(screenId);
	          if (!screen) {
	            return screenId;
	          }
	        }
	
	        while (stateId) {
	          var state = screen.states[stateId];
	          var v = values[state.qid];
	
	          var _state$nextStateIdAnd = state.nextStateIdAndScreenId(v, values),
	              _state$nextStateIdAnd2 = (0, _slicedToArray3.default)(_state$nextStateIdAnd, 2),
	              nextStateId = _state$nextStateIdAnd2[0],
	              nextScreenId = _state$nextStateIdAnd2[1];
	
	          stateId = nextStateId;
	          if (stateId == null) {
	            if (nextScreenId) {
	              screen = this.screen(nextScreenId);
	              if (!screen) {
	                return nextScreenId;
	              }
	            } else {
	              return screen.id;
	            }
	          }
	        }
	      }
	
	      return screen.id;
	    }
	  }, {
	    key: 'screenPath',
	    value: function screenPath(values, entryScreenId) {
	      var screenPath = [];
	
	      var screen = this.screen(entryScreenId);
	      while (screen) {
	        var _screen$entryState3 = screen.entryState(values),
	            _screen$entryState4 = (0, _slicedToArray3.default)(_screen$entryState3, 2),
	            stateId = _screen$entryState4[0],
	            screenId = _screen$entryState4[1];
	
	        if (screenId) {
	          screen = this.screen(screenId);
	          if (screen == null) {
	            break;
	          }
	        } else {
	          screenPath.push(screen);
	        }
	
	        while (stateId) {
	          var state = screen.states[stateId];
	          var v = values[state.qid];
	
	          var _state$nextStateIdAnd3 = state.nextStateIdAndScreenId(v, values),
	              _state$nextStateIdAnd4 = (0, _slicedToArray3.default)(_state$nextStateIdAnd3, 2),
	              nextStateId = _state$nextStateIdAnd4[0],
	              nextScreenId = _state$nextStateIdAnd4[1];
	
	          stateId = nextStateId;
	          if (stateId == null) {
	            screen = nextScreenId != null ? this.screen(nextScreenId) : null;
	          }
	        }
	      }
	      return screenPath;
	    }
	  }]);
	  return Screens;
	}();
	
	exports.default = Screens;

/***/ }),

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(37);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _classCallCheck2 = __webpack_require__(61);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(62);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Condition = __webpack_require__(109);
	
	var _Condition2 = _interopRequireDefault(_Condition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var State = function () {
	  function State(obj) {
	    (0, _classCallCheck3.default)(this, State);
	
	    this.id = obj.id;
	    this.qid = obj.qid;
	    this.transitions = obj.transitions;
	    this.target = obj.target;
	    this.targetScreen = obj['target-screen'];
	  }
	
	  (0, _createClass3.default)(State, [{
	    key: 'nextStateIdAndScreenId',
	    value: function nextStateIdAndScreenId(v, values) {
	
	      if (this.target != null) {
	        return [this.target, null];
	      }
	      if (this.targetScreen != null) {
	        return [null, this.targetScreen];
	      }
	
	      var nextStateId = null;
	      var nextScreenId = null;
	
	      if (this.transitions == null) {
	        return [null, null];
	      }
	      if (v == null && this.transitions.length > 0) {
	        return [null, null];
	      }
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(this.transitions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var transistion = _step.value;
	
	          if (transistion.condition != null) {
	
	            if (v != null && _Condition2.default.evalCondition(transistion.condition, values, v)) {
	              if ('target' in transistion) {
	                nextStateId = transistion.target;
	              } else if ('target-screen' in transistion) {
	                nextScreenId = transistion['target-screen'];
	              }
	              break;
	            }
	          } else {
	            if ('target' in transistion) {
	              nextStateId = transistion.target;
	            } else if ('target-screen' in transistion) {
	              nextScreenId = transistion['target-screen'];
	            }
	            break;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return [nextStateId, nextScreenId];
	    }
	  }]);
	  return State;
	}();
	
	exports.default = State;

/***/ }),

/***/ 355:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = { "default": { "error-messages": { "date": { "fr": "Date incorrect", "cn": "日期不正确", "en": "incorrect date" } } }, "questions": [{ "id": "id_user_civilite", "q": { "fr": "Civilité", "cn": "性别", "en": "civility" }, "a": { "type": "array", "display": "radio", "min": 1, "max": 1, "values": [{ "fr": "Monsieur", "cn": "先生", "en": "Mister" }, { "fr": "Madame", "cn": "女士", "en": "Madam" }] } }, { "id": "id_user_prenom", "q": { "fr": "Prénom", "cn": "名", "en": "First name" }, "a": { "type": "text", "min": 1, "error-message": { "fr": "Prénom requis", "cn": "取得的名字", "en": "First name required" } } }, { "id": "id_user_nom", "q": { "fr": "Nom", "cn": "姓", "en": "Last name" }, "a": { "type": "text", "min": 1, "error-message": { "fr": "Nom requis", "cn": "取得的姓", "en": "Last name required" } } }, { "id": "id_user_birthdate", "q": { "fr": "Date de naissance", "cn": "出生日期", "en": "Date of birth" }, "a": { "type": "date", "max": "today" } }, { "id": "id_user_birthplace", "q": { "fr": "Ville de naissance", "cn": "出生城市", "en": "Place of birth" }, "a": { "type": "text", "min": 1, "error-message": { "fr": "Lieu de naissance requis", "cn": "取得的出生地", "en": "Place of birth required" } } }, { "id": "id_user_nationality", "q": { "fr": "Nationalité", "cn": "国籍", "en": "Nationality" }, "a": { "type": "text", "min": 1, "error-message": { "fr": "Nationalité requise", "cn": "取得的国籍", "en": "Nationality required" }, "placeholder": "Chinoise" } }, { "id": "id_user_city", "q": { "fr": "Ville de résidence", "cn": "居住地", "en": "Place of residence" }, "info": { "fr": "La ville dans laquelle vous vivez plus de 3 mois dans l'année", "cn": "您所居住超过3个月的城市", "en": "The town where you live more than 3 months during the year" }, "a": { "type": "text", "min": 1, "error-message": { "fr": "Ville requise", "cn": "取得城市", "en": "Town required" }, "placeholder": "Shanghai" } }, { "id": "id_user_adress_street", "q": { "fr": "Adresse", "cn": "地址", "en": "Address" }, "a": { "type": "text", "min": 1, "error-message": { "fr": "Adresse requise", "cn": "取得的地址", "en": "Adress required" }, "placeholder": "350 rue de la paix" } }, { "id": "id_user_adress_city", "q": { "fr": "Ville", "cn": "城市", "en": "Town" }, "a": { "type": "text", "min": 1, "error-message": { "fr": "Ville requise", "cn": "取得城市", "en": "Town required" }, "placeholder": "Alger" } }, { "id": "id_user_adress_zip", "q": { "fr": "Code postal", "cn": "邮编", "en": "Postal code" }, "a": { "type": "text", "min": 1, "error-message": { "fr": "Code postal requis", "cn": "所取得的邮编", "en": "Postal code required" }, "placeholder": "78210" } }, { "id": "id_user_adress_country", "q": { "fr": "Pays", "cn": "国家", "en": "Country" }, "a": { "type": "text", "min": 1, "error-message": { "fr": "Code postal requis", "cn": "所取得的邮编" }, "placeholder": "San Sebastian" } }, { "id": "id_user_phnum", "q": { "fr": "Numéro de téléphone (format international)", "cn": "电话号码（国籍格式）", "en": "Phone number (international format)" }, "a": { "type": "text", "min": 1, "error-message": { "fr": "Numéro de téléphone requis", "cn": "取得的电话号码", "en": "Phone number required" }, "placeholder": "+86 2163575555" } }, { "id": "id_user_mail", "q": { "fr": "Email", "cn": "电子邮件", "en": "Email" }, "a": { "type": "text", "min": 1, "error-message": { "fr": "Email requis", "cn": "取得的电子邮件", "en": "Email required" } } }, { "id": "id_user_mail_verification", "q": { "fr": "Email (pour vérification)", "cn": "电子邮件（为确认）", "en": "Email (verification)" }, "a": { "type": "text", "condition": "v == values.id_user_mail", "error-message": { "fr": "Email ne correspond pas avec le précédent", "cn": "您所输入的电子邮件与之前的不相符", "en": "Email is not the same than the previous one" } } }, { "id": "id_why_no_cb", "q": { "fr": "Nous souhaitons améliorer les moyens de paiement et nous avons besoin de votre avis :<br>Pourquoi n'avez vous pas choisi le paiement par carte Visa ou MasterCard&nbsp;?", "cn": "我们想提高支付方式", "en": "We would like to improve the means of payment and we need your opinion :<br>Why did you refuse the MasterCard or Visa payment&nbsp;?" }, "a": { "type": "array", "min": 1, "values": [{ "fr": "Je n'ai pas de carte de paiement", "cn": "我没有银行卡", "en": "I do not have credit card" }, { "fr": "Je n'ai pas suffisamment d'argent sur mon compte mais j'ai du cash", "cn": "我银行账户里没有足够的前但是我有现金", "en": "I do not have enough money on my bank account but I have some cash" }, { "fr": "Ma carte ou ma banque ne m'autorise pas le paiement en Euros", "cn": "我的卡或者我的银行没有给予我支付欧元的权利", "en": "My card or my bank do not allow me to pay in euro" }, { "fr": "J'ai une carte mais je préfére utiliser un autre moyen de paiement", "cn": "我有一张银行卡但是我更偏向于其他的付款方式", "en": "I have a credit card but I prefer to use another payment means" }, { "fr": "Autre", "cn": "其他", "en": "Other" }] } }, { "id": "id_visa", "q": { "fr": "Avez-vous déjà demandé un visa pour la France&nbsp;?", "cn": "您是否已经申请过法国签证&nbsp;?", "en": "Have you already ask for a visa for France&nbsp;?" }, "info": { "fr": "Avez-vous fait une demande de visa auprès du Consulat de France de votre pays de résidence&nbsp;?", "cn": "您是否已经在您所在国家的法国使馆申请过法国签证&nbsp;?", "en": "Have you already done a visa demand at the French consulat in your residence country&nbsp;?" }, "a": { "type": "boolean", "max": 1 } }, { "id": "id_visa_really", "q": { "fr": "Souhaitez-vous que nous vous assistions dans la préparation du dossier de demande de visa&nbsp;?", "cn": "您是否已经申请过法国签证&nbsp;?", "en": "Do you need help for a new visa application with our experts&nbsp;?" }, "info": { "fr": "Si vous n'avez démandé aucun visa, nous pouvons vous aider à faire votre demande&nbsp;", "cn": "您是否已经在您所在国家的法国使馆申请过法国签证&nbsp;?", "en": "If you have not done a visa application yet, we can help you to prepare your visa application&nbsp. If you have done a visa application, please select no." }, "a": { "type": "boolean", "max": 1 } }, { "id": "id_tiers", "q": { "fr": "A qui le visa a été refusé&nbsp;?", "cn": "谁的签证被拒绝了&nbsp;?", "en": "Who is the one the visa was refused" }, "a": { "type": "array", "display": "radio", "max": 1, "values": [{ "fr": "À moi", "cn": "我的", "en": "To me" }, { "fr": "À un de mes proches", "cn": "我的亲友之一", "en": "To one of my relative" }, { "fr": "Aucune demande de visa n'a été faite", "cn": null, "en": "No visa application has been done" }] } }, { "id": "id_compris", "q": { "fr": "Attention, vous devez remplir ce questionnaire en vous mettant à la place de la personne que vous aidez. Avez-vous compris&nbsp;?", "cn": "请注意，您需要站在您帮助的朋友的角度上来完成这份表格的填写,您是否明白&nbsp;?", "en": "Be careful, you have to fulfilf the document as if you were the one you want to help.Do you understand&nbsp;?" }, "info": { "fr": "Par exemple : vivez-vous en France&nbsp;? normalement non, sinon vous ne demanderiez pas un visa.", "cn": "举例说明：您是否在法国生活&nbsp;?正常情况不是，否则您不应该申请签证。", "en": "For example: Do you live in France&nbsp;? normaly no, otherwise you would not ask for a visa" }, "a": { "type": "check", "value": { "fr": "Oui, j'ai compris", "cn": "是的，我明白了。", "en": "Yes, understood" } } }, { "id": "id_visa_refus", "q": { "fr": "Votre demande de visa est-elle <u>refusée</u>&nbsp;?", "cn": "您的签证申请是否被拒<u>被拒</u>&nbsp;?", "en": "has your visa demand <u>been rejected</u>&nbsp;?" }, "info": { "fr": "Votre demande de visa est rejetée en cas de lettre du Consulat précisant le refus ou de non réponse pendant 2 mois.", "cn": "您收到写着明确的拒签理由的使馆拒签信，或者是在两个月之内没有消息。", "en": "Your visa demand has been rejected when you receive a letter from the Consulate with the refusal mention or when you do not have an answer within 2 months" }, "a": { "type": "boolean", "max": 1 } }, { "id": "id_visa_refus_confirmation", "q": { "fr": "Pouvez-vous nous confirmer que la demande de visa <u>est bien refusée</u>&nbsp;?", "cn": "请您和我们确认您的签证是否被拒<u>确实被拒</u>&nbsp;?", "en": "Could you confirm that your visa demand <u>has been rejected</u>&nbsp;?" }, "info": { "fr": "Votre demande de visa est rejetée en cas de lettre du Consulat précisant le refus ou de non réponse pendant 2 mois.", "cn": "您收到写着明确的拒签理由的使馆拒签信，或者是在两个月之内没有消息。", "en": "Your visa demand is rejected when you receive a letter from the Consulate with the refusal mnetion or when you do not have an answer within 2 months" }, "a": { "type": "boolean", "max": 1 } }, { "id": "id_crrv", "q": { "fr": "Avez-vous déjà contesté cette décision&nbsp;?", "cn": "您是否已经对此要求提出上诉&nbsp;?", "en": "Have you already challenged this decision&nbsp;?" }, "info": { "fr": "Avez-vous déposé un recours pour ce dernier refus de visa&nbsp;?", "cn": "您是否已经针对此次被拒提交了上诉申请&nbsp;?", "en": "Have you already filed an appeal for this last visa refusal&nbsp;?" }, "a": { "type": "boolean", "max": 1 } }, { "id": "id_crrv_type_recours", "q": { "fr": "Auprès de qui avez-vous déjà déposé un recours&nbsp;?", "cn": "您的上诉申请提交到了哪里&nbsp;?", "en": "Where did you fil the appeal?" }, "info": { "fr": "Avez-vous déposé un recours auprès de la Commission de Recours contre les Refus de Visa (CRRV)&nbsp;? Si oui, nous allons alors vous accompagner dans le recours auprès du Tribunal Administratif de Nantes.", "cn": "你是否已经向拒签管理中心提交了上诉申请（CRRV）&nbsp;?如果是，我们会在南特的行政管理法院陪同您出席", "en": "Did you file you appeal at the Commission that take care of visa refusal (CRRV)&nbsp; ? If yes, we are going to help for the appeal at the administrative court of Nantes" }, "a": { "type": "array", "min": 1, "values": [{ "fr": "auprès du Consulat de France", "cn": "在法国大使馆", "en": "at the french Consulate" }, { "fr": "auprès de la Commission de Recours contre les Refus de Visa (CRRV)", "cn": "在拒签管理中心", "en": "at the appeal Commission against visa refusal (CRRV)" }, { "fr": "auprès du Tribunal administratif de Nantes", "cn": "在南特新政管理法院", "en": "at the administrative court of Nantes" }], "files": [{ "condition": "v.includes(1)", "label": { "fr": "Accusé de réception de votre recours auprès de la CRRV", "cn": "被拒签证管理中心收到了您的上诉", "en": "Acknowledgment of receipt of your appeal to the CRRV" } }, { "condition": "v.includes(2)", "label": { "fr": "Accusé de réception de votre recours auprès du Tribunal administratif de Nantes", "cn": "南特的行政管理法院收到了您的上诉申请", "en": "Acknowledgement of receipt of your appeal at the administrative court of Nantes" } }] } }, { "id": "id_when_crrv", "q": { "fr": "Quand avez-vous déposé votre dernier recours&nbsp;?", "cn": "您上一次何时提交的上诉申请&nbsp;?", "en": "When did you file your last appeal&nbsp;?" }, "info": { "fr": "Vous avez 2 mois francs pour contester la décision de la CRRV auprès du Tribunal administratif de Nantes.", "cn": "您有两个月的时间在南特行政管理法院来对拒签管理中心的决定提出上诉", "en": "You have two months to contest the CRRV decision to the administrative court of Nantes." }, "a": { "type": "date", "max": "today" } }, { "id": "id_courrier_crrv", "q": { "fr": "Avez-vous reçu un courrier vous informant du refus de <u>votre recours</u>&nbsp;?", "cn": "您是否已经收到明确通知您签证被拒的信件<u>您的上诉</u>&nbsp;?", "en": "Did you receive a mail about the refusal of <u>your appeal</u>&nbsp;?" }, "info": { "fr": "Il s'agit d'un courrier avec accusé de réception de la CRRV ou Tribunal administratif de Nantes", "cn": "可能是拒签管理中心CRRV或者是南特行政管理法院的回执", "en": "It's a mail with acknowledgment of receipt from the CRRV or administrative court of Nantes" }, "a": { "type": "boolean", "max": 1 } }, { "id": "id_when_refus_crrv", "q": { "fr": "Quand avez-vous reçu ce courrier&nbsp;?", "cn": "您何时收到的信件&nbsp;?", "en": "When did you receive this mail&nbsp;?" }, "info": { "fr": "Il s'agit de la date de l'accusé de réception ou de la date de remise en main propre", "cn": "可能是收到回执的日期或者是亲自上交的日期", "en": "It coresponds to the date of the acknowledgment of receipt or the date of the date when the letter has been directly handed to you" }, "a": { "type": "date", "max": "today", "file": { "label": { "fr": "Courrier de l'administration vous informant du refus de votre recours", "cn": "通知您签证被拒的官方信件", "en": "Mail from the administration notifying you the refusal of your appeal" } } } }, { "id": "id_user_country", "q": { "fr": "De quel pays êtes-vous ressortissant&nbsp;?", "cn": "您是哪国的居民&nbsp;?", "en": "From which country are you national&nbsp;?" }, "info": { "fr": "Indiquez votre nationalité", "cn": "请注明您的国籍", "en": "Indicate your nationality" }, "a": { "type": "array", "min": 1, "max": 1, "error-message": { "fr": "Selectionnez votre pays dans la liste", "cn": "从列表中选择您的国家", "en": "Select your country in the list" }, "values": [{ "fr": "Afghanistan", "en": "Afghanistan", "cn": "阿富汗" }, { "fr": "Afrique du Sud", "en": "South Africa", "cn": "南非" }, { "fr": "Albanie", "en": "Albania", "cn": "阿尔巴尼亚" }, { "fr": "Algérie", "en": "Algeria", "cn": "阿尔及利亚" }, { "fr": "Allemagne", "en": "Germany", "cn": "德国" }, { "fr": "Andorre", "en": "Andorra", "cn": "安道尔" }, { "fr": "Angola", "en": "Angola", "cn": "安哥拉" }, { "fr": "Arabie saoudite", "en": "Saudi Arabia", "cn": "沙特阿拉伯" }, { "fr": "Argentine", "en": "Argentina", "cn": "阿根廷" }, { "fr": "Arménie", "en": "Armenia", "cn": "亚美尼亚" }, { "fr": "Australie", "en": "Australia", "cn": "澳大利亚" }, { "fr": "Autriche", "en": "Austria", "cn": "奥地利" }, { "fr": "Azerbaïdjan", "en": "Azerbaijan", "cn": "阿塞拜疆" }, { "fr": "Bahreïn", "en": "Bahrain", "cn": "巴林" }, { "fr": "Bangladesh", "en": "Bangladesh", "cn": "孟加拉国" }, { "fr": "Belgique", "en": "Belgium", "cn": "比利时" }, { "fr": "Bénin", "en": "Benin", "cn": "贝宁" }, { "fr": "Biélorussie", "en": "Belarus", "cn": "白俄罗斯" }, { "fr": "Birmanie", "en": "Burma", "cn": "缅甸" }, { "fr": "Bolivie", "en": "Bolivia", "cn": "玻利维亚" }, { "fr": "Bosnie-Herzégovine", "en": "Bosnia and Herzegovina", "cn": "波斯尼亚和黑塞哥维那" }, { "fr": "Botswana", "en": "Botswana", "cn": "博茨瓦纳" }, { "fr": "Brésil", "en": "Brazil", "cn": "巴西" }, { "fr": "Brunei", "en": "Brunei", "cn": "文莱" }, { "fr": "Bulgarie", "en": "Bulgaria", "cn": "保加利亚" }, { "fr": "Burkina Faso", "en": "Burkina Faso", "cn": "布基纳法索" }, { "fr": "Burundi", "en": "Burundi", "cn": "布隆迪" }, { "fr": "Cambodge", "en": "Cambodia", "cn": "柬埔寨" }, { "fr": "Cameroun", "en": "Cameroon", "cn": "喀麦隆" }, { "fr": "Canada", "en": "Canada", "cn": "加拿大" }, { "fr": "Cap-Vert", "en": "Cape Verde", "cn": "佛得角" }, { "fr": "Chili", "en": "Chile", "cn": "智" }, { "fr": "Chine", "en": "China", "cn": "中国" }, { "fr": "Chypre", "en": "Cyprus", "cn": "塞浦路斯" }, { "fr": "Colombie", "en": "British", "cn": "英国" }, { "fr": "Comores", "en": "Comoros", "cn": "科摩罗" }, { "fr": "Corée du Sud", "en": "South Korea", "cn": "韩国" }, { "fr": "Costa Rica", "en": "Costa Rica", "cn": "哥斯达黎加" }, { "fr": "Côte d'Ivoire", "en": "Ivory Coast", "cn": "象牙海岸" }, { "fr": "Croatie", "en": "Croatia", "cn": "克罗地亚" }, { "fr": "Cuba", "en": "Cuba", "cn": "古巴" }, { "fr": "Danemark", "en": "Denmark", "cn": "丹麦" }, { "fr": "Djibouti", "en": "Djibouti", "cn": "吉布提" }, { "fr": "Égypte", "en": "Egypt", "cn": "埃及" }, { "fr": "Émirats arabes unis", "en": "United Arab Emirates", "cn": "阿拉伯联合酋长国" }, { "fr": "Équateur", "en": "Ecuador", "cn": "厄瓜多尔" }, { "fr": "Érythrée", "en": "Eritrea", "cn": "厄立特里亚" }, { "fr": "Espagne", "en": "Spain", "cn": "西班牙" }, { "fr": "Estonie", "en": "Estonia", "cn": "爱沙尼亚" }, { "fr": "États-Unis", "en": "United States", "cn": "美国" }, { "fr": "Éthiopie", "en": "Ethiopia", "cn": "埃塞俄比亚" }, { "fr": "Fidji", "en": "Fiji", "cn": "斐济" }, { "fr": "Finlande", "en": "Finland", "cn": "芬兰" }, { "fr": "Gabon", "en": "Gabon", "cn": "加蓬" }, { "fr": "Géorgie", "en": "Georgia", "cn": "格鲁吉亚" }, { "fr": "Ghana", "en": "Ghana", "cn": "加纳" }, { "fr": "Grèce", "en": "Greece", "cn": "希腊" }, { "fr": "Guatemala", "en": "Guatemala", "cn": "危地马拉" }, { "fr": "Guinée", "en": "Guinea", "cn": "几内亚" }, { "fr": "Guinée équatoriale", "en": "Equatorial Guinea", "cn": "赤道几内亚" }, { "fr": "Guinée-Bissau", "en": "Guinea-Bissau", "cn": "几内亚比绍" }, { "fr": "Haïti", "en": "Haiti", "cn": "海地" }, { "fr": "Honduras", "en": "Honduras", "cn": "洪都拉斯" }, { "fr": "Hongrie", "en": "Hungary", "cn": "匈牙利" }, { "fr": "Inde", "en": "India", "cn": "印度" }, { "fr": "Indonésie", "en": "Indonesia", "cn": "印度尼西亚" }, { "fr": "Irak", "en": "Iraq", "cn": "伊拉克" }, { "fr": "Iran", "en": "Iran", "cn": "伊朗" }, { "fr": "Irlande", "en": "Ireland", "cn": "爱尔兰" }, { "fr": "Islande", "en": "Iceland", "cn": "冰岛" }, { "fr": "Israël", "en": "Israel", "cn": "以色列" }, { "fr": "Italie", "en": "Italy", "cn": "意大利" }, { "fr": "Jamaïque", "en": "Jamaica", "cn": "牙买加" }, { "fr": "Japon", "en": "Japan", "cn": "日本" }, { "fr": "Jérusalem", "en": "Jerusalem", "cn": "耶路撒冷" }, { "fr": "Jordanie", "en": "Jordan", "cn": "乔丹" }, { "fr": "Kazakhstan", "en": "Kazakhstan", "cn": "哈萨克斯坦" }, { "fr": "Kenya", "en": "Kenya", "cn": "肯尼亚" }, { "fr": "Kirghizistan", "en": "Kyrgyzstan", "cn": "吉尔吉斯斯坦" }, { "fr": "Kosovo", "en": "Kosovo", "cn": "科索沃" }, { "fr": "Koweït", "en": "Kuwait", "cn": "科威特" }, { "fr": "Laos", "en": "Laos", "cn": "老挝" }, { "fr": "Lettonie", "en": "Latvia", "cn": "拉脱维亚" }, { "fr": "Liban", "en": "Lebanon", "cn": "黎巴嫩" }, { "fr": "Liberia", "en": "Liberia", "cn": "利比里亚" }, { "fr": "Libye", "en": "Libya", "cn": "利比亚" }, { "fr": "Lituanie", "en": "Lithuania", "cn": "立陶宛" }, { "fr": "Luxembourg", "en": "Luxembourg", "cn": "卢森堡" }, { "fr": "Macédoine", "en": "Macedonia", "cn": "马其顿" }, { "fr": "Madagascar", "en": "Madagascar", "cn": "马达加斯加" }, { "fr": "Malaisie", "en": "Malaysia", "cn": "马来西亚90" }, { "fr": "Mali", "en": "Mali", "cn": "马里" }, { "fr": "Malte", "en": "Malta", "cn": "马耳他" }, { "fr": "Maroc", "en": "Morocco", "cn": "摩洛哥" }, { "fr": "Maurice", "en": "Maurice", "cn": "莫里斯" }, { "fr": "Mauritanie", "en": "Mauritania", "cn": "毛里塔尼亚" }, { "fr": "Mexique", "en": "Mexico", "cn": "墨西哥" }, { "fr": "Moldavie", "en": "Moldova", "cn": "摩尔多瓦" }, { "fr": "Monaco", "en": "Monaco", "cn": "摩纳哥" }, { "fr": "Mongolie", "en": "Mongolia", "cn": "蒙古" }, { "fr": "Monténégro", "en": "Montenegro", "cn": "黑山" }, { "fr": "Mozambique", "en": "Mozambique", "cn": "莫桑比克" }, { "fr": "Namibie", "en": "Namibia", "cn": "纳米比亚" }, { "fr": "Népal", "en": "Nepal", "cn": "尼泊尔" }, { "fr": "Nicaragua", "en": "Nicaragua", "cn": "尼加拉瓜" }, { "fr": "Niger", "en": "Niger", "cn": "尼日尔" }, { "fr": "Nigeria", "en": "Nigeria", "cn": "尼日利亚" }, { "fr": "Norvège", "en": "Norway", "cn": "挪威" }, { "fr": "Nouvelle-Zélande", "en": "New Zealand", "cn": "新西兰" }, { "fr": "Oman", "en": "Oman", "cn": "阿曼" }, { "fr": "Ouganda", "en": "Uganda", "cn": "乌干达" }, { "fr": "Ouzbékistan", "en": "Uzbekistan", "cn": "乌兹别克斯坦" }, { "fr": "Pakistan", "en": "Pakistan", "cn": "巴基斯坦" }, { "fr": "Panama", "en": "Panama", "cn": "巴拿马" }, { "fr": "Papouasie-Nouvelle-Guinée", "en": "Papua New Guinea", "cn": "巴布亚新几内亚" }, { "fr": "Paraguay", "en": "Paraguay", "cn": "巴拉圭" }, { "fr": "Pays-Bas", "en": "Netherlands", "cn": "荷兰" }, { "fr": "Pérou", "en": "Peru", "cn": "秘鲁" }, { "fr": "Philippines", "en": "Philippines", "cn": "菲律宾" }, { "fr": "Pologne", "en": "Poland", "cn": "波兰" }, { "fr": "Portugal", "en": "Portugal", "cn": "葡萄牙" }, { "fr": "Qatar", "en": "Qatar", "cn": "卡塔尔" }, { "fr": "République centrafricaine", "en": "CAR", "cn": "CAR" }, { "fr": "République démocratique du Congo", "en": "DRC", "cn": "刚果（金）" }, { "fr": "République dominicaine", "en": "Dominican Republic", "cn": "多米尼加共和国" }, { "fr": "République du Congo", "en": "Republic of Congo", "cn": "刚果" }, { "fr": "République tchèque", "en": "Czech Republic", "cn": "捷克共和国" }, { "fr": "Roumanie", "en": "Romania", "cn": "罗马尼亚" }, { "fr": "Royaume-Uni", "en": "United Kingdom", "cn": "英国" }, { "fr": "Russie", "en": "Russia", "cn": "俄罗斯" }, { "fr": "Rwanda", "en": "Rwanda", "cn": "卢旺达" }, { "fr": "Sainte-Lucie", "en": "Saint Lucia", "cn": "圣卢西亚" }, { "fr": "Salvador", "en": "Salvador", "cn": "萨尔瓦多" }, { "fr": "Sénégal", "en": "Senegal", "cn": "塞内加尔" }, { "fr": "Serbie", "en": "Serbia", "cn": "塞尔维亚" }, { "fr": "Seychelles", "en": "Seychelles", "cn": "塞舌尔" }, { "fr": "Singapour", "en": "Singapore", "cn": "新加坡" }, { "fr": "Slovaquie", "en": "Slovakia", "cn": "斯洛伐克" }, { "fr": "Slovénie", "en": "Slovenia", "cn": "斯洛文尼亚" }, { "fr": "Soudan", "en": "Sudan", "cn": "苏丹" }, { "fr": "Soudan du Sud", "en": "South Sudan", "cn": "南苏丹" }, { "fr": "Sri Lanka", "en": "Sri Lanka", "cn": "斯里兰卡" }, { "fr": "Suède", "en": "Sweden", "cn": "瑞典" }, { "fr": "Suisse", "en": "Switzerland", "cn": "瑞士" }, { "fr": "Suriname", "en": "Suriname", "cn": "苏里南" }, { "fr": "Syrie", "en": "Syria", "cn": "叙利亚" }, { "fr": "Tadjikistan", "en": "Tajikistan", "cn": "塔吉克斯坦" }, { "fr": "Taïwan", "en": "Taiwan", "cn": "台湾" }, { "fr": "Tanzanie", "en": "Tanzania", "cn": "坦桑尼亚" }, { "fr": "Tchad", "en": "Chad", "cn": "乍得" }, { "fr": "Thaïlande", "en": "Thailand", "cn": "泰国" }, { "fr": "Togo", "en": "Togo", "cn": "多哥" }, { "fr": "Trinité-et-Tobago", "en": "Trinidad and Tobago", "cn": "特立尼达和多巴哥" }, { "fr": "Tunisie", "en": "Tunisia", "cn": "突尼斯" }, { "fr": "Turkménistan", "en": "Turkmenistan", "cn": "土库曼斯坦" }, { "fr": "Turquie", "en": "Turkey", "cn": "土耳其" }, { "fr": "Ukraine", "en": "Ukraine", "cn": "乌克兰" }, { "fr": "Uruguay", "en": "Uruguay", "cn": "乌拉圭" }, { "fr": "Vanuatu", "en": "Vanuatu", "cn": "瓦努阿图" }, { "fr": "Venezuela", "en": "Venezuela", "cn": "委内瑞拉" }, { "fr": "Viêt Nam", "en": "Vietnam", "cn": "越南" }, { "fr": "Yémen", "en": "Yemen", "cn": "也门" }, { "fr": "Zambie", "en": "Zambia", "cn": "赞比亚" }, { "fr": "Zimbabwe", "en": "Zimbabwe", "cn": "津巴布韦" }] } }, { "id": "id_demande_visa", "q": { "fr": "Avez-vous déposé votre demande de visa dans ce pays&nbsp;?", "en": "Did you file the visa demand in this country&bnsp;?", "cn": "您是否已经提交了本国的签证申请&nbsp;?" }, "info": { "fr": "Avez vous déposé votre demande de visa dans un autre pays que celui dont vous êtes ressortissant", "en": "Did you file the visa demand in another country than the one you are national", "cn": "您是否已经向除您本国之外的国家提交过签证申请" }, "a": { "type": "boolean" } }, { "id": "id_user_visacountry", "q": { "fr": "Dans quel pays avez-vous déposé votre demande de visa&nbsp;?", "en": "In which country did you file the visa demand&nbsp;?", "cn": "您向哪国提交过签证申请&nbsp;?" }, "info": { "fr": "Indiquez le pays du Consulat de France de votre demande de visa", "en": "Indicate the country of the french Consulate where you asked for the visa", "cn": "请标明您申请签证的国家" }, "a": { "type": "array", "min": 1, "max": 1, "error-message": { "fr": "Selectionnez votre pays dans la liste", "en": "Select the country in the list", "cn": "请在列表中选择国家" }, "values": [{ "fr": "Afghanistan", "en": "Afghanistan", "cn": "阿富汗" }, { "fr": "Afrique du Sud", "en": "South Africa", "cn": "南非" }, { "fr": "Albanie", "en": "Albania", "cn": "阿尔巴尼亚" }, { "fr": "Algérie", "en": "Algeria", "cn": "阿尔及利亚" }, { "fr": "Allemagne", "en": "Germany", "cn": "德国" }, { "fr": "Andorre", "en": "Andorra", "cn": "安道尔" }, { "fr": "Angola", "en": "Angola", "cn": "安哥拉" }, { "fr": "Arabie saoudite", "en": "Saudi Arabia", "cn": "沙特阿拉伯" }, { "fr": "Argentine", "en": "Argentina", "cn": "阿根廷" }, { "fr": "Arménie", "en": "Armenia", "cn": "亚美尼亚" }, { "fr": "Australie", "en": "Australia", "cn": "澳大利亚" }, { "fr": "Autriche", "en": "Austria", "cn": "奥地利" }, { "fr": "Azerbaïdjan", "en": "Azerbaijan", "cn": "阿塞拜疆" }, { "fr": "Bahreïn", "en": "Bahrain", "cn": "巴林" }, { "fr": "Bangladesh", "en": "Bangladesh", "cn": "孟加拉国" }, { "fr": "Belgique", "en": "Belgium", "cn": "比利时" }, { "fr": "Bénin", "en": "Benin", "cn": "贝宁" }, { "fr": "Biélorussie", "en": "Belarus", "cn": "白俄罗斯" }, { "fr": "Birmanie", "en": "Burma", "cn": "缅甸" }, { "fr": "Bolivie", "en": "Bolivia", "cn": "玻利维亚" }, { "fr": "Bosnie-Herzégovine", "en": "Bosnia and Herzegovina", "cn": "波斯尼亚和黑塞哥维那" }, { "fr": "Botswana", "en": "Botswana", "cn": "博茨瓦纳" }, { "fr": "Brésil", "en": "Brazil", "cn": "巴西" }, { "fr": "Brunei", "en": "Brunei", "cn": "文莱" }, { "fr": "Bulgarie", "en": "Bulgaria", "cn": "保加利亚" }, { "fr": "Burkina Faso", "en": "Burkina Faso", "cn": "布基纳法索" }, { "fr": "Burundi", "en": "Burundi", "cn": "布隆迪" }, { "fr": "Cambodge", "en": "Cambodia", "cn": "柬埔寨" }, { "fr": "Cameroun", "en": "Cameroon", "cn": "喀麦隆" }, { "fr": "Canada", "en": "Canada", "cn": "加拿大" }, { "fr": "Cap-Vert", "en": "Cape Verde", "cn": "佛得角" }, { "fr": "Chili", "en": "Chile", "cn": "智" }, { "fr": "Chine", "en": "China", "cn": "中国" }, { "fr": "Chypre", "en": "Cyprus", "cn": "塞浦路斯" }, { "fr": "Colombie", "en": "British", "cn": "英国" }, { "fr": "Comores", "en": "Comoros", "cn": "科摩罗" }, { "fr": "Corée du Sud", "en": "South Korea", "cn": "韩国" }, { "fr": "Costa Rica", "en": "Costa Rica", "cn": "哥斯达黎加" }, { "fr": "Côte d'Ivoire", "en": "Ivory Coast", "cn": "象牙海岸" }, { "fr": "Croatie", "en": "Croatia", "cn": "克罗地亚" }, { "fr": "Cuba", "en": "Cuba", "cn": "古巴" }, { "fr": "Danemark", "en": "Denmark", "cn": "丹麦" }, { "fr": "Djibouti", "en": "Djibouti", "cn": "吉布提" }, { "fr": "Égypte", "en": "Egypt", "cn": "埃及" }, { "fr": "Émirats arabes unis", "en": "United Arab Emirates", "cn": "阿拉伯联合酋长国" }, { "fr": "Équateur", "en": "Ecuador", "cn": "厄瓜多尔" }, { "fr": "Érythrée", "en": "Eritrea", "cn": "厄立特里亚" }, { "fr": "Espagne", "en": "Spain", "cn": "西班牙" }, { "fr": "Estonie", "en": "Estonia", "cn": "爱沙尼亚" }, { "fr": "États-Unis", "en": "United States", "cn": "美国" }, { "fr": "Éthiopie", "en": "Ethiopia", "cn": "埃塞俄比亚" }, { "fr": "Fidji", "en": "Fiji", "cn": "斐济" }, { "fr": "Finlande", "en": "Finland", "cn": "芬兰" }, { "fr": "Gabon", "en": "Gabon", "cn": "加蓬" }, { "fr": "Géorgie", "en": "Georgia", "cn": "格鲁吉亚" }, { "fr": "Ghana", "en": "Ghana", "cn": "加纳" }, { "fr": "Grèce", "en": "Greece", "cn": "希腊" }, { "fr": "Guatemala", "en": "Guatemala", "cn": "危地马拉" }, { "fr": "Guinée", "en": "Guinea", "cn": "几内亚" }, { "fr": "Guinée équatoriale", "en": "Equatorial Guinea", "cn": "赤道几内亚" }, { "fr": "Guinée-Bissau", "en": "Guinea-Bissau", "cn": "几内亚比绍" }, { "fr": "Haïti", "en": "Haiti", "cn": "海地" }, { "fr": "Honduras", "en": "Honduras", "cn": "洪都拉斯" }, { "fr": "Hongrie", "en": "Hungary", "cn": "匈牙利" }, { "fr": "Inde", "en": "India", "cn": "印度" }, { "fr": "Indonésie", "en": "Indonesia", "cn": "印度尼西亚" }, { "fr": "Irak", "en": "Iraq", "cn": "伊拉克" }, { "fr": "Iran", "en": "Iran", "cn": "伊朗" }, { "fr": "Irlande", "en": "Ireland", "cn": "爱尔兰" }, { "fr": "Islande", "en": "Iceland", "cn": "冰岛" }, { "fr": "Israël", "en": "Israel", "cn": "以色列" }, { "fr": "Italie", "en": "Italy", "cn": "意大利" }, { "fr": "Jamaïque", "en": "Jamaica", "cn": "牙买加" }, { "fr": "Japon", "en": "Japan", "cn": "日本" }, { "fr": "Jérusalem", "en": "Jerusalem", "cn": "耶路撒冷" }, { "fr": "Jordanie", "en": "Jordan", "cn": "乔丹" }, { "fr": "Kazakhstan", "en": "Kazakhstan", "cn": "哈萨克斯坦" }, { "fr": "Kenya", "en": "Kenya", "cn": "肯尼亚" }, { "fr": "Kirghizistan", "en": "Kyrgyzstan", "cn": "吉尔吉斯斯坦" }, { "fr": "Kosovo", "en": "Kosovo", "cn": "科索沃" }, { "fr": "Koweït", "en": "Kuwait", "cn": "科威特" }, { "fr": "Laos", "en": "Laos", "cn": "老挝" }, { "fr": "Lettonie", "en": "Latvia", "cn": "拉脱维亚" }, { "fr": "Liban", "en": "Lebanon", "cn": "黎巴嫩" }, { "fr": "Liberia", "en": "Liberia", "cn": "利比里亚" }, { "fr": "Libye", "en": "Libya", "cn": "利比亚" }, { "fr": "Lituanie", "en": "Lithuania", "cn": "立陶宛" }, { "fr": "Luxembourg", "en": "Luxembourg", "cn": "卢森堡" }, { "fr": "Macédoine", "en": "Macedonia", "cn": "马其顿" }, { "fr": "Madagascar", "en": "Madagascar", "cn": "马达加斯加" }, { "fr": "Malaisie", "en": "Malaysia", "cn": "马来西亚90" }, { "fr": "Mali", "en": "Mali", "cn": "马里" }, { "fr": "Malte", "en": "Malta", "cn": "马耳他" }, { "fr": "Maroc", "en": "Morocco", "cn": "摩洛哥" }, { "fr": "Maurice", "en": "Maurice", "cn": "莫里斯" }, { "fr": "Mauritanie", "en": "Mauritania", "cn": "毛里塔尼亚" }, { "fr": "Mexique", "en": "Mexico", "cn": "墨西哥" }, { "fr": "Moldavie", "en": "Moldova", "cn": "摩尔多瓦" }, { "fr": "Monaco", "en": "Monaco", "cn": "摩纳哥" }, { "fr": "Mongolie", "en": "Mongolia", "cn": "蒙古" }, { "fr": "Monténégro", "en": "Montenegro", "cn": "黑山" }, { "fr": "Mozambique", "en": "Mozambique", "cn": "莫桑比克" }, { "fr": "Namibie", "en": "Namibia", "cn": "纳米比亚" }, { "fr": "Népal", "en": "Nepal", "cn": "尼泊尔" }, { "fr": "Nicaragua", "en": "Nicaragua", "cn": "尼加拉瓜" }, { "fr": "Niger", "en": "Niger", "cn": "尼日尔" }, { "fr": "Nigeria", "en": "Nigeria", "cn": "尼日利亚" }, { "fr": "Norvège", "en": "Norway", "cn": "挪威" }, { "fr": "Nouvelle-Zélande", "en": "New Zealand", "cn": "新西兰" }, { "fr": "Oman", "en": "Oman", "cn": "阿曼" }, { "fr": "Ouganda", "en": "Uganda", "cn": "乌干达" }, { "fr": "Ouzbékistan", "en": "Uzbekistan", "cn": "乌兹别克斯坦" }, { "fr": "Pakistan", "en": "Pakistan", "cn": "巴基斯坦" }, { "fr": "Panama", "en": "Panama", "cn": "巴拿马" }, { "fr": "Papouasie-Nouvelle-Guinée", "en": "Papua New Guinea", "cn": "巴布亚新几内亚" }, { "fr": "Paraguay", "en": "Paraguay", "cn": "巴拉圭" }, { "fr": "Pays-Bas", "en": "Netherlands", "cn": "荷兰" }, { "fr": "Pérou", "en": "Peru", "cn": "秘鲁" }, { "fr": "Philippines", "en": "Philippines", "cn": "菲律宾" }, { "fr": "Pologne", "en": "Poland", "cn": "波兰" }, { "fr": "Portugal", "en": "Portugal", "cn": "葡萄牙" }, { "fr": "Qatar", "en": "Qatar", "cn": "卡塔尔" }, { "fr": "République centrafricaine", "en": "CAR", "cn": "CAR" }, { "fr": "République démocratique du Congo", "en": "DRC", "cn": "刚果（金）" }, { "fr": "République dominicaine", "en": "Dominican Republic", "cn": "多米尼加共和国" }, { "fr": "République du Congo", "en": "Republic of Congo", "cn": "刚果" }, { "fr": "République tchèque", "en": "Czech Republic", "cn": "捷克共和国" }, { "fr": "Roumanie", "en": "Romania", "cn": "罗马尼亚" }, { "fr": "Royaume-Uni", "en": "United Kingdom", "cn": "英国" }, { "fr": "Russie", "en": "Russia", "cn": "俄罗斯" }, { "fr": "Rwanda", "en": "Rwanda", "cn": "卢旺达" }, { "fr": "Sainte-Lucie", "en": "Saint Lucia", "cn": "圣卢西亚" }, { "fr": "Salvador", "en": "Salvador", "cn": "萨尔瓦多" }, { "fr": "Sénégal", "en": "Senegal", "cn": "塞内加尔" }, { "fr": "Serbie", "en": "Serbia", "cn": "塞尔维亚" }, { "fr": "Seychelles", "en": "Seychelles", "cn": "塞舌尔" }, { "fr": "Singapour", "en": "Singapore", "cn": "新加坡" }, { "fr": "Slovaquie", "en": "Slovakia", "cn": "斯洛伐克" }, { "fr": "Slovénie", "en": "Slovenia", "cn": "斯洛文尼亚" }, { "fr": "Soudan", "en": "Sudan", "cn": "苏丹" }, { "fr": "Soudan du Sud", "en": "South Sudan", "cn": "南苏丹" }, { "fr": "Sri Lanka", "en": "Sri Lanka", "cn": "斯里兰卡" }, { "fr": "Suède", "en": "Sweden", "cn": "瑞典" }, { "fr": "Suisse", "en": "Switzerland", "cn": "瑞士" }, { "fr": "Suriname", "en": "Suriname", "cn": "苏里南" }, { "fr": "Syrie", "en": "Syria", "cn": "叙利亚" }, { "fr": "Tadjikistan", "en": "Tajikistan", "cn": "塔吉克斯坦" }, { "fr": "Taïwan", "en": "Taiwan", "cn": "台湾" }, { "fr": "Tanzanie", "en": "Tanzania", "cn": "坦桑尼亚" }, { "fr": "Tchad", "en": "Chad", "cn": "乍得" }, { "fr": "Thaïlande", "en": "Thailand", "cn": "泰国" }, { "fr": "Togo", "en": "Togo", "cn": "多哥" }, { "fr": "Trinité-et-Tobago", "en": "Trinidad and Tobago", "cn": "特立尼达和多巴哥" }, { "fr": "Tunisie", "en": "Tunisia", "cn": "突尼斯" }, { "fr": "Turkménistan", "en": "Turkmenistan", "cn": "土库曼斯坦" }, { "fr": "Turquie", "en": "Turkey", "cn": "土耳其" }, { "fr": "Ukraine", "en": "Ukraine", "cn": "乌克兰" }, { "fr": "Uruguay", "en": "Uruguay", "cn": "乌拉圭" }, { "fr": "Vanuatu", "en": "Vanuatu", "cn": "瓦努阿图" }, { "fr": "Venezuela", "en": "Venezuela", "cn": "委内瑞拉" }, { "fr": "Viêt Nam", "en": "Vietnam", "cn": "越南" }, { "fr": "Yémen", "en": "Yemen", "cn": "也门" }, { "fr": "Zambie", "en": "Zambia", "cn": "赞比亚" }, { "fr": "Zimbabwe", "en": "Zimbabwe", "cn": "津巴布韦" }, { "fr": "France", "en": "France", "cn": "法国" }] } }, { "id": "id_already_here", "q": { "fr": "Vivez-vous actuellement en France&nbsp;?", "en": "do you currently live in France&nbsp;?", "cn": "您目前是否居住在法国&nbsp;?" }, "a": { "type": "boolean" } }, { "id": "id_other_already_here", "q": { "fr": "La personne souhaitant un visa vit-elle actuellement en France&nbsp;?", "en": "Does the person asking for the visa is currently living in France&nbsp;?", "cn": "您目前是否居住在法国&nbsp;?" }, "a": { "type": "boolean" } }, { "id": "id_really_already_here", "q": { "fr": "Le demandeur de visa vit-il vraiment en France&nbsp;?", "en": "Does the person asking for the visa live in France&nbsp;?", "cn": "申请签证的人是否真实生活在法国&nbsp;?" }, "a": { "type": "boolean" } }, { "id": "id_already_france", "q": { "fr": "Avez-vous demandé un titre de séjour pour la France&nbsp;?", "en": "Did you ask for a french residence permit&nbsp;?", "cn": "您是否申请过在法居留证&nbsp;?" }, "a": { "type": "boolean" } }, { "id": "id_regular", "q": { "fr": "Avez-vous demandé une régularisation de votre situation à la préfecture&nbsp;?", "en": "Did you ask for a regularization of your situation at the prefecture&nbsp;?", "cn": "您是否向移民局提交过申请合法婚姻的申请&nbsp;?", "info": { "fr": "En tant que ressortissant étranger présent illégalement sur le territoire français la demande de titre de séjour s'effectue auprès de la préfécture de police de votre Région.", "en": "As a foreign national presents illegaly on the french territory, the residence permit demand has to be done at the police headquaters of your region.", "cn": "作为外国居民，非法在法国国土上逗留，申请居留的程序需要在本地区的移民局来进行" } }, "a": { "type": "boolean" } }, { "id": "id_when_app", "q": { "fr": "Quand avez-vous déposé votre <u>demande de visa</u>&nbsp;?", "en": "When did you file your <u>visa demand</u>&nbsp;?", "cn": "您何时提交的您的<u>签证申请</u>&nbsp;?" }, "info": { "fr": "Il s'agit de la date inscrite sur le reçu de votre demande de visa", "en": "It's the date written on the receipt of your visa demand", "cn": "在您申请签证的收据上可以找到这个日期" }, "a": { "type": "date", "max": "today", "files": [{ "label": { "fr": "Récépissé de votre demande de visa", "en": "Voucher of your visa demand", "cn": "您申请签证所获得的短期居留" } }, { "label": { "fr": "Intégralité du dossier de demande de visa avec pièces jointes du dossier remis au Consulat", "en": "Integrality of your visa demand file with attachments of the file sent to the consulate", "cn": "完整的申请签证材料，里面有上交给法国使馆的完整的材料" } }] } }, { "id": "id_when_refus", "q": { "fr": "Quand avez-vous reçu ce courrier (date de l'accusé de réception ou de la remise en main propre)&nbsp;?", "en": "When did you receive this mail (date of the achnowledgment receipt or when it was directly given to you)&nbsp;?", "cn": "您何时收到的这封邮件（确认收到您的申请的回执或者是亲自上交的日期）&nbsp;?" }, "info": { "fr": "Il s'agit de la date de l'accusé de réception ou de la date de remise en main propre", "en": "It's the date of the achnowledgment receipt or when it was directly given to you", "cn": "可能是您收到回执的日期或者是亲自上门取得这封信件的日期" }, "a": { "type": "date", "max": "today", "error-message": null } }, { "id": "id_courr_refus", "q": { "fr": "Avez-vous reçu un courrier vous informant que votre <u>demande de visa</u> est rejetée&nbsp;?", "en": "Have you received a mail saying that your <u>visa demand</u> was rejected&nbsp;?", "cn": "您是否收到了一封信件通知您 <u>您的签证申请</u>被拒绝了&nbsp;?" }, "a": { "type": "boolean", "file": { "condition": "values['id_courr_refus'] == true", "label": { "fr": "Courrier du Consulat vous informant que votre demande a été rejetée", "en": "Mail from the Consulate saying that your demand was rejected", "cn": "法国领事馆通知您的签证被拒绝了" } } } }, { "id": "id_courr_indiq", "q": { "fr": "Est-ce que ce courrier indique les voies de recours possibles?", "en": "Does the mail indicate possible appeal ways?", "cn": "请问这封信件是否注明有提出上诉的可能性" }, "info": { "fr": "Un champ du type \"Vous pouvez contester cette décision de refus devant la Commission des Recours contre les décisions de Refus de Visa d'entrée en France [...] dans un délai de deux mois\" doit figurer", "en": "A quote like « you can contest this refusal decision in front of the appeal Commission against the entry visa refusal decision in France […] within 2 months”  has to appear", "cn": "您的信件上应该有一栏上写着“您可以在两个月的期限之内，在行政管理法院通过上诉的方式来驳绝关于您入法签证被拒的决定[...]" }, "a": { "type": "boolean" } }, { "id": "id_app_indiq", "q": { "fr": "Est-ce que le récépissé de votre dépôt de demande de visa indique delai de recours&nbsp;?", "en": "Does the recepicy of your Visa demand deposit mention a delay of recours?", "cn": "您在递交签证申请时收到的收据上是否注明了可以上诉的期限&nbsp;?" }, "info": { "fr": "Un champ indiquant \"Vous pouvez contester cette décision de refus [...] dans un délai de deux mois à compter de la date de dépôt\" doit figurer", "en": "A quote saying\" you are able to contest the refusal decision [...] within 2 months after the deposit date\" has to appear", "cn": "应该有一个地方写着“您可以在递签之日起的两个月内对被拒的签证提出上诉" }, "a": { "type": "boolean" } }, { "id": "id_consul", "q": { "fr": "Dans quel consulat ou ambassade avez-vous déposé votre demande de visa&nbsp;?", "en": "In which consulate or embassy did you file your visa demand&nbsp;?", "cn": "您是在哪一个领事馆或者大使馆递交的签证申请&nbsp;?" }, "info": { "fr": "Choisissez une ambassade ou un consulat", "en": "Choose your embassy or consulate", "cn": "请选择一个大使馆或者领事馆" }, "a": { "type": "array", "min": 1, "max": 1, "error-message": { "fr": "Selectionnez une ambassade ou un consulat dans la liste", "en": "Choose an embassy or a consulate in the list", "cn": "请在名单中选择一个大使馆或者领事馆" }, "conditions": [{ "condition": "values.id_user_visacountry == 0", "values": [{ "fr": "Kaboul", "en": "Kabul", "cn": "喀布尔" }] }, { "condition": "values.id_user_visacountry == 1", "values": [{ "fr": "Pretoria", "en": "Pretoria", "cn": "比勒陀利亚" }, { "fr": "Johannesburg", "en": "Johannesburg", "cn": "约翰内斯堡" }, { "fr": "Le Cap", "en": "Cape Town" }], "cn": "开普敦" }, { "condition": "values.id_user_visacountry == 2", "values": [{ "fr": "Tirana", "en": "Tirana", "cn": "地拉那" }] }, { "condition": "values.id_user_visacountry == 3", "values": [{ "fr": "Alger", "en": "Algiers", "cn": "阿尔及尔" }, { "fr": "Annaba", "en": "Annaba", "cn": "安纳巴" }, { "fr": "Oran", "en": "Oran", "cn": "奥兰" }] }, { "condition": "values.id_user_visacountry == 4", "values": [{ "fr": "Berlin", "en": "Berlin", "cn": "柏林" }, { "fr": "Düsseldorf", "en": "Düsseldorf", "cn": "杜塞尔多夫" }, { "fr": "Francfort", "en": "Frankfurt", "cn": "法兰克福" }, { "fr": "Hambourg", "en": "Hamburg", "cn": "汉堡" }, { "fr": "Munich", "en": "Munich", "cn": "慕尼黑" }, { "fr": "Sarrebruck", "en": "Saarbrucken", "cn": "萨尔布吕肯" }, { "fr": "Stuttgart", "en": "Stuttgart", "cn": "斯图加特" }] }, { "condition": "values.id_user_visacountry == 5", "values": [{ "fr": "Andorre-la-Vieille", "en": "Andorra la Vella", "cn": "安道尔城" }] }, { "condition": "values.id_user_visacountry == 6", "values": [{ "fr": "Luanda", "en": "Luanda", "cn": "罗安达" }] }, { "condition": "values.id_user_visacountry == 7", "values": [{ "fr": "Riyad", "en": "Riyadh", "cn": "利雅得" }, { "fr": "Djeddah", "en": "Jeddah", "cn": "吉达" }] }, { "condition": "values.id_user_visacountry == 8", "values": [{ "fr": "Buenos Aires", "en": "Buenos Aires", "cn": "布宜诺斯艾利斯" }] }, { "condition": "values.id_user_visacountry == 9", "values": [{ "fr": "Erevan", "en": "Yerevan", "cn": "埃里温" }] }, { "condition": "values.id_user_visacountry == 10", "values": [{ "fr": "Canberra", "en": "Canberra", "cn": "堪培拉" }, { "fr": "Sydney", "en": "Sydney", "cn": "悉尼" }] }, { "condition": "values.id_user_visacountry == 11", "values": [{ "fr": "Vienne", "en": "Vienna", "cn": "维也纳" }] }, { "condition": "values.id_user_visacountry == 12", "values": [{ "fr": "Bakou", "en": "Baku", "cn": "巴库" }] }, { "condition": "values.id_user_visacountry == 13", "values": [{ "fr": "Manama", "en": "Manama", "cn": "麦纳麦" }] }, { "condition": "values.id_user_visacountry == 14", "values": [{ "fr": "Dacca", "en": "Dhaka", "cn": "达卡" }] }, { "condition": "values.id_user_visacountry == 15", "values": [{ "fr": "Bruxelles", "en": "Brussels", "cn": "布鲁塞尔" }, { "fr": "Anvers", "en": "Antwerp", "cn": "安特卫普" }, { "fr": "Liège", "en": "Liege", "cn": "列日" }, { "fr": "Tournai", "en": "Tournai", "cn": "图尔奈" }, { "fr": "Mouscron", "en": "Mouscron", "cn": "穆斯克龙" }] }, { "condition": "values.id_user_visacountry == 16", "values": [{ "fr": "Cotonou", "en": "Cotonou", "cn": "科托努" }] }, { "condition": "values.id_user_visacountry == 17", "values": [{ "fr": "Minsk", "en": "Minsk", "cn": "明斯克" }] }, { "condition": "values.id_user_visacountry == 18", "values": [{ "fr": "Rangoun", "en": "Rangoon", "cn": "仰光" }] }, { "condition": "values.id_user_visacountry == 19", "values": [{ "fr": "La Paz", "en": "La Paz", "cn": "拉巴斯" }] }, { "condition": "values.id_user_visacountry == 20", "values": [{ "fr": "Sarajevo", "en": "Sarajevo", "cn": "萨拉热窝" }, { "fr": "Banja Luka", "en": "Banja Luka", "cn": "巴尼亚卢卡" }] }, { "condition": "values.id_user_visacountry == 21", "values": [{ "fr": "Gaborone", "en": "Gaborone", "cn": "哈博罗内" }] }, { "condition": "values.id_user_visacountry == 22", "values": [{ "fr": "Brasilia", "en": "Brasilia", "cn": "巴西利亚" }, { "fr": "Recife", "en": "Recife", "cn": "累西腓" }, { "fr": "Rio de Janeiro", "en": "Rio de Janeiro", "cn": "里约热内卢" }, { "fr": "São Paulo", "en": "Sao Paulo", "cn": "圣保罗" }] }, { "condition": "values.id_user_visacountry == 23", "values": [{ "fr": "Bandar Seri Begawan", "en": "Bandar Seri Begawan", "cn": "斯里巴加湾市" }] }, { "condition": "values.id_user_visacountry == 24", "values": [{ "fr": "Sofia", "en": "Sofia", "cn": "苏菲亚" }] }, { "condition": "values.id_user_visacountry == 25", "values": [{ "fr": "Ouagadougou", "en": "Ouagadougou", "cn": "瓦加杜古" }] }, { "condition": "values.id_user_visacountry == 26", "values": [{ "fr": "Bujumbura", "en": "Bujumbura", "cn": "布琼布拉" }] }, { "condition": "values.id_user_visacountry == 27", "values": [{ "fr": "Phnom Penh", "en": "Phnom Penh", "cn": "金边" }] }, { "condition": "values.id_user_visacountry == 28", "values": [{ "fr": "Yaoundé", "en": "Yaounde", "cn": "雅温得" }, { "fr": "Douala", "en": "Douala", "cn": "杜阿拉" }, { "fr": "Garoua", "en": "Garoua", "cn": "加鲁阿" }] }, { "condition": "values.id_user_visacountry == 29", "values": [{ "fr": "Ottawa", "en": "Ottawa", "cn": "渥太华" }, { "fr": "Moncton", "en": "Moncton", "cn": "蒙克顿" }, { "fr": "Montréal", "en": "Montreal", "cn": "蒙特利尔" }, { "fr": "Québec", "en": "Quebec", "cn": "魁北克" }, { "fr": "Toronto", "en": "Toronto", "cn": "多伦多" }, { "fr": "Vancouver", "en": "Vancouver", "cn": "温哥华" }] }, { "condition": "values.id_user_visacountry == 30", "values": [{ "fr": "Praia", "en": "Praia", "cn": "普拉亚" }] }, { "condition": "values.id_user_visacountry == 31", "values": [{ "fr": "Santiago", "en": "Santiago", "cn": "圣地亚哥" }] }, { "condition": "values.id_user_visacountry == 32", "values": [{ "fr": "Pékin", "en": "Beijing", "cn": "北京" }, { "fr": "Canton", "en": "Canton", "cn": "广州" }, { "fr": "Chengdu", "en": "Chengdu", "cn": "成都" }, { "fr": "Hong Kong", "en": "Hong Kong", "cn": "香港" }, { "fr": "Shanghai", "en": "Shanghai", "cn": "上海" }, { "fr": "Shenyang", "en": "Shenyang", "cn": "沉阳" }, { "fr": "Wuhan", "en": "Wuhan", "cn": "武汉" }] }, { "condition": "values.id_user_visacountry == 33", "values": [{ "fr": "Nicosie", "en": "Nicosia", "cn": "尼科西亚" }] }, { "condition": "values.id_user_visacountry == 34", "values": [{ "fr": "Bogotá", "en": "Bogota", "cn": "波哥大" }] }, { "condition": "values.id_user_visacountry == 35", "values": [{ "fr": "Moroni", "en": "Moroni", "cn": "莫罗尼" }, { "fr": "Mutsamudu", "en": "Mutsamudu", "cn": "穆察穆杜" }] }, { "condition": "values.id_user_visacountry == 36", "values": [{ "fr": "Séoul", "en": "Seoul", "cn": "汉城" }] }, { "condition": "values.id_user_visacountry == 37", "values": [{ "fr": "San José", "en": "San José", "cn": "圣荷西" }] }, { "condition": "values.id_user_visacountry == 38", "values": [{ "fr": "Abidjan", "en": "Abidjan", "cn": "阿比让" }] }, { "condition": "values.id_user_visacountry == 39", "values": [{ "fr": "Zagreb", "en": "Zagreb", "cn": "萨格勒布" }] }, { "condition": "values.id_user_visacountry == 40", "values": [{ "fr": "La Havane", "en": "Havana", "cn": "哈瓦那" }] }, { "condition": "values.id_user_visacountry == 41", "values": [{ "fr": "Copenhague", "en": "Copenhagen", "cn": "哥本哈根" }] }, { "condition": "values.id_user_visacountry == 42", "values": [{ "fr": "Djibouti", "en": "Djibouti", "cn": "吉布提" }] }, { "condition": "values.id_user_visacountry == 43", "values": [{ "fr": "Le Caire", "en": "Cairo", "cn": "开罗" }, { "fr": "Alexandrie", "en": "Alexandria", "cn": "亚历山大" }] }, { "condition": "values.id_user_visacountry == 44", "values": [{ "fr": "Abou Dabi", "en": "Abu Dhabi", "cn": "阿布扎比" }, { "fr": "Dubaï", "en": "Dubai", "cn": "迪拜" }] }, { "condition": "values.id_user_visacountry == 45", "values": [{ "fr": "Quito", "en": "Quito", "cn": "基多" }] }, { "condition": "values.id_user_visacountry == 46", "values": [{ "fr": "Asmara", "en": "Asmara", "cn": "阿斯马拉" }] }, { "condition": "values.id_user_visacountry == 47", "values": [{ "fr": "Madrid", "en": "Madrid", "cn": "马德里" }, { "fr": "Alicante", "en": "Alicante", "cn": "阿利坎特" }, { "fr": "Barcelone", "en": "Barcelona", "cn": "巴塞罗那" }, { "fr": "Bilbao", "en": "Bilbao", "cn": "毕尔巴鄂" }, { "fr": "Málaga", "en": "Malaga", "cn": "马拉加" }, { "fr": "Palma de Majorque", "en": "Palma de Mallorca", "cn": "帕尔马" }, { "fr": "Séville", "en": "Seville", "cn": "塞维利亚" }, { "fr": "Valence", "en": "Valencia", "cn": "瓦伦西亚" }] }, { "condition": "values.id_user_visacountry == 48", "values": [{ "fr": "Tallinn", "en": "Tallinn", "cn": "塔林" }] }, { "condition": "values.id_user_visacountry == 49", "values": [{ "fr": "Washington", "en": "Washington", "cn": "华盛顿" }, { "fr": "Atlanta", "en": "Atlanta", "cn": "亚特兰大" }, { "fr": "Boston", "en": "Boston", "cn": "波士顿" }, { "fr": "Chicago", "en": "Chicago", "cn": "芝加哥" }, { "fr": "Houston", "en": "Houston", "cn": "休斯顿" }, { "fr": "La Nouvelle-Orléans", "en": "New Orleans", "cn": "新奥尔良" }, { "fr": "Los Angeles", "en": "Los Angeles", "cn": "洛杉矶" }, { "fr": "Miami", "en": "Miami", "cn": "迈阿密" }, { "fr": "New York", "en": "New York", "cn": "纽约" }, { "fr": "San Francisco", "en": "San Francisco", "cn": "旧金山" }, { "fr": "Washington", "en": "Washington", "cn": "华盛顿" }] }, { "condition": "values.id_user_visacountry == 50", "values": [{ "fr": "Addis-Abeba", "en": "Addis Ababa", "cn": "亚的斯亚贝巴" }] }, { "condition": "values.id_user_visacountry == 51", "values": [{ "fr": "Suva", "en": "Suva", "cn": "苏瓦" }] }, { "condition": "values.id_user_visacountry == 52", "values": [{ "fr": "Helsinki", "en": "Helsinki", "cn": "赫尔辛基" }] }, { "condition": "values.id_user_visacountry == 53", "values": [{ "fr": "Libreville", "en": "Libreville", "cn": "利伯维尔" }, { "fr": "Port-Gentil", "en": "Port Gentil", "cn": "让蒂尔港" }] }, { "condition": "values.id_user_visacountry == 54", "values": [{ "fr": "Tbilissi", "en": "Tbilisi", "cn": "第比利斯" }] }, { "condition": "values.id_user_visacountry == 55", "values": [{ "fr": "Accra", "en": "Accra", "cn": "阿克拉" }] }, { "condition": "values.id_user_visacountry == 56", "values": [{ "fr": "Athènes", "en": "Athens", "cn": "雅典" }, { "fr": "Salonique", "en": "Thessaloniki", "cn": "塞萨洛尼基" }] }, { "condition": "values.id_user_visacountry == 57", "values": [{ "fr": "Guatemala", "en": "Guatemala", "cn": "危地马拉" }] }, { "condition": "values.id_user_visacountry == 58", "values": [{ "fr": "Conakry", "en": "Conakry", "cn": "科纳克里" }] }, { "condition": "values.id_user_visacountry == 59", "values": [{ "fr": "Malabo", "en": "Malabo", "cn": "马拉博" }] }, { "condition": "values.id_user_visacountry == 60", "values": [{ "fr": "Bissau", "en": "Bissau", "cn": "几内亚比绍" }] }, { "condition": "values.id_user_visacountry == 61", "values": [{ "fr": "Port-au-Prince", "en": "Port-au-Prince", "cn": "太子港" }] }, { "condition": "values.id_user_visacountry == 62", "values": [{ "fr": "Tegucigalpa", "en": "Tegucigalpa", "cn": "特古西加尔巴" }] }, { "condition": "values.id_user_visacountry == 63", "values": [{ "fr": "Budapest", "en": "Budapest", "cn": "布达佩斯" }] }, { "condition": "values.id_user_visacountry == 64", "values": [{ "fr": "New Delhi", "en": "New Delhi", "cn": "新德里" }, { "fr": "Bangalore", "en": "Bangalore", "cn": "班加罗尔" }, { "fr": "Calcutta", "en": "Calcutta", "cn": "加尔各答" }, { "fr": "Bombay", "en": "Bombay", "cn": "孟买" }, { "fr": "Pondichéry", "en": "Pondicherry", "cn": "本地治里" }] }, { "condition": "values.id_user_visacountry == 65", "values": [{ "fr": "Jakarta", "en": "Jakarta", "cn": "雅加达" }] }, { "condition": "values.id_user_visacountry == 66", "values": [{ "fr": "Bagdad", "en": "Baghdad", "cn": "巴格达" }] }, { "condition": "values.id_user_visacountry == 67", "values": [{ "fr": "Téhéran", "en": "Tehran", "cn": "德黑兰" }] }, { "condition": "values.id_user_visacountry == 68", "values": [{ "fr": "Dublin", "en": "Dublin", "cn": "都柏林" }] }, { "condition": "values.id_user_visacountry == 69", "values": [{ "fr": "Reykjavík", "en": "Reykjavik", "cn": "雷克雅未克" }] }, { "condition": "values.id_user_visacountry == 70", "values": [{ "fr": "Tel Aviv", "en": "Tel Aviv", "cn": "特拉维夫" }, { "fr": "Haïfa", "en": "Haifa", "cn": "海法" }] }, { "condition": "values.id_user_visacountry == 71", "values": [{ "fr": "Rome", "en": "Rome", "cn": "罗马" }, { "fr": "Milan", "en": "Milan", "cn": "米兰" }, { "fr": "Naples", "en": "Naples", "cn": "那不勒斯" }, { "fr": "Turin", "en": "Turin", "cn": "都灵" }] }, { "condition": "values.id_user_visacountry == 72", "values": [{ "fr": "Kingston", "en": "Kingston", "cn": "金士顿" }] }, { "condition": "values.id_user_visacountry == 73", "values": [{ "fr": "Tokyo", "en": "Tokyo", "cn": "东京" }, { "fr": "Kyoto", "en": "Kyoto", "cn": "京都" }] }, { "condition": "values.id_user_visacountry == 74", "values": [{ "fr": "Jérusalem", "en": "Jerusalem", "cn": "耶路撒冷" }] }, { "condition": "values.id_user_visacountry == 75", "values": [{ "fr": "Amman", "en": "Amman", "cn": "安曼" }] }, { "condition": "values.id_user_visacountry == 76", "values": [{ "fr": "Astana", "en": "Astana", "cn": "阿斯塔纳" }, { "fr": "Almaty", "en": "Almaty", "cn": "阿拉木图" }] }, { "condition": "values.id_user_visacountry == 77", "values": [{ "fr": "Nairobi", "en": "Nairobi", "cn": "内罗毕" }] }, { "condition": "values.id_user_visacountry == 78", "values": [{ "fr": "Bichkek", "en": "Bishkek", "cn": "比什凯克" }] }, { "condition": "values.id_user_visacountry == 79", "values": [{ "fr": "Pristina", "en": "Pristina", "cn": "普里什蒂纳" }] }, { "condition": "values.id_user_visacountry == 80", "values": [{ "fr": "Koweït", "en": "Kuwait", "cn": "科威特" }] }, { "condition": "values.id_user_visacountry == 81", "values": [{ "fr": "Vientiane", "en": "Vientiane", "cn": "万象" }] }, { "condition": "values.id_user_visacountry == 82", "values": [{ "fr": "Riga", "en": "Riga", "cn": "里加" }] }, { "condition": "values.id_user_visacountry == 83", "values": [{ "fr": "Beyrouth", "en": "Beirut", "cn": "贝鲁特" }] }, { "condition": "values.id_user_visacountry == 84", "values": [{ "fr": "Monrovia", "en": "Monrovia", "cn": "蒙罗维亚" }] }, { "condition": "values.id_user_visacountry == 85", "values": [{ "fr": "Tripoli" }] }, { "condition": "values.id_user_visacountry == 86", "values": [{ "fr": "Vilnius", "en": "Vilnius", "cn": "维尔纽斯" }] }, { "condition": "values.id_user_visacountry == 87", "values": [{ "fr": "Luxembourg", "en": "Luxembourg", "cn": "卢森堡" }] }, { "condition": "values.id_user_visacountry == 88", "values": [{ "fr": "Skopje", "en": "Skopje", "cn": "斯科普里" }] }, { "condition": "values.id_user_visacountry == 89", "values": [{ "fr": "Tananarive (Antananarivo)", "en": "Tananarive (Antananarivo)", "cn": "塔那那利佛（塔那那利佛）" }, { "fr": "Antsiranana", "en": "Antsiranana", "cn": "安齐拉纳纳" }, { "fr": "Mahajanga", "en": "Mahajanga", "cn": "马任加" }, { "fr": "Toamasina", "en": "Toamasina", "cn": "图阿马西纳" }] }, { "condition": "values.id_user_visacountry == 90", "values": [{ "fr": "Kuala Lumpur", "en": "Kuala Lumpur", "cn": "吉隆坡" }] }, { "condition": "values.id_user_visacountry == 91", "values": [{ "fr": "Bamako", "en": "Bamako", "cn": "巴马科" }] }, { "condition": "values.id_user_visacountry == 92", "values": [{ "fr": "La Valette", "en": "Valletta", "cn": "瓦莱塔" }] }, { "condition": "values.id_user_visacountry == 93", "values": [{ "fr": "Rabat", "en": "Rabat", "cn": "拉巴特" }, { "fr": "Agadir", "en": "Agadir", "cn": "阿加迪尔" }, { "fr": "Casablanca", "en": "Casablanca", "cn": "卡萨布兰卡" }, { "fr": "Fès", "en": "Fes", "cn": "菲斯" }, { "fr": "Marrakech", "en": "Marrakech", "cn": "马拉喀什" }, { "fr": "Tanger", "en": "Tanger", "cn": "丹吉尔" }] }, { "condition": "values.id_user_visacountry == 94", "values": [{ "fr": "Port-Louis", "en": "Port Louis", "cn": "路易港" }] }, { "condition": "values.id_user_visacountry == 95", "values": [{ "fr": "Nouakchott", "en": "Nouakchott", "cn": "努瓦克肖特" }] }, { "condition": "values.id_user_visacountry == 96", "values": [{ "fr": "Mexico", "en": "Mexico", "cn": "墨西哥" }] }, { "condition": "values.id_user_visacountry == 97", "values": [{ "fr": "Chişinău", "en": "Chisinau", "cn": "基希讷乌" }] }, { "condition": "values.id_user_visacountry == 98", "values": [{ "fr": "Monaco", "en": "Monaco", "cn": "摩纳哥" }] }, { "condition": "values.id_user_visacountry == 99", "values": [{ "fr": "Oulan-Bator", "en": "Ulaanbaatar", "cn": "乌兰巴托" }] }, { "condition": "values.id_user_visacountry == 100", "values": [{ "fr": "Podgorica", "en": "Podgorica", "cn": "波德戈里察" }] }, { "condition": "values.id_user_visacountry == 101", "values": [{ "fr": "Maputo", "en": "Maputo", "cn": "马普托" }] }, { "condition": "values.id_user_visacountry == 102", "values": [{ "fr": "Windhoek", "en": "Windhoek", "cn": "温得和克" }] }, { "condition": "values.id_user_visacountry == 103", "values": [{ "fr": "Katmandou", "en": "Kathmandu", "cn": "加德满都" }] }, { "condition": "values.id_user_visacountry == 104", "values": [{ "fr": "Managua", "en": "Managua", "cn": "马那瓜" }] }, { "condition": "values.id_user_visacountry == 105", "values": [{ "fr": "Niamey", "en": "Niamey", "cn": "尼亚美" }] }, { "condition": "values.id_user_visacountry == 106", "values": [{ "fr": "Abuja", "en": "Abuja", "cn": "阿布贾" }, { "fr": "Lagos", "en": "Lagos", "cn": "拉各斯" }] }, { "condition": "values.id_user_visacountry == 107", "values": [{ "fr": "Oslo", "en": "Oslo", "cn": "奥斯陆" }] }, { "condition": "values.id_user_visacountry == 108", "values": [{ "fr": "Wellington", "en": "Wellington", "cn": "惠灵顿" }] }, { "condition": "values.id_user_visacountry == 109", "values": [{ "fr": "Mascate", "en": "Muscat", "cn": "马斯喀特" }] }, { "condition": "values.id_user_visacountry == 110", "values": [{ "fr": "Kampala", "en": "Kampala", "cn": "坎帕拉" }] }, { "condition": "values.id_user_visacountry == 111", "values": [{ "fr": "Tachkent", "en": "Tashkent", "cn": "塔什干" }] }, { "condition": "values.id_user_visacountry == 112", "values": [{ "fr": "Islamabad", "en": "Islamabad", "cn": "伊斯兰堡" }, { "fr": "Karachi", "en": "Karachi", "cn": "卡拉奇" }] }, { "condition": "values.id_user_visacountry == 113", "values": [{ "fr": "Panamá", "en": "Panama", "cn": "巴拿马" }] }, { "condition": "values.id_user_visacountry == 114", "values": [{ "fr": "Port Moresby", "en": "Port Moresby", "cn": "莫尔兹比港" }] }, { "condition": "values.id_user_visacountry == 115", "values": [{ "fr": "Assomption", "en": "Assumption", "cn": "假设" }] }, { "condition": "values.id_user_visacountry == 116", "values": [{ "fr": "La Haye", "en": "Hague", "cn": "海牙" }, { "fr": "Amsterdam", "en": "Amsterdam", "cn": "阿姆斯特丹" }] }, { "condition": "values.id_user_visacountry == 117", "values": [{ "fr": "Lima", "en": "Lima", "cn": "利马" }] }, { "condition": "values.id_user_visacountry == 118", "values": [{ "fr": "Manille", "en": "Manila", "cn": "马尼拉" }] }, { "condition": "values.id_user_visacountry == 119", "values": [{ "fr": "Varsovie", "en": "Warsaw", "cn": "华沙" }, { "fr": "Cracovie", "en": "Krakow", "cn": "克拉科夫" }] }, { "condition": "values.id_user_visacountry == 120", "values": [{ "fr": "Lisbonne", "en": "Lisbon", "cn": "里斯本" }, { "fr": "Porto", "en": "Porto", "cn": "波尔图" }] }, { "condition": "values.id_user_visacountry == 121", "values": [{ "fr": "Doha", "en": "Doha", "cn": "多哈" }] }, { "condition": "values.id_user_visacountry == 122", "values": [{ "fr": "Bangui", "en": "Bangui", "cn": "班吉" }] }, { "condition": "values.id_user_visacountry == 123", "values": [{ "fr": "Kinshasa", "en": "Kinshasa", "cn": "金沙萨" }] }, { "condition": "values.id_user_visacountry == 124", "values": [{ "fr": "Saint-Domingue", "en": "Santo Domingo", "cn": "圣多明各" }] }, { "condition": "values.id_user_visacountry == 125", "values": [{ "fr": "Brazzaville", "en": "Brazzaville", "cn": "布拉柴维尔" }, { "fr": "Pointe-Noire", "en": "Pointe-Noire", "cn": "黑角" }] }, { "condition": "values.id_user_visacountry == 126", "values": [{ "fr": "Prague", "en": "Prague", "cn": "布拉格" }] }, { "condition": "values.id_user_visacountry == 127", "values": [{ "fr": "Bucarest", "en": "Bucharest", "cn": "布加勒斯特" }] }, { "condition": "values.id_user_visacountry == 128", "values": [{ "fr": "Londres", "en": "London", "cn": "伦敦" }, { "fr": "Édimbourg", "en": "Edinburgh", "cn": "爱丁堡" }, { "fr": "Gibraltar", "en": "Gibraltar", "cn": "直布罗陀" }, { "fr": "Jersey", "en": "Jersey", "cn": "新泽西" }, { "fr": "Guernesey", "en": "Guernsey", "cn": "根西岛" }] }, { "condition": "values.id_user_visacountry == 129", "values": [{ "fr": "Moscou", "en": "Moscow", "cn": "莫斯科" }, { "fr": "Iekaterinbourg", "en": "Yekaterinburg", "cn": "叶卡捷琳堡" }, { "fr": "Saint-Pétersbourg", "en": "St. Petersburg", "cn": "圣彼得堡" }] }, { "condition": "values.id_user_visacountry == 130", "values": [{ "fr": "Kigali", "en": "Kigali", "cn": "基加利" }] }, { "condition": "values.id_user_visacountry == 131", "values": [{ "fr": "Castries", "en": "Castries", "cn": "卡斯特里" }] }, { "condition": "values.id_user_visacountry == 132", "values": [{ "fr": "San Salvador", "en": "San Salvador", "cn": "圣萨尔瓦多" }] }, { "condition": "values.id_user_visacountry == 133", "values": [{ "fr": "Dakar", "en": "Dakar", "cn": "达喀尔" }, { "fr": "Saint-Louis", "en": "St. Louis", "cn": "圣路易斯" }] }, { "condition": "values.id_user_visacountry == 134", "values": [{ "fr": "Belgrade", "en": "Belgrade", "cn": "贝尔格莱德" }] }, { "condition": "values.id_user_visacountry == 135", "values": [{ "fr": "Victoria", "en": "Victoria", "cn": "维多利亚" }] }, { "condition": "values.id_user_visacountry == 136", "values": [{ "fr": "Singapour", "en": "Singapore", "cn": "新加坡" }] }, { "condition": "values.id_user_visacountry == 137", "values": [{ "fr": "Bratislava", "en": "Bratislava", "cn": "布拉迪斯拉发" }] }, { "condition": "values.id_user_visacountry == 138", "values": [{ "fr": "Ljubljana", "en": "Ljubljana", "cn": "卢布尔雅那" }] }, { "condition": "values.id_user_visacountry == 139", "values": [{ "fr": "Khartoum", "en": "Khartoum", "cn": "喀土穆" }] }, { "condition": "values.id_user_visacountry == 140", "values": [{ "fr": "Djouba", "en": "Juba", "cn": "朱巴" }] }, { "condition": "values.id_user_visacountry == 141", "values": [{ "fr": "Colombo", "en": "Colombo", "cn": "科伦坡" }] }, { "condition": "values.id_user_visacountry == 142", "values": [{ "fr": "Stockholm", "en": "Stockholm", "cn": "斯德哥尔摩" }] }, { "condition": "values.id_user_visacountry == 143", "values": [{ "fr": "Berne", "en": "Bern", "cn": "伯尔尼" }, { "fr": "Genève", "en": "Geneva", "cn": "日内瓦" }, { "fr": "Zurich", "en": "Zurich", "cn": "苏黎世" }] }, { "condition": "values.id_user_visacountry == 144", "values": [{ "fr": "Paramaribo", "en": "Paramaribo", "cn": "帕拉马里博" }] }, { "condition": "values.id_user_visacountry == 145", "values": [{ "fr": "Damas", "en": "Damascus", "cn": "大马士革" }, { "fr": "Alep", "en": "Aleppo", "cn": "阿勒颇" }] }, { "condition": "values.id_user_visacountry == 146", "values": [{ "fr": "Douchanbé", "en": "Dushanbe", "cn": "杜尚别" }] }, { "condition": "values.id_user_visacountry == 147", "values": [{ "fr": null, "en": null, "cn": "  于：" }, { "fr": "Bureau français de Taipei", "en": "French Office in Taipei", "cn": "法国驻台北" }] }, { "condition": "values.id_user_visacountry == 148", "values": [{ "fr": "Dar es Salam", "en": "Dar es Salaam", "cn": "达累斯萨拉姆" }] }, { "condition": "values.id_user_visacountry == 149", "values": [{ "fr": "Ndjamena", "en": "Ndjamena", "cn": "恩贾梅纳" }] }, { "condition": "values.id_user_visacountry == 150", "values": [{ "fr": "Bangkok", "en": "Bangkok", "cn": "曼谷" }] }, { "condition": "values.id_user_visacountry == 151", "values": [{ "fr": "Lomé", "en": "Lome", "cn": "洛美" }] }, { "condition": "values.id_user_visacountry == 152", "values": [{ "fr": "Port d'Espagne", "en": "Port of Spain", "cn": "西班牙港" }] }, { "condition": "values.id_user_visacountry == 153", "values": [{ "fr": "Tunis", "en": "Tunis", "cn": "突尼斯" }, { "fr": "Bizerte", "en": "Bizerte", "cn": "比塞大" }, { "fr": "Sfax", "en": "Sfax", "cn": "斯法克斯" }, { "fr": "Djerba", "en": "Djerba", "cn": "杰尔巴" }, { "fr": "Tozeur", "en": "Tozeur", "cn": "托泽尔" }, { "fr": "Kantaoui", "en": "Kantaoui", "cn": "甘达维" }] }, { "condition": "values.id_user_visacountry == 154", "values": [{ "fr": "Achgabat", "en": "Ashgabat", "cn": "阿什哈巴德" }] }, { "condition": "values.id_user_visacountry == 155", "values": [{ "fr": "Ankara", "en": "Ankara", "cn": "安卡拉" }, { "fr": "Istanbul", "en": "Istanbul", "cn": "伊斯坦布尔" }] }, { "condition": "values.id_user_visacountry == 156", "values": [{ "fr": "Kiev", "en": "Kiev", "cn": "基辅" }] }, { "condition": "values.id_user_visacountry == 157", "values": [{ "fr": "Montévidéo", "en": "Montevideo", "cn": "蒙得维的亚" }] }, { "condition": "values.id_user_visacountry == 158", "values": [{ "fr": "Port-Vila", "en": "Port Vila", "cn": "维拉港" }] }, { "condition": "values.id_user_visacountry == 159", "values": [{ "fr": "Caracas", "en": "Caracas", "cn": "加拉加斯" }] }, { "condition": "values.id_user_visacountry == 160", "values": [{ "fr": "Hanoï", "en": "Hanoi", "cn": "河内" }, { "fr": "Hô-Chi-Minh-Ville", "en": "Ho Chi Minh City", "cn": "胡志明市" }] }, { "condition": "values.id_user_visacountry == 161", "values": [{ "fr": "Sanaa", "en": "Sanaa", "cn": "萨那" }] }, { "condition": "values.id_user_visacountry == 162", "values": [{ "fr": "Lusaka", "en": "Lusaka", "cn": "卢萨卡" }] }, { "condition": "values.id_user_visacountry == 163", "values": [{ "fr": "Harare", "en": "Harare", "cn": "哈拉雷" }] }, { "condition": "values.id_user_visacountry == 164", "values": [{ "fr": "Préfécture en France", "en": "France", "cn": "法国" }] }] } }, { "id": "id_howlong", "q": { "fr": "Quel type de visa avez-vous demandé&nbsp;?", "en": "What type of visa did you aplly for&nbsp;?", "cn": "您申请的是哪一种签证&nbsp;?" }, "a": { "type": "array", "min": 1, "max": 1, "error-message": { "fr": "Selectionnez un type de visa dans la liste", "en": "Select a type of visa in the list", "cn": "请在名单中选择一种签证" }, "values": [{ "fr": "Visa long séjour", "en": "Long term visa", "cn": "长期居留签证" }, { "fr": "Visa court séjour", "en": "Short term visa", "cn": "短期居留签证" }] } }, { "id": "id_whichvisa", "q": { "fr": "Quel type de visa souhaitez-vous demander&nbsp;?", "en": "What type of visa would you like to apply&nbsp;?", "cn": "您希望申请哪一种签证&nbsp;?" }, "a": { "type": "array", "min": 1, "max": 1, "error-message": { "fr": "Selectionnez un type de visa dans la liste", "en": "Select a type of visa", "cn": "请选择一种签证" }, "values": [{ "fr": "Visa long séjour", "en": "Long term visa", "cn": "长期居留签证" }, { "fr": "Visa court séjour", "en": "Short term visa", "cn": "短期拘留签证" }] } }, { "id": "id_why", "q": { "fr": "Quel est le motif de votre visa long séjour&nbsp;?", "en": "What is the reason for your long term visa&nbsp;?", "cn": "您的长期居留的目的是什么&nbsp;?" }, "a": { "type": "array", "min": 1, "max": 1, "error-message": { "fr": "Selectionnez un motif dans la liste", "en": "Select a reason in the list", "cn": "请在以下目的中选择" }, "values": [{ "fr": "Etude", "en": "Study", "cn": "学习" }, { "fr": "Etablissement familial", "en": "Family reunification", "cn": "建立家庭" }, { "fr": "Stage/Formation", "en": "Training/formation", "cn": "实习/培训" }, { "fr": "Etablissement privé/Visiteur", "en": "Visitor", "cn": "私人机构/游客" }, { "fr": "Activité professionnelle", "en": "Professionel activity", "cn": "职业活动" }, { "fr": "Mariage", "en": "Wedding", "cn": "婚姻" }, { "fr": "Visa de retour", "en": "Return Visa", "cn": "返程签证" }, { "fr": "Raison médicale", "en": "Medical reason", "cn": "医疗方面原因" }, { "fr": "Prise de fonctions officielles", "en": "Official asumption of duties", "cn": "任职" }, { "fr": "Autre", "en": "Other", "cn": "其他" }] } }, { "id": "id_why_other", "q": { "fr": "Pouvez-vous préciser le motif de votre visa&nbsp;?", "en": "could you precise the reason for your vis&nbsp;?", "cn": "请您具体阐明您的签证目的&nbsp;?" }, "a": { "type": "text", "min": 1, "error-message": { "fr": "Motif requis", "en": "Reason required", "cn": "获得的目的" }, "placeholder": "Ecrire ici le motif de votre visa long séjour" } }, { "id": "id_why_short", "q": { "fr": "Quel est le motif de votre visa court séjour&nbsp;?", "en": "What is the reason for your short term visa&nbsp;?", "cn": "您的短期签证的目的是什么&nbsp;?" }, "a": { "type": "array", "min": 1, "max": 1, "error-message": { "fr": "Selectionnez un motif dans la liste", "en": "Select a reason in the list", "cn": "请在名单中选择您的目的" }, "values": [{ "fr": "Etudes", "en": "Study", "cn": "学习" }, { "fr": "Visite à la famille ou à des amis", "en": "Visit to the family or some friends", "cn": "探访家人或朋友" }, { "fr": "Tourisme", "en": "Tourism", "cn": "旅游" }, { "fr": "Affaires", "en": "Business", "cn": "商务" }, { "fr": "Culture", "en": "Culture", "cn": "文化" }, { "fr": "Sport", "en": "Sport", "cn": "体育运动" }, { "fr": "Visite officielle", "en": "Official visit", "cn": "官方访问" }, { "fr": "Raisons médicales", "en": "Medical reason", "cn": "医药治疗原因" }, { "fr": "Transit", "en": "Transit", "cn": "运输" }, { "fr": "Transit aéroportuaire", "en": "Airport transit", "cn": "机场运输" }, { "fr": "Autre", "en": "Other", "cn": "其他" }] } }, { "id": "id_why_short_other", "q": { "fr": "Pouvez-vous préciser le motif de votre visa&nbsp;?", "en": "Could you precise the reason for your visa&nbsp;?", "cn": "请您阐明您的签证目的&nbsp;?" }, "a": { "type": "text", "min": 1, "error-message": { "fr": "Motif requis", "en": "Reason required", "cn": "获得的目的" }, "placeholder": "Ecrire ici le motif de votre visa court séjour" } }, { "id": "id_courr_motif", "q": { "fr": "Les raisons du refus vous ont-t-elles été précisées&nbsp;?", "en": "Have the reason for your refusal been precised&nbsp;?", "cn": "您被拒签的理由是否明确通知给您&nbsp;?", "info": { "fr": "Cette information doit figurée sur le document \"Notification de refus d'un visa\"", "en": "This information has to figure on the document \"visa refusal notification\"", "cn": "这一项信息应该在“被拒签证说明”这一份材料中可以找到" } }, "a": { "type": "boolean" } }, { "id": "id_motif_quoi_longsejour", "q": { "fr": "Pouvez-vous préciser le motif de votre refus de visa&nbsp;?", "en": "Could you precise the reason for your visa refusal&nbsp;?", "cn": "请您阐明您被拒的原因&nbsp;?" }, "a": { "type": "text", "min": 1, "error-message": { "fr": "Motif requis", "en": "Reason required", "cn": "获得的原因" }, "placeholder": "Ecrire ici le motif de votre refus de visa long séjour" } }, { "id": "id_motif_quoi", "q": { "fr": "Lesquels&nbsp;?", "en": "Which one&nbsp;?", "cn": "那些&nbsp;?" }, "a": { "type": "array", "min": 1, "values": [{ "fr": "Vos ressources sont insuffisantes", "en": "Your income are inadequate", "cn": "您的收入不足够" }, { "fr": "Votre maîtrise du français est insuffisante", "en": "Your french knowledge is inadequate", "cn": "您的法语程度不足够" }, { "fr": "L'administration a des doutes quant à l'objet de votre séjour (réalité de votre formation ou du sérieux de vos études)", "en": "The administration has some doubts about the real reason of your stay in France", "cn": "行政部门怀疑您在法国居留的目的（您的培训的真实性或者您对学习的严肃程度）" }, { "fr": "Vous n'avez pas justifié d'une inscription dans un établissement d'enseignement en France", "en": "You did not justify a registration in a french educational institution", "cn": "您没有提供法国本地一所教育机构的注册证明" }, { "fr": "Vous représentez une menace pour l'ordre public, la sécurité nationale ou la santé publique, etc.", "en": "You are considered as a threat for the public order, national security or national health,  etc.", "cn": "您对公共秩序，国家安全和公共健康存在威胁等等" }, { "fr": "Vous semblez avoir oublié de fournir des pièces obligatoires à votre dossier", "en": "You seem to have forgotten some compulsory documents in your file", "cn": "您很可能忘记提供重要文件" }, { "fr": "Autres", "en": "Other", "cn": "其他" }] } }, { "id": "id_oubli_ress", "q": { "fr": "Aviez-vous fourni les preuves que vous disposez de suffisamment de ressources (moyens financiers) pour la durée de votre séjour&nbsp;?", "en": "Did you give some proofs that you would have enough income during the stay in France&nbsp;?", "cn": "您是否提供在法期间证明您有足够的收入的文件（经济方面的解决方案&nbsp;?" }, "a": { "type": "boolean" } }, { "id": "id_oubli_conn", "q": { "fr": "Aviez-vous fourni la preuve que vous avez le niveau suffisant de français pour venir étudier en France&nbsp;?", "en": "Did you give some proofs that you have french language knowledge to come study in France&nbsp;?", "cn": "您是否提供了证明您有足够的法语水平来法国学习的文件&nbsp;?" }, "a": { "type": "boolean" } }, { "id": "id_oubli_inscrip", "q": { "fr": "Aviez-vous fourni la preuve de votre inscription à un établissement d'enseignement français&nbsp;?", "en": "Did you give proof of your registration in an educational institution&nbsp;?", "cn": "您是否提供了在法国某所教育机构或高校注册证明&nbsp;?" }, "a": { "type": "boolean" } }, { "id": "id_oubli_inscrip_cash", "q": { "fr": "Aviez-vous fourni la preuve du paiement de vos frais d'inscription dans un établissement d'enseignement français&nbsp;?", "en": "Did you give the proof of the payment of your registration fees in a french educational institution&nbsp;?", "cn": "您是否提供了已经支付某所教育机构或高校的支付证明&nbsp;?" }, "a": { "type": "boolean" } }, { "id": "id_oubli_pieces", "q": { "fr": "Aviez-vous fourni les pièces suivantes&nbsp;?", "en": "Did you forget the following documents&nbsp;?", "cn": "您是否提供了以下文件&nbsp;?" }, "a": { "type": "array", "min": 1, "files": [{ "condition": "v.includes(0)", "label": { "fr": "Justificatif de ressources financières suffisantes", "en": "Sufficient income justification", "cn": "证明经济收入充足" } }, { "condition": "v.includes(1)", "label": { "fr": "Justificatif d'inscription dans un établissement d'enseignement français et du paiement des frais de scolarité associés", "en": "Proof of the inscription in a french educational insitution and the paymnent of the tuition fees", "cn": "证明已经成功注册法国某教育机构或高校并且附加学费上交收据" } }, { "condition": "v.includes(2)", "label": { "fr": "Justificatif de maîtrise de la langue française", "En": "Proof of the french language knowledge", "cn": "证明法语掌握程度的文件" } }, { "condition": "v.includes(3)", "label": { "fr": "pJustificatif d'inscription à une assurance maladie", "en": "Proof of the health insurance inscription", "cn": "有医疗保险的证明" } }, { "condition": "v.includes(4)", "label": { "fr": "Document de voyage en cours de validité (passeport, etc.)", "en": "Valid travel documents (passport...)", "cn": "在有效期之内的旅游证件（护照等等）" } }], "values": [{ "fr": "Justificatif de ressources financières", "en": "Income justification", "cn": "经济收入证明" }, { "fr": "Justificatif d'inscription dans un établissement d'enseignement français et du paiement des frais de scolarité", "en": "Proof of the inscription in a french educational insitution and the paymnent of the tuition fees", "cn": "证明已经成功注册法国某教育机构或高校并且附加学费上交收据" }, { "fr": "Justificatif de connaissance de la langue française", "en": "Proof of the french language knowledge", "cn": "证明法语掌握程度的文件" }, { "fr": "Justificatif d'affiliation à une assurance maladie", "en": "Proof of the health insurance inscription", "cn": "证明您有医疗保险" }, { "fr": "Document de voyage en cours de validité (passeport etc.)", "en": "Valid travel documents (passport...)", "cn": "在有效期之内的旅游证件（护照等等）" }] } }, { "id": "id_multi_totetud", "q": { "fr": "Avez-vous effectué la totalité de vos études secondaires dans un établissement d'enseignement français de votre pays&nbsp;?", "cn": "您在您的国家是否在一家法国学校完成了全部高中的学习&nbsp;?", "info": { "fr": "Êtiez-vous inscrit dans un collège et un lycée français&nbsp;?", "cn": "您是否曾经在法国中学读书&nbsp;?" } }, "a": { "type": "boolean" } }, { "id": "id_multi_where", "q": { "fr": "Dans quels collège et lycée&nbsp;?", "cn": "您曾经在哪一个中学&nbsp;?" }, "a": { "type": "text" } }, { "id": "id_partetud", "q": { "fr": "Avez-vous effectué une partie de vos études dans un établissement d'enseignement français de votre pays&nbsp;?", "cn": "您是否在您的国家在一家法国学校完成了一部分的高中学习&nbsp;?", "info": { "fr": "Êtiez-vous inscrit dans un collège ou un lycée français&nbsp;?", "cn": "您是否曾经在一家法国中学（初中或高中）注册&nbsp;?" } }, "a": { "type": "boolean" } }, { "id": "id_partetud_where", "q": { "fr": "Dans quels établissements d'enseignement&nbsp;?", "cn": "您曾经在哪家中学（初中或高中）&nbsp;?" }, "info": { "fr": "Indiquer le type d'établissement, son nom et la ville ou bien sélectionner dans la liste", "cn": "请标明学校类型，名字和城市，或者在列表中选择" }, "a": { "type": "text" } }, { "id": "id_franc_dipl", "q": { "fr": "Avez-vous obtenu un diplôme français reconnu par le Ministère de l'éducation nationale ou le Ministère de l'enseignement supérieur et de la recherche&nbsp;?", "cn": "您是否取得过被法国国家教育系统或高等教育，高等研究教育等机构认可的法国文凭&nbsp;?" }, "info": { "fr": "par exemple : Baccalauréat (et non OIB), License ou Maîtrise en France", "cn": "比如：高考，大学本科或者研究生" }, "a": { "type": "boolean" } }, { "id": "id_chin_dipl", "q": { "fr": "Avez-vous obtenu l'un de ces diplômes&nbsp;?", "cn": "您是否取得过以下文凭之一&nbsp;?" }, "a": { "type": "array", "min": 1, "values": [{ "fr": "Gaoko de français (LV1)", "cn": "法语高考（第一外语为法语）" }, { "fr": "Benke de français", "cn": "法语本科学历" }] } }, { "id": "id_proj_pro", "q": { "fr": "Quel est votre projet professionnel&nbsp;?", "cn": "您的职业规划是什么&nbsp;?" }, "a": { "type": "text", "placeholder": "Architecte" } }, { "id": "id_last_diploma_name", "q": { "fr": "Quel est votre dernier diplôme obtenu&nbsp;?", "cn": "您取得的最近一个文凭是哪一个&nbsp;?" }, "a": { "type": "text", "file": { "label": { "fr": "Dernier diplôme obtenu", "cn": "最近一个取得的文凭" } }, "placeholder": "Master 1 de français" } }, { "id": "id_last_diploma_when", "q": { "fr": "Quelle est l'année d'obtention de votre dernier diplôme?", "cn": "您是哪一年取得的最近一个文凭？" }, "a": { "type": "text", "placeholder": "2015" } }, { "id": "id_last_diploma_rank", "q": { "fr": "Pouvez-vous fournir les bulletins de note associés à votre diplôme&nbsp;?", "cn": "请您把和这个文凭相关的成绩单一起附上&nbsp;?", "info": { "fr": "Ces dîplomes permettront de prouver votre assiduité et la qualité de votre candidature", "cn": "这些学历证书可以来证明您学习的勤力程度和您是否是一位有资格获得签证的人" } }, "a": { "type": "boolean", "file": { "label": { "fr": "Bulletins de note associés à votre diplôme", "cn": "和学历相关的成绩单" } } } }, { "id": "id_last_diploma_school", "q": { "fr": "Dans quel établissement l'avez vous obtenu&nbsp;?", "cn": "您实在哪一个学校获得的文凭&nbsp;?" }, "a": { "type": "text", "placeholder": "Université de Shanghai" } }, { "id": "id_future_diploma_name", "q": { "fr": "Quel diplôme souhaitez-vous préparer en France&nbsp;?", "cn": "您准备在法国准备攻读哪一个文凭&nbsp;?" }, "a": { "type": "text", "placeholder": "Master 2 de français" } }, { "id": "id_future_diploma_school", "q": { "fr": "Dans quel établissement êtes-vous inscrit&nbsp;?", "cn": "您在哪一所学校注册&nbsp;?" }, "a": { "type": "text", "placeholder": "Université Paris Diderot", "file": { "label": { "fr": "Justificatif d'inscription dans l'établissement dans lequel vous poursuivez vos études", "cn": "请提供您所注册的学校的注册证明" } } } }, { "id": "id_future_diploma_year", "q": { "fr": "En quelle année obtiendrez-vous votre diplôme&nbsp;?", "cn": "您是为哪一个学年的学习注册&nbsp;?" }, "a": { "type": "text", "placeholder": "2017" } }, { "id": "id_future_reco_prof", "q": { "fr": "Bénéficiez-vous d'une recommandation d'un de vos professeurs pour ce cursus&nbsp;?", "cn": "针对您在法国的学习，您是否有您的老师的推荐信&nbsp;?" }, "a": { "type": "boolean", "file": { "label": { "fr": "Recommandation d'un de vos professeurs pour votre cursus", "cn": "您其中一位老师为您在法国的学习提供给您的推荐信" } } } }, { "id": "id_future_reco_proche", "q": { "fr": "Bénéficiez-vous d'une recommandation d'un de vos proches pour ce cursus&nbsp;?", "cn": "您是否有您的亲友的推荐信&nbsp;?", "info": { "fr": "Un de vos parents peut-il attester de votre assiduité et de votre sérieux&nbsp;?", "cn": "您的父母一方是否可以证明您在学习方面的勤奋和严肃性&nbsp;?" } }, "a": { "type": "boolean", "file": { "label": { "fr": "Recommandation d'un de vos proches pour votre cursus", "cn": "您的一位亲友为您在法国的学习提供的推荐信" } } } }, { "id": "id_bourse", "q": { "fr": "Bénéficiez-vous d'une bourse d'étude&nbsp;?", "cn": "您是否有奖学金&nbsp;?" }, "a": { "type": "boolean" } }, { "id": "id_bourse_what", "q": { "fr": "Laquelle&nbsp;?", "cn": "哪一项奖学金&nbsp;?" }, "a": { "type": "array", "min": 1, "files": [{ "condition": "v.includes(0)", "label": { "fr": "Justificatif de bourse du gouvernement", "cn": "政府奖学金证明" } }, { "condition": "v.includes(1)", "label": { "fr": "Justificatif de bourse Eiffel", "cn": "艾佛尔奖学金证明" } }, { "condition": "v.includes(2)", "label": { "fr": "Justificatif de bourse Erasmus-Mundus", "cn": "国际交流生奖学金证明" } }], "values": [{ "fr": "Boursier du gouvernement", "cn": "政府奖学金" }, { "fr": "Boursier Eiffel", "cn": "艾佛尔奖学金" }, { "fr": "Boursie Erasmus-Mundus", "cn": "国际交流生奖学金" }] } }, { "id": "id_tage", "q": { "fr": "Avez-vous passé le TAGE-MAGE&nbsp;?", "cn": "您是否参加了TAGE-MAGE考试&nbsp;?" }, "a": { "type": "boolean", "file": { "condition": "v == true", "label": { "fr": "Resultats du TAGE MAGE", "cn": "您的TAGE MAGE考试的结果" } } } }, { "id": "id_test", "q": { "fr": "Avez-vous obtenu un TCF, TCF-DAP, TEF, DELF ou DALF&nbsp;?", "cn": "您是否取得了TCF, TCF-DAP,TEF, DELF或者DALF&nbsp;?", "info": { "fr": "Test de connaissance du français (TCF), TCF pour la demande d'adminission préalable (DAP), Test d'évaluation de français (TEF), Diplôme d'étude en langue française (DELF), Diplôme approfondi de Langue française (DALF)", "cn": "法语水平考试（TCF），法语进入专业考试（DAP），法语进步考试（TEF)，法语语言学习考试（DELF),法语深入学习考试（DALF)" } }, "a": { "type": "boolean" } }, { "id": "id_test_what", "q": { "fr": "Lequel&nbsp;?", "cn": "哪一个&nbsp;?" }, "a": { "type": "array", "min": 1, "files": [{ "condition": "v.includes(0)", "label": { "fr": "Résultat du test TCF ou TCF-DAP", "cn": "您的TCF或TCF-DAP的成绩" } }, { "condition": "v.includes(1)", "label": { "fr": "Résultat du TEF", "cn": "您的TEF的成绩" } }, { "condition": "v.includes(2)", "label": { "fr": "Resultat du DELF", "cn": "您的DELF成绩" } }, { "condition": "v.includes(3)", "label": { "fr": "Resultat du DALF", "cn": "您的DALF成绩" } }], "values": [{ "fr": "J'ai réalisé un test TCF ou TCF-DAP", "cn": "我参加了TCF或TCF-DAP考试" }, { "fr": "J'ai réalisé un TEF", "cn": "我参加了TEF考试" }, { "fr": "J'ai un DELF", "cn": "我参加了DELF考试" }, { "fr": "J'ai un DALF", "cn": "我参加了DALF考试" }] } }, { "id": "id_tcf_what", "q": { "fr": "Quel type de TCF avez-vous&nbsp;?", "cn": "您参加的是哪一种TCF考试&nbsp;?", "info": { "fr": "Test de connaissance du français (TCF), TCF pour la demande d'adminission préalable (DAP)", "cn": "法语水平考试TCF, 法语入学考试（DAP)" } }, "a": { "type": "array", "max": 1, "values": [{ "fr": "J'ai réalisé un test TCF-DAP", "cn": "我参加了TCF-DAP" }, { "fr": "J'ai réalisé un test TCF", "cn": "我参加了TCF考试" }] } }, { "id": "id_tcf_when", "q": { "fr": "Quand avez-vous passé votre dernier test&nbsp;?", "cn": "您何时参加的最后一次法语测试&nbsp;?" }, "a": { "type": "date" } }, { "id": "id_tcf_score", "q": { "fr": "Quel score avez vous obtenu&nbsp;?", "cn": "您的成绩是多少&nbsp;?", "condition": "v > 0 && v < 699" }, "a": { "type": "number" } }, { "id": "id_tef_when", "q": { "fr": "Quand avez-vous passé votre test&nbsp;?", "cn": "您何时参加的考试&nbsp;?" }, "a": { "type": "date" } }, { "id": "id_tef_score", "q": { "fr": "Quel score avez-vous obtenu à l'épreuve d'expression écrite&nbsp;?", "cn": "您的写作成绩是多少&nbsp;?", "condition": "v > 0 && v < 450" }, "a": { "type": "number" } }, { "id": "id_delf_what", "q": { "fr": "Quel type de DELF avez-vous&nbsp;?", "cn": "您参加的是哪一种DELF考试&nbsp;?" }, "a": { "type": "array", "max": 1, "values": [{ "fr": "J'ai un DELF B2", "cn": "我有DELF B2" }, { "fr": "Autres DELF", "cn": "其他的DELF文凭" }] } }, { "id": "id_dalf_what", "q": { "fr": "Quel type de DALF avez-vous&nbsp;?", "cn": "您参加的是哪一种DALF&nbsp;?" }, "a": { "type": "array", "max": 1, "values": [{ "fr": "J'ai un DALF C1", "cn": "我有DALF C1" }, { "fr": "J'ai un DALF C2", "cn": "我有DALF C2" }] } }, { "id": "id_lv", "q": { "fr": "Avez-vous pris des cours de français&nbsp;? (LV1 ou LV2)", "cn": "您是否系统参加过法语的课程&nbsp;?(第一外语或第二外语)" }, "a": { "type": "boolean" } }, { "id": "id_bulletin_french", "q": { "fr": "Pouvez-vous fournir le bulletin de note de votre dernier examen de français (si les résultats sont bons :))&nbsp;?", "cn": "请您提供您最近一次法语考试的成绩单（如果成绩不错）&nbsp;?" }, "a": { "type": "boolean", "file": { "label": { "fr": "Bulletin de note de votre dernier examen de français", "cn": "您最近一次法语测试的成绩单" } } } }, { "id": "id_reco_french", "q": { "fr": "Pouvez-vous fournir une recommandation de votre professeur de français&nbsp;?", "cn": "您是否能提供您的法语老师的推荐信&nbsp;?" }, "a": { "type": "boolean", "file": { "label": { "fr": "Recommandation de votre professeur de français", "cn": "您的法语老师的推荐信" } } } }, { "id": "id_cours_encore", "q": { "fr": "Poursuivez-vous vos cours de français depuis la reception de votre courrier de refus&nbsp;?", "cn": "您是否在收到您的拒签信之后仍然继续在学习法语&nbsp;?" }, "a": { "type": "boolean" } }, { "id": "id_voyage", "q": { "fr": "Avez-vous déjà réalisé un voyage touristique ou d'étude en France et pouvez-vous fournir une preuve de ce voyage (billet, photographie de vous)&nbsp;?", "cn": "您是否曾经来过法国旅游或者学习，请出示您的证据（机票，车票，您的旅行照片）&nbsp;?" }, "a": { "type": "boolean", "file": { "label": { "fr": "Preuve de voyage touristique ou d'étude en France (billet, photographie de vous)", "cn": "您在法国旅游或学习的证据（机票，车票，您的旅行照片）" } } } }, { "id": "id_memoire", "q": { "fr": "Avez-vous déjà réalisé des travaux en lien avec la France (mémoire d'étude, etc.)&nbsp;?", "cn": "您是否已经做过和法国相关的研究和学习（论文等等）&nbsp;?", "info": { "fr": "Tous travaux artistiques, culturels, scolaires réalisés sur le thème de la France ou d'une personnalité ou monument français ou d'une ville", "cn": "所有和法国相关的艺术类，文化类，学术类文章和作品，或者是和法国人物，建筑，城市相关的作品" } }, "a": { "type": "boolean", "file": { "label": { "fr": "Preuve de travaux en lien avec la France (mémoire d'étude etc.)", "cn": "请提供相关证明（论文等等）" } } } }, { "id": "id_revenue", "q": { "fr": "Aurez-vous des revenus mensuels une fois en France&nbsp;?", "cn": "您是否在来法之后有每月经济来源&nbsp;?" }, "a": { "type": "boolean" } }, { "id": "id_rev_amount", "q": { "fr": "De combien disposerez-vous par mois en euro&nbsp;?", "cn": "您每个月有多少经费&nbsp;?" }, "a": { "type": "number" } }, { "id": "id_rev_from", "q": { "fr": "Quelles sera la source de ces revenus&nbsp;?", "cn": "您的经济来源是哪里&nbsp;?" }, "a": { "type": "array", "min": 1, "files": [{ "condition": "v.includes(0)", "label": { "fr": "Justificatif de revenu d'activité professionnelle dans mon pays d'origine (contrat de travail ou bulletins de salaire)", "cn": "我的国家提供的职业工作证明（工作合同或者工资单）" } }, { "condition": "v.includes(1)", "label": { "fr": "Justificatif de revenu d'aide de proche (relevé bancaire du proche, caution bancaire, bulletin de salaire du proche, attestation de virement permanant d'un proche)", "cn": "亲友经济资助证明（亲友的银行流水单，银行押金，亲友工资单，亲友固定汇款证明）" } }, { "condition": "v.includes(2)", "label": { "fr": "Justificatif de revenu de bourse d'étude (avec indication du moment perçu)", "cn": "奖学金证明（明确注明收到款项时间）" } }, { "condition": "v.includes(3)", "label": { "fr": "Contrat de bail (justificatif de revenu locatif d'un bien immobilier situé dans mon pays d'origine)", "cn": "房屋合同（从我本国的房产中所得的租金证明）" } }, { "condition": "v.includes(4)", "label": { "fr": "Promesse d'embauche (justificatif de revenu d'un emploi en France dans les limites fixées par la loi)", "cn": "雇佣保证（在法国境内受法律认可的工作证明）" } }, { "condition": "v.includes(5)", "label": { "fr": "Justificatif de revenu autre", "cn": "其他收入证明" } }], "values": [{ "fr": "Activité professionnelle dans mon pays d'origine", "cn": "在我本国的职业工作" }, { "fr": "Aides de proches", "cn": "亲友资助" }, { "fr": "Bourse d'étude", "cn": "奖学金" }, { "fr": "Revenu locatif d'un bien immobilier situé dans mon pays d'origine", "cn": "我本国内的房屋出租收入" }, { "fr": "Un emploi en France dans les limites fixées par la loi", "cn": "在法国境内受法律认可的工作" }, { "fr": "Autre", "cn": "其他" }] } }, { "id": "id_rev_what", "q": { "fr": "Quel est votre métier&nbsp;?", "cn": "您的职业是什么&nbsp;?" }, "a": { "type": "text", "placeholder": "Charcutier" } }, { "id": "id_rev_how", "q": { "fr": "Quel revenu vous procure-t-il (en euro)&nbsp;?", "cn": "您工资收入是多少（折换成欧元）&nbsp;?" }, "a": { "type": "number" } }, { "id": "id_rev_bourse", "q": { "fr": "Quel est le montant de votre bourse (en euro)&nbsp;?", "cn": "您的奖学金总额是多少（欧元）&nbsp;?" }, "a": { "type": "number" } }, { "id": "id_cash", "q": { "fr": "Disposez-vous d'une réserve d'argent suffisante sur votre compte bancaire pour prendre en charge votre séjour&nbsp;?", "cn": "您的账户里是否有足够的存款来保证您自法国期间的生活&nbsp;?" }, "a": { "type": "boolean" } }, { "id": "id_cash_amount", "q": { "fr": "Combien de cette réserve peut être utilisée pour financer votre séjour en France (en euro)&nbsp;?", "cn": "您的存款中有多少是可以来资助您在法国的生活费用的(欧元)&nbsp;?" }, "a": { "type": "number", "file": { "label": { "fr": "Relevé de compte attestant d'une réserve d'argent suffisante pour financer votre séjour en France", "cn": "请提供您有足够的银行存款来保证您法国的生活的证明" } } } }, { "id": "id_nature", "q": { "fr": "Bénéficierez-vous pendant votre séjour d'avantages pour votre hébergement (prêt d'appartement, accueil chez un proche, etc.)", "cn": "您是否在法期间享受房屋方面的补助（房屋贷款，被亲友收留 等等）" }, "a": { "type": "boolean", "file": { "label": { "fr": "Preuve hébergement (prêt d'appartement, accueil chez un proche etc.)", "cn": "您享有房屋资助的证明（房屋贷款，亲友收留等等）" } } } }, { "id": "id_casier", "q": { "fr": "Avez-vous un casier judiciaire vierge dans votre pays d'origine&nbsp;?", "cn": "您在您的祖籍国是否有过犯罪历史&nbsp;?" }, "a": { "type": "boolean", "file": { "label": { "fr": "Attestation prouvant le fait que votre casier judiciaire soit vierge avec traduction en français", "cn": "请提供证明您无犯罪记录的证明。要求翻译成法语" } } } }, { "id": "id_casier_when", "q": { "fr": "Quand avez-vous été condamné la dernière fois&nbsp;?", "cn": "您上一次何时被审判&nbsp;?" }, "a": { "type": "date", "file": { "label": { "fr": "Attestation prouvant la date de votre derniere condamnation", "cn": "请提供您上一次被审判的证明" } } } }, { "id": "id_casier_proche", "q": { "fr": "Est-ce qu'un de vos proches peut attester de votre parfaite moralité et de votre integration sociale&nbsp;?", "cn": "请问您的一位亲友是否可以证明您的精神面貌和融入社会的能力&nbsp;?" }, "a": { "type": "boolean", "file": { "label": { "fr": "Attestation d'un de vos proches prouvant votre parfaite moralité et votre integration sociale", "cn": "请提供您一位亲友证明您的精神面貌和融入社会能力的证明" } } } }, { "id": "id_why_who", "q": { "fr": "Qui souhaitez vous rejoindre&nbsp;?", "cn": "您想和谁团聚&nbsp;?" }, "a": { "type": "array", "max": 1, "files": [{ "condition": "v == 0", "label": { "fr": "Justificatif de nationalité française de mon/ma conjoint(e)", "cn": "我的配偶是法国籍的证明" } }], "values": [{ "fr": "Mon/Ma conjoint(e) de nationalité française", "cn": "我的配偶是法国籍" }, { "fr": "Autre", "cn": "其他" }] } }, { "id": "id_why_who_other", "q": { "fr": "Pouvez-vous préciser qui est le membre de votre famille que vous demandez à rejoindre&nbsp;?", "cn": "请明确说明您要和家庭的哪一位成员团聚&nbsp;?" }, "a": { "type": "text", "min": 1, "error-message": { "fr": "Membres de votre famille requis", "cn": "获得的家庭成员" }, "placeholder": "Ecrire ici le lien de parenté que vous avez avec le membre de votre famille" } }, { "id": "id_mariage_where", "q": { "fr": "Où a eu lieu le mariage&nbsp;?", "cn": "婚礼在哪里举行&nbsp;?" }, "a": { "type": "array", "files": [{ "condition": "v == 0", "label": { "fr": "Acte de mariage français", "cn": "法语版的结婚证明" } }], "max": 1, "values": [{ "fr": "En France", "cn": "在法国" }, { "fr": "A l'etranger", "cn": "在国外" }] } }, { "id": "id_mariage_acte_transcrit", "q": { "fr": "L'acte de mariage a t il été transcrit dans l'état civile français&nbsp;?", "cn": "您的结婚证明是否被法国政府记录在案&nbsp;?" }, "a": { "type": "boolean", "file": { "label": { "fr": "Transcription de l'acte de mariage étranger", "cn": "请提供国外婚姻的证明复印件" } } } }, { "id": "id_mariage_acte_etranger", "q": { "fr": "Avez vous l'acte de mariage étranger&nbsp;?", "cn": "您是否有国外婚姻证明&nbsp;?" }, "a": { "type": "boolean", "file": { "label": { "fr": "Acte de mariage étranger", "cn": "请提供国外婚姻证明" } } } }, { "id": "id_CCAM", "q": { "fr": "Avez vous votre le certificat de capacité à mariage (CCAM)&nbsp;?", "cn": "您是否拥有“具备结婚资格与能力”的证明(CCAM)&nbsp;?" }, "a": { "type": "boolean", "file": { "label": { "fr": "Certificat de capacité à mariage", "cn": "请提供“具备有结婚资格与能力”的证明" } } } }, { "id": "id_motif_quoi2", "q": { "fr": "Lesquels&nbsp;?", "cn": "哪些&nbsp;?" }, "a": { "type": "array", "min": 1, "values": [{ "fr": "Vous avez séjourné illégalement sur le territoire des Etats membres", "cn": "您在成员国内非法居留" }, { "fr": "Un mariage frauduleux", "cn": "您的婚姻造假" }, { "fr": "Contestation ou Annulation de votre mariage", "cn": "婚姻争论或被取消" }, { "fr": "Menace à l'ordre public etc.", "cn": "对公共秩序造成威胁等等" }, { "fr": "Oubli de pièces obligatoires", "cn": "缺少强制性文件" }, { "fr": "Autres", "cn": "其他" }] } }, { "id": "id_oqtf", "q": { "fr": "Avez vous fait l'objet d'une Obligation de Quitter le Territoire Français (OQTF)&nbsp;?", "cn": "您是否被法国强行要求离境（OQTF）&nbsp;?" }, "a": { "type": "boolean", "file": { "label": { "fr": "Document présentant l'Obligation de Quitter le Territoire Français (OQTF)", "cn": "请出示强行被要求离开法国证明（OQTF）" } } } }, { "id": "id_contestation", "q": { "fr": "La procédure est-elle en cours&nbsp;?", "cn": "现在是否还在审理中&nbsp;?" }, "a": { "type": "boolean", "file": { "label": { "fr": "Assignation du TGI, conclusions et défense", "cn": "法院传唤，判决以及辩论" } } } }, { "id": "id_contestation_conjoint", "q": { "fr": "Cette contestation a-t-elle été initiée par votre conjoint(e)&nbsp;?", "cn": "是否是您的配偶对这个判决提出的异议&nbsp;?" }, "a": { "type": "boolean" } }, { "id": "id_annul_mariage", "q": { "fr": "Une demande d'annulation ou une contestation judiciaire de votre mariage a-t-elle été réalisée&nbsp;?", "cn": "您的婚姻是否经历过纠纷或取消&nbsp;?" }, "a": { "type": "boolean" } }, { "id": "id_annul_mariage_rejet", "q": { "fr": "A-t-elle été rejetée&nbsp;?", "cn": "是否被拒绝了&nbsp;?" }, "a": { "type": "boolean", "file": { "label": { "fr": "Décision judiciaire définitive", "cn": "最终法院审理结果" } } } }, { "id": "id_annul_mariage_where", "q": { "fr": "Dans quel pays&nbsp;?", "cn": "在哪一个国家&nbsp;?" }, "a": { "type": "array", "max": 1, "values": [{ "fr": "En France", "cn": "在法国" }, { "fr": "A l'etranger", "cn": "在国外" }] } }, { "id": "id_oubli_pieces2", "q": { "fr": "Aviez-vous fourni les pièces suivantes&nbsp;?", "cn": "您是否提交了以下材料&nbsp;?" }, "a": { "type": "array", "min": 1, "files": [{ "condition": "v.includes(0)", "label": { "fr": "Justificatif de ressources financières suffisantes", "cn": "证明有充足的经济来源" } }, { "condition": "v.includes(1)", "label": { "fr": "Le Cerfa 14571*04", "cn": "CERFA文件 14571*04" } }, { "condition": "v.includes(2)", "label": { "fr": "Justificatif de maîtrise de la langue française", "cn": "法语水平证明" } }, { "condition": "v.includes(3)", "label": { "fr": "Justificatifs de mariage", "cn": "婚姻证明" } }, { "condition": "v.includes(4)", "label": { "fr": "Document de voyage en cours de validité (passeport, etc.)", "cn": "在有效期之内的旅行证件（护照等等）" } }], "values": [{ "fr": "Justificatif de ressources financières", "cn": "经济来源充足证明" }, { "fr": "Le Cerfa 14571*04", "cn": "CERFA文件 14571*03" }, { "fr": "Justificatif de connaissance de la langue française", "cn": "法语水平证明" }, { "fr": "Certificat de mariage", "cn": "婚姻证明" }, { "fr": "Document de voyage en cours de validité (passeport etc.)", "cn": "在有效期之内的旅游证件（护照等等）" }] } }, { "id": "id_conjoint_civilite", "q": { "fr": "Civilité de votre conjoint(e)", "cn": "您的配偶性别" }, "a": { "type": "array", "display": "radio", "min": 1, "max": 1, "values": [{ "fr": "Monsieur", "cn": "先生" }, { "fr": "Madame", "cn": "女士" }] } }, { "id": "id_conjoint_prenom", "q": { "fr": "Prénom de votre conjoint(e)", "cn": "您的配偶名" }, "a": { "type": "text", "min": 1, "error-message": { "fr": "Prénom requis", "cn": "获得的名字" } } }, { "id": "id_conjoint_nom", "q": { "fr": "Nom de votre conjoint(e)", "cn": "您的配偶的姓氏" }, "a": { "type": "text", "min": 1, "error-message": { "fr": "Nom requis", "cn": "获得的姓氏" } } }, { "id": "id_date_debut_relation", "q": { "fr": "Quand a débuté votre relation avec votre conjoint(e)&nbsp;? (appoximativement)", "cn": "您和配偶的关系何时建立&nbsp;?(大概时间)" }, "a": { "type": "date" } }, { "id": "id_vie_commune", "q": { "fr": "Vivez-vous actuellement avec votre conjoint(e)&nbsp;?", "cn": "您是否现在和您的配偶一起生活&nbsp;?" }, "a": { "type": "boolean" } }, { "id": "id_vie_commune_before", "q": { "fr": "Avez-vous vécu avec votre conjoint(e)&nbsp;?", "cn": "您是否和您的配偶一起生活过&nbsp;?" }, "a": { "type": "boolean" } }, { "id": "id_preuve_visite", "q": { "fr": "Pouvez vous fournir des preuves de vos visites ou de ses visites&nbsp;?", "cn": "您是否可以提供您或您的配偶的探访证明&nbsp;?" }, "a": { "type": "boolean", "file": { "label": { "fr": "Preuve(s) de vos visites chez votre conjoint(e) ou de ses visites", "cn": "请提供您或您的配偶的探访证明" } } } }, { "id": "id_courrier_echange", "q": { "fr": "Pouvez vous fournir des courriers échangés entre vous et votre conjoint(e) depuis votre mariage&nbsp;?", "cn": "您是否可以提供您和配偶在结婚后的来往信件&nbsp;?" }, "a": { "type": "boolean", "file": { "label": { "fr": "Courriers échangés entre vous et votre conjoint(e) depuis votre mariage", "cn": "请提供您和配偶在结婚后的来往信件" } } } }, { "id": "id_releve_teleph", "q": { "fr": "Pouvez vous fournir des relevés téléphoniques prouvant des échanges réguliers entre vous&nbsp;?", "cn": "您是否可以提供您和您的配偶固定通话的电话单&nbsp;?" }, "a": { "type": "boolean", "file": { "label": { "fr": "Relevés téléphoniques prouvant des échanges réguliers entre vous et votre conjoint(e)&nbsp;?", "cn": "请提供您和您的配偶固定通话的电话单" } } } }, { "id": "id_duree_vie_commune", "q": { "fr": "Depuis combien de temps&nbsp;? (en mois)", "cn": "持续了多久&nbsp;?(以月为单位)" }, "a": { "type": "number" } }, { "id": "id_facture_dom", "q": { "fr": "Pouvez vous fournir des factures établies à votre nom et à son nom à la même adresse&nbsp;?", "cn": "您是否可以提供可以提供写着您两位姓名的共同账单&nbsp;?" }, "a": { "type": "boolean", "file": { "label": { "fr": "Factures établies à votre nom et au nom de votre conjoint(e) à la même adresse&nbsp;?", "cn": "请提供此账单&nbsp;?" } } } }, { "id": "id_compte_joint", "q": { "fr": "Possédez vous un compte bancaire joint (commun avec votre conjoint(e))&nbsp;?", "cn": "您是否和配偶有共用银行账户&nbsp;?" }, "a": { "type": "boolean", "file": { "label": { "fr": "Relevé compte bancaire (commun avec votre conjoint(e)) joint ou une attestation de compte bancaire", "cn": "您和配偶的共用账户流水单" } } } }, { "id": "id_adresse_logement", "q": { "fr": "A quelle adresse vivrez vous une fois votre Visa obtenu&nbsp;? (rue, ville)", "cn": "您的签证一旦拿到，会再哪个地方居住&nbsp;?（街道，城市）" }, "a": { "type": "text" } }, { "id": "id_adresse_logement_coinjoint", "q": { "fr": "Est ce le domicile de votre conjoint(e)&nbsp;?", "cn": "这是否是您的配偶的家庭地址&nbsp;?" }, "a": { "type": "boolean" } }, { "id": "id_preuve_logement", "q": { "fr": "Pouvez vous fournir un preuve de logement&nbsp;?", "cn": "您是否可以提供住房证明&nbsp;?" }, "a": { "type": "boolean", "file": { "label": { "fr": "Preuve de logement (bail établi au nom du conjoint(e) et/ou facture établie au nom du conjoint(e))", "cn": "住房证明（写有配偶姓名的房屋合同或账单）" } } } }, { "id": "id_preuve_revenus", "q": { "fr": "Pouvez vous fournir un bulletin de paie ou l'avis d'imposition de votre conjoint(e)&nbsp;?", "cn": "请提供您的配偶的工资单或者纳税通知&nbsp;?" }, "a": { "type": "boolean", "file": { "label": { "fr": "Bulletin de paie ou l'avis d'imposition de votre conjoint(e)", "cn": "您的配偶的工资单或纳税通知" } } } }, { "id": "id_photo_mariage", "q": { "fr": "Pouvez-vous fournir une photographie de votre couple et/ou de votre mariage&nbsp;?", "cn": "请提供情侣照片或者结婚照&nbsp;?" }, "a": { "type": "boolean", "file": { "label": { "fr": "Photographie du couple", "cn": "夫妇照片" } } } }, { "id": "id_child_majeur", "q": { "fr": "Votre conjoint(e) a il/elle un ou des enfants majeurs&nbsp;?", "cn": "您的配偶是否有成年的孩子&nbsp;?" }, "a": { "type": "boolean" } }, { "id": "id_attestation_child", "q": { "fr": "Acceptent-ils de témoigner de la réalité de votre union&nbsp;?", "cn": "他们是否接受为您提供家庭团聚证明&nbsp;?" }, "a": { "type": "boolean", "file": { "label": { "fr": "Attestation de(s) enfant(s) de votre conjoint(e) témoignant de la réalité de votre union", "cn": "您的配偶提供的家庭团聚证明" } } } }, { "id": "id_mychild", "q": { "fr": "Avez-vous des enfants&nbsp;?", "cn": "您是否有孩子&nbsp;?" }, "a": { "type": "boolean" } }, { "id": "id_attestation_mychild", "q": { "fr": "Acceptent-ils de témoigner de la réalité de votre union&nbsp;?", "cn": "他们是否接受提供给您家庭团聚证明&nbsp;?" }, "a": { "type": "boolean", "file": { "label": { "fr": "Attestation de vos enfant(s) témoignant de la réalité de votre union", "cn": "您的孩子提供的家庭团聚证明" } } } }, { "id": "id_attestation_proche", "q": { "fr": "Avez-vous des proches pouvant attester de la réalité de votre union&nbsp;?", "cn": "您是否有亲友提供的家庭团聚证明&nbsp;?" }, "a": { "type": "boolean", "file": { "label": { "fr": "Attestation de proches témoignant de la réalité de votre union", "cn": "您亲友提供的家庭团聚证明" } } } }, { "id": "id_proj_pro_exist", "q": { "fr": "Souhaitez vous avoir un emploi dès votre arrivée en France&nbsp;?", "cn": "您是否希望在到法之后有一份工作&nbsp;?" }, "a": { "type": "boolean" } }, { "id": "id_promesse_job", "q": { "fr": "Avez vous une promesse d'embauche&nbsp;?", "cn": "您是否有聘用证明&nbsp;?" }, "a": { "type": "boolean", "file": { "label": { "fr": "Promesse d'embauche", "cn": "聘用证明" } } } }, { "id": "id_future_diploma_exist", "q": { "fr": "Souhaitez vous réaliser des études en France&nbsp;?", "cn": "您是否希望在法国学习&nbsp;?" }, "a": { "type": "boolean" } }, { "id": "id_oqtf_where", "q": { "fr": "Dans quel pays&nbsp;?", "cn": "哪个国家&nbsp;?" }, "a": { "type": "text" } }, { "id": "id_oqtf_when", "q": { "fr": "Quand&nbsp;?", "cn": "何时&nbsp;?" }, "a": { "type": "date" } }, { "id": "id_confirmation_fichier", "q": { "fr": "Avez-vous bien complété votre dossier en téléchargant tous les documents requis&nbsp;?", "cn": "您是否已经下载并完成填写要求的文件&nbsp;?" }, "a": { "type": "boolean" } }, { "id": "id_incomplet", "q": { "fr": "Vous devez complèter votre dossier avant de l'envoyer en relecture auprès nos experts.", "cn": "在提交给我们的专家之前，请您应该完成填写您的文件" } }, { "id": "id_relecture", "q": { "fr": "Votre dossier est prêt à être envoyé à nos experts pour une relecture. Avez-vous bien terminé vos modifications&nbsp;?", "cn": "您的文件已经准备好发给我们的重审专员。您是否确认您完成了修改&nbsp;?" }, "a": { "type": "check", "value": { "fr": "Je confirme avoir complété mon dossier", "cn": "我确认完成了我的文件" } } }, { "id": "id_attente_relecture", "q": { "fr": "Votre dossier est en cours de relecture.", "cn": "您的文件正在被重审" } }, { "id": "id_telechargement", "q": { "fr": "La relecture est terminée, vous pouvez telecharger votre document.", "cn": "重审完毕，您可以下载文件" } }, { "id": "id_voyagetour_date", "q": { "fr": "Quand est prévu votre déplacement en France&nbsp;?", "cn": "您定在什么时候来法&nbsp;?" }, "a": { "type": "date" } }, { "id": "id_motif_quoi3", "q": { "fr": "Lesquels&nbsp;?", "cn": "是那些&nbsp;?" }, "a": { "type": "array", "min": 1, "values": [{ "fr": "Le document de voyage présenté est faux/falsifié", "cn": "您提供的旅游证明是假的或伪造的" }, { "fr": "L'objet et les conditions du séjour envisagé n'ont pas été justifiés", "cn": "您在法国的居住生活情况没有任何证明" }, { "fr": "Vous n'avez pas fourni la preuve que vous disposez de moyens de subsistance suffisants", "cn": "您没有提供有效的经济来源充足证明" }, { "fr": "Vous avez déjà séjourné sur le territoire des Etats membres pendant plus de 3 mois au cours de la période de 6 mois en cours", "cn": "您已经在六个月有效期内在法属地区居住超过三个月" }, { "fr": "Vous avez fait l'objet d'un signalement aux fins de non-admission dans le système d'information Schengen", "cn": "您在申根系统内被认定为不可获得签证的一类" }, { "fr": "Un ou plusieurs Etats membres estiment que vous représentez une menace pour l'ordre public, la sécurité nationale ou la santé publique ou pour les relations internationales d'un ou plusieurs Etats membres", "cn": "一个或多个法属地区证明您对公共秩序，国家安全和公共健康或对一个或多个法属地区的国际关系存在威胁，" }, { "fr": "Vous n'avez pas présenté d'éléments attestant que vous êtes titulaire d'une assurance maladie en voyage", "cn": "您没有提供您是旅行保险持有者的证明" }, { "fr": "Les informations communiquées pour justifier l'objet et les conditions du séjour envisagé ne sont pas fiables", "cn": "您提供的在法生活居住或从事活动的证明并不可靠" }, { "fr": "Votre volonté de quitter le territoire des Etats membres avant l'expiration du visa n'a pas être établie", "cn": "您在签证到期后离开成员地区的主动性不强" }] } }], "screens": [{ "id": "start", "entry-point": "s0", "states": [{ "id": "s0", "qid": "id_tiers", "transitions": [{ "target-screen": "eligibilite", "condition": "v == 0" }, { "target": "s1", "condition": "v == 1" }, { "target": "s2", "condition": "v == 2" }] }, { "id": "s1", "qid": "id_compris", "transitions": [{ "target-screen": "eligibilite", "condition": "v == true" }] }, { "id": "s2", "qid": "id_other_already_here", "transitions": [{ "target": "s3", "condition": "v == true" }, { "target": "s4" }] }, { "id": "s3", "qid": "id_really_already_here", "transitions": [{ "target-screen": "oqtf", "condition": "v == true" }, { "target": "s4" }] }, { "id": "s4", "qid": "id_visa_really", "transitions": [{ "target-screen": "ko", "condition": "v == false" }, { "target-screen": "checkout" }] }] }, { "id": "eligibilite", "entry-point": "s3", "states": [{ "id": "s3", "qid": "id_crrv", "transitions": [{ "target": "s4", "condition": "v == false" }, { "target": "s31" }] }, { "id": "s31", "qid": "id_crrv_type_recours", "transitions": [{ "target": "s4", "condition": "v.includes(0) && !v.includes(1) && !v.includes(2)" }, { "target": "s32", "condition": "v.includes(1) || v.includes(2)" }] }, { "id": "s32", "qid": "id_courrier_crrv", "transitions": [{ "target": "s34", "condition": "v == false" }, { "target": "s33" }] }, { "id": "s33", "qid": "id_when_refus_crrv", "transitions": [{ "target": "s35", "condition": "mfrancs_lte(v, 2) == true" }, { "target-screen": "ko", "condition": "mfrancs_lte(v, 2) != true" }] }, { "id": "s34", "qid": "id_when_crrv", "transitions": [{ "target": "s35", "condition": "mfrancs_lte(v, 4) == true" }, { "target-screen": "ko", "condition": "mfrancs_lte(v, 4) != true" }] }, { "id": "s35", "qid": "id_when_app", "transitions": [{ "target": "s61" }] }, { "id": "s4", "qid": "id_when_app", "transitions": [{ "target": "s6", "condition": "mfrancs_lte(v, 4) == true" }, { "target": "s5", "condition": "mfrancs_lte(v, 4) != true" }] }, { "id": "s5", "qid": "id_app_indiq", "transitions": [{ "condition": "v == true", "target-screen": "ko" }, { "condition": "v == false", "target": "s6" }] }, { "id": "s6", "qid": "id_courr_refus", "transitions": [{ "condition": "v == true", "target": "s7" }, { "condition": "v == false", "target-screen": "consulat" }] }, { "id": "s7", "qid": "id_when_refus", "transitions": [{ "condition": "mfrancs_lte(v, 2) == true", "target-screen": "consulat" }, { "condition": "mfrancs_lte(v, 2) == false", "target": "s8" }] }, { "id": "s8", "qid": "id_courr_indiq", "transitions": [{ "condition": "v == true", "target-screen": "ko" }, { "condition": "v == false", "target-screen": "consulat" }] }, { "id": "s61", "qid": "id_courr_refus", "transitions": [{ "condition": "v == true", "target": "s71" }, { "condition": "v == false", "target-screen": "consulat" }] }, { "id": "s71", "qid": "id_when_refus", "transitions": [{ "target-screen": "consulat" }] }] }, { "id": "consulat", "entry-point": "s1", "states": [{ "id": "s1", "qid": "id_user_country", "transitions": [{ "target": "s2" }] }, { "id": "s2", "qid": "id_demande_visa", "transitions": [{ "target": "s3", "condition": "v == false" }, { "target": "s4" }] }, { "id": "s3", "qid": "id_user_visacountry", "transitions": [{ "target": "s4" }] }, { "id": "s4", "qid": "id_consul", "transitions": [{ "target-screen": "motif" }] }] }, { "id": "motif", "entry-point": "s1", "states": [{ "id": "s1", "qid": "id_howlong", "transitions": [{ "target": "s2", "condition": "v == 0" }, { "target": "s3", "condition": "v == 1" }] }, { "id": "s2", "qid": "id_why", "transitions": [{ "target-screen": "motifs refus", "condition": "v == 0" }, { "target-screen": "conjoint", "condition": "v == 1" }, { "target-screen": "motifs refus long sejour", "condition": "v == 2" }, { "target-screen": "motifs refus long sejour", "condition": "v == 3" }, { "target-screen": "motifs refus long sejour", "condition": "v == 4" }, { "target-screen": "motifs refus long sejour", "condition": "v == 5" }, { "target-screen": "motifs refus long sejour", "condition": "v == 6" }, { "target-screen": "motifs refus long sejour", "condition": "v == 7" }, { "target-screen": "motifs refus long sejour", "condition": "v == 8" }, { "target": "s21", "condition": "v == 9" }] }, { "id": "s21", "qid": "id_why_other", "transitions": [{ "target-screen": "motifs refus long sejour" }] }, { "id": "s3", "qid": "id_why_short", "transitions": [{ "target-screen": "deplacement", "condition": "v == 0" }, { "target-screen": "deplacement", "condition": "v == 1" }, { "target-screen": "deplacement", "condition": "v == 2" }, { "target-screen": "deplacement", "condition": "v == 3" }, { "target-screen": "deplacement", "condition": "v == 4" }, { "target-screen": "deplacement", "condition": "v == 5" }, { "target-screen": "deplacement", "condition": "v == 6" }, { "target-screen": "deplacement", "condition": "v == 7" }, { "target-screen": "deplacement", "condition": "v == 8" }, { "target-screen": "deplacement", "condition": "v == 9" }, { "target": "s31", "condition": "v == 10" }] }, { "id": "s31", "qid": "id_why_short_other", "transitions": [{ "target-screen": "deplacement" }] }] }, { "id": "motifs refus long sejour", "entry-point": "s1", "states": [{ "id": "s1", "qid": "id_courr_motif", "transitions": [{ "target-screen": "checkout", "condition": "v == false" }, { "target": "s2", "condition": "v == true" }] }, { "id": "s2", "qid": "id_motif_quoi_longsejour", "transitions": [{ "target-screen": "checkout" }] }] }, { "id": "motifs refus", "entry-point": "s1", "states": [{ "id": "s1", "qid": "id_courr_motif", "transitions": [{ "target-screen": "checkout", "condition": "v == false" }, { "target": "s2", "condition": "v == true" }] }, { "id": "s2", "qid": "id_motif_quoi", "transitions": [{ "target": "s0m", "condition": "v.includes(0)" }, { "target": "s1m", "condition": "v.includes(1)" }, { "target": "s2m", "condition": "v.includes(2)" }, { "target": "s3m", "condition": "v.includes(3)" }, { "target": "s5m", "condition": "v.includes(5)" }, { "target-screen": "checkout", "condition": "v.includes(4) || v.includes(6)" }] }, { "id": "s0m", "qid": "id_oubli_ress", "transitions": [{ "target": "s1m", "condition": "values.id_motif_quoi.includes(1)" }, { "target": "s2m", "condition": "values.id_motif_quoi.includes(2)" }, { "target": "s3m", "condition": "values.id_motif_quoi.includes(3)" }, { "target": "s5m", "condition": "values.id_motif_quoi.includes(5)" }, { "target-screen": "checkout", "condition": "values.id_motif_quoi.includes(4)" }, { "target-screen": "checkout", "condition": "v == false" }, { "target-screen": "checkout", "condition": "v == true" }] }, { "id": "s1m", "qid": "id_oubli_conn", "transitions": [{ "target": "s2m", "condition": "values.id_motif_quoi.includes(2)" }, { "target": "s3m", "condition": "values.id_motif_quoi.includes(3)" }, { "target": "s5m", "condition": "values.id_motif_quoi.includes(5)" }, { "target-screen": "checkout", "condition": "values.id_motif_quoi.includes(4)" }, { "target-screen": "checkout", "condition": "v == false || v['id_oubli_ress'] == false" }, { "target-screen": "checkout", "condition": "v == true" }] }, { "id": "s2m", "qid": "id_oubli_inscrip", "transitions": [{ "target": "s3m", "condition": "values.id_motif_quoi..includes(3)" }, { "target": "s5m", "condition": "values.id_motif_quoi..includes(5)" }, { "target-screen": "checkout", "condition": "values.id_motif_quoi.includes(4)" }, { "target-screen": "checkout", "condition": "v == false || v.id_oubli_ress == false || v.id_oubli_conn == false" }, { "target-screen": "checkout", "condition": "v == true" }] }, { "id": "s3m", "qid": "id_oubli_inscrip_cash", "transitions": [{ "target": "s5m", "condition": "values.id_motif_quoi.includes(5)" }, { "target-screen": "checkout", "condition": "values.id_motif_quoi.includes(4)" }, { "target-screen": "checkout", "condition": "v == false || v.id_oubli_ress == false || v.id_oubli_conn == false || v.id_oubli_inscrip == false" }, { "target-screen": "checkout", "condition": "v == true" }] }, { "id": "s5m", "qid": "id_oubli_pieces", "transitions": [{ "target-screen": "checkout", "condition": "v == false || v.id_oubli_ress == false || v.id_oubli_conn == false || v.id_oubli_inscrip == false" }, { "target-screen": "checkout" }] }] }, { "id": "parcours etudiant", "entry-points": [{ "target-screen": "projet professionnel", "condition": "isFrancophone(values.id_user_country)" }, { "target": "s2", "condition": "isFrenchSpeaking(values.id_user_country)" }, { "target": "s3" }], "states": [{ "id": "s2", "qid": "id_multi_totetud", "transitions": [{ "target": "s3", "condition": "v == false" }, { "target": "s2.1", "condition": "v == true" }] }, { "id": "s2.1", "qid": "id_multi_where", "transitions": [{ "target": "s3.2" }] }, { "id": "s3", "qid": "id_partetud", "transitions": [{ "target": "s3.1", "condition": "v == true" }, { "target": "s3.2", "condition": "v == false" }] }, { "id": "s3.1", "qid": "id_partetud_where", "transitions": [{ "target": "s3.2" }] }, { "id": "s3.2", "qid": "id_franc_dipl", "transitions": [{ "target": "s3.3", "condition": "v == true && values.id_user_country == 32" }, { "target-screen": "projet professionnel" }] }, { "id": "s3.3", "qid": "id_chin_dipl", "transitions": [{ "target-screen": "projet professionnel" }] }] }, { "id": "projet professionnel", "entry-point": "s1", "states": [{ "id": "s1", "qid": "id_proj_pro", "transitions": [{ "target": "s2" }] }, { "id": "s2", "qid": "id_last_diploma_name", "transitions": [{ "target": "s3" }] }, { "id": "s3", "qid": "id_last_diploma_when", "transitions": [{ "target": "s4" }] }, { "id": "s4", "qid": "id_last_diploma_rank", "transitions": [{ "target": "s5" }] }, { "id": "s5", "qid": "id_last_diploma_school", "transitions": [{ "target-screen": "projet futur" }] }] }, { "id": "projet futur", "entry-point": "s1", "states": [{ "id": "s1", "qid": "id_future_diploma_name", "transitions": [{ "target": "s2" }] }, { "id": "s2", "qid": "id_future_diploma_school", "transitions": [{ "target": "s3" }] }, { "id": "s3", "qid": "id_future_diploma_year", "transitions": [{ "target": "s4" }] }, { "id": "s4", "qid": "id_future_reco_prof", "transitions": [{ "target": "s5" }] }, { "id": "s5", "qid": "id_future_reco_proche", "transitions": [{ "target-screen": "bourse" }] }] }, { "id": "bourse", "entry-point": "s1", "states": [{ "id": "s1", "qid": "id_bourse", "transitions": [{ "target": "s2", "condition": "v == true" }, { "target-screen": "tests francais" }] }, { "id": "s2", "qid": "id_bourse_what", "transitions": [{ "target-screen": "cours lv" }] }] }, { "id": "tests francais", "entry-point": "s1", "states": [{ "id": "s1", "qid": "id_tage", "transitions": [{ "target-screen": "cours lv", "condition": "v == true && values.id_user_country == 32" }, { "target-screen": "voyage", "condition": "isFrancophone(values.id_user_country)" }, { "target-screen": "cours lv", "condition": "isFrenchSpeaking(values.id_user_country) && values.id_multi_totetud ==1" }, { "target": "s2" }] }, { "id": "s2", "qid": "id_test", "transitions": [{ "target-screen": "cours lv", "condition": "v == false" }, { "target": "s3" }] }, { "id": "s3", "qid": "id_test_what", "transitions": [{ "target": "s3.0", "condition": "v.includes(0)" }, { "target": "s3.1", "condition": "v.includes(1)" }, { "target": "s3.2", "condition": "v.includes(2)" }, { "target": "s3.3", "condition": "v.includes(3)" }] }, { "id": "s3.0", "qid": "id_tcf_what", "transitions": [{ "target": "s3.0.0" }] }, { "id": "s3.0.0", "qid": "id_tcf_when", "transitions": [{ "target": "s3.0.1" }] }, { "id": "s3.0.1", "qid": "id_tcf_score", "transitions": [{ "target-screen": "cours lv" }] }, { "id": "s3.1", "qid": "id_tef_when", "transitions": [{ "target": "s3.1.0" }] }, { "id": "s3.1.0", "qid": "id_tef_score", "transitions": [{ "target-screen": "cours lv" }] }, { "id": "s3.2", "qid": "id_delf_what", "transitions": [{ "target-screen": "cours lv" }] }, { "id": "s3.3", "qid": "id_dalf_what", "transitions": [{ "target-screen": "cours lv" }] }] }, { "id": "cours lv", "entry-point": "s1", "states": [{ "id": "s1", "qid": "id_lv", "transitions": [{ "target": "s2", "condition": "v == true" }, { "target-screen": "voyage" }] }, { "id": "s2", "qid": "id_bulletin_french", "transitions": [{ "target": "s3" }] }, { "id": "s3", "qid": "id_reco_french", "transitions": [{ "target": "s4" }] }, { "id": "s4", "qid": "id_cours_encore", "transitions": [{ "target-screen": "voyage" }] }] }, { "id": "voyage", "entry-point": "s1", "states": [{ "id": "s1", "qid": "id_voyage", "transitions": [{ "target": "s2" }] }, { "id": "s2", "qid": "id_memoire", "transitions": [{ "target-screen": "condition ressources", "condition": "values.id_why == 0" }, { "target-screen": "parcours ordre public", "condition": "values.id_why == 1" }] }] }, { "id": "condition ressources", "entry-point": "s1", "states": [{ "id": "s1", "qid": "id_revenue", "transitions": [{ "target": "s2", "condition": "v == true" }, { "target": "s3", "condition": "v == false" }] }, { "id": "s2", "qid": "id_rev_amount", "transitions": [{ "target": "s2.1" }] }, { "id": "s2.1", "qid": "id_rev_from", "transitions": [{ "target": "s2.1.0", "condition": "v.includes(0)" }, { "target": "s2.1.1", "condition": "v.includes(1)" }, { "target": "s2.1.2", "condition": "v.includes(2)" }, { "target": "s4" }] }, { "id": "s2.1.0", "qid": "id_rev_what", "transitions": [{ "target": "s4" }] }, { "id": "s2.1.1", "qid": "id_rev_how", "transitions": [{ "target": "s4" }] }, { "id": "s2.1.2", "qid": "id_rev_bourse", "transitions": [{ "target": "s4" }] }, { "id": "s3", "qid": "id_cash", "transitions": [{ "target": "s3.1", "condition": "v == true" }, { "target": "s4" }] }, { "id": "s3.1", "qid": "id_cash_amount", "transitions": [{ "target": "s4" }] }, { "id": "s4", "qid": "id_nature", "transitions": [{ "target-screen": "parcours ordre public" }] }] }, { "id": "parcours ordre public", "entry-points": [{ "target": "s1", "condition": "values.id_why == 0 && values.id_motif_quoi && values.id_motif_quoi.includes(4)" }, { "target": "s1", "condition": "values.id_why == 1 && values.id_motif_quoi && values.id_motif_quoi2.includes(3)" }, { "target-screen": "summary" }], "states": [{ "id": "s1", "qid": "id_casier", "transitions": [{ "target-screen": "summary", "condition": "values.id_why == 0 && v == true" }, { "target": "s3", "condition": "values.id_why == 1 && v == true" }, { "target": "s2", "condition": "v == false" }] }, { "id": "s2", "qid": "id_casier_when", "transitions": [{ "target-screen": "summary", "condition": "values.id_why == 0" }, { "target": "s3" }] }, { "id": "s3", "qid": "id_oqtf", "transitions": [{ "target-screen": "summary", "condition": "v == false" }, { "target": "s4" }] }, { "id": "s4", "qid": "id_oqtf_where", "transitions": [{ "target": "s5" }] }, { "id": "s5", "qid": "id_oqtf_when", "transitions": [{ "target-screen": "summary" }] }] }, { "id": "conjoint", "entry-point": "s1", "states": [{ "id": "s1", "qid": "id_user_birthdate", "transitions": [{ "target": "s2" }] }, { "id": "s2", "qid": "id_why_who", "transitions": [{ "target": "s3", "condition": "v == 0" }, { "target": "s21" }] }, { "id": "s21", "qid": "id_why_who_other", "transitions": [{ "target-screen": "motifs refus long sejour" }] }, { "id": "s3", "qid": "id_mariage_where", "transitions": [{ "target-screen": "motif conjoint", "condition": "v == 0" }, { "target": "s4", "condition": "v == 1" }] }, { "id": "s4", "qid": "id_mariage_acte_transcrit", "transitions": [{ "target": "s5", "condition": "v == false" }, { "target-screen": "motif conjoint", "condition": "v == true" }] }, { "id": "s5", "qid": "id_mariage_acte_etranger", "transitions": [{ "target": "s6", "condition": "v == true" }, { "target-screen": "ko" }] }, { "id": "s6", "qid": "id_CCAM", "transitions": [{ "target-screen": "motif conjoint", "condition": "v == true" }, { "target-screen": "ko" }] }] }, { "id": "motif conjoint", "entry-point": "s1", "states": [{ "id": "s1", "qid": "id_courr_motif", "transitions": [{ "target-screen": "checkout", "condition": "v == false" }, { "target": "s2" }] }, { "id": "s2", "qid": "id_motif_quoi2", "transitions": [{ "target": "s0m", "condition": "v.includes(0)" }, { "target": "s2m", "condition": "v.includes(2)" }, { "target": "s4m", "condition": "v.includes(4)" }, { "target-screen": "checkout", "condition": "v.includes(1) || v.includes(3) || v.includes(5)" }] }, { "id": "s0m", "qid": "id_oqtf", "transitions": [{ "target": "s2m", "condition": "values.id_motif_quoi2.includes(2)" }, { "target": "s4m", "condition": "values.id_motif_quoi2.includes(4)" }, { "target-screen": "checkout" }] }, { "id": "s2m", "qid": "id_contestation", "transitions": [{ "target": "s2m1", "condition": "v == true" }, { "target": "s2m2", "condition": "v == false" }] }, { "id": "s2m1", "qid": "id_contestation_conjoint", "transitions": [{ "target": "s4m", "condition": "v == false || values.id_motif_quoi2.includes(4)" }, { "target-screen": "contact avocat", "condition": "v == true" }] }, { "id": "s2m2", "qid": "id_annul_mariage_rejet", "transitions": [{ "target": "s2m3", "condition": "v == true" }, { "target-screen": "contact avocat", "condition": "v == false" }] }, { "id": "s2m3", "qid": "id_annul_mariage_where", "transitions": [{ "target": "s4m", "condition": "values.id_motif_quoi2.includes(4)" }, { "target-screen": "checkout" }] }, { "id": "s4m", "qid": "id_oubli_pieces2", "transitions": [{ "target-screen": "checkout" }] }] }, { "id": "parcours conjoint", "entry-point": "s1", "states": [{ "id": "s1", "qid": "id_conjoint_civilite", "transitions": [{ "target": "s2" }] }, { "id": "s2", "qid": "id_conjoint_prenom", "transitions": [{ "target": "s3" }] }, { "id": "s3", "qid": "id_conjoint_nom", "transitions": [{ "target": "s4" }] }, { "id": "s4", "qid": "id_date_debut_relation", "transitions": [{ "target": "s5" }] }, { "id": "s5", "qid": "id_vie_commune", "transitions": [{ "target": "s6aa", "condition": "v == false" }, { "target": "s6b", "condition": "v == true" }] }, { "id": "s6aa", "qid": "id_vie_commune_before", "transitions": [{ "target": "s6a" }] }, { "id": "s6a", "qid": "id_preuve_visite", "transitions": [{ "target": "s7a" }] }, { "id": "s7a", "qid": "id_courrier_echange", "transitions": [{ "target": "s8" }] }, { "id": "s6b", "qid": "id_duree_vie_commune", "transitions": [{ "target": "s7b" }] }, { "id": "s7b", "qid": "id_facture_dom", "transitions": [{ "target": "s8" }] }, { "id": "s8", "qid": "id_releve_teleph", "transitions": [{ "target": "s9" }] }, { "id": "s9", "qid": "id_compte_joint", "transitions": [{ "target-screen": "domicile conjoint" }] }] }, { "id": "domicile conjoint", "entry-point": "s1", "states": [{ "id": "s1", "qid": "id_adresse_logement", "transitions": [{ "target": "s2" }] }, { "id": "s2", "qid": "id_adresse_logement_coinjoint", "transitions": [{ "target": "s3" }] }, { "id": "s3", "qid": "id_preuve_logement", "transitions": [{ "target": "s4" }] }, { "id": "s4", "qid": "id_preuve_revenus", "transitions": [{ "target": "s5" }] }, { "id": "s5", "qid": "id_photo_mariage", "transitions": [{ "target": "s6" }] }, { "id": "s6", "qid": "id_child_majeur", "transitions": [{ "target": "s7", "condition": "v == false" }, { "target": "s6a", "condition": "v == true" }] }, { "id": "s6a", "qid": "id_attestation_child", "transitions": [{ "target": "s7" }] }, { "id": "s7", "qid": "id_mychild", "transitions": [{ "target": "s9", "condition": "v == false" }, { "target": "s8", "condition": "v == true" }] }, { "id": "s8", "qid": "id_attestation_mychild", "transitions": [{ "target": "s9" }] }, { "id": "s9", "qid": "id_attestation_proche", "transitions": [{ "target-screen": "projet professionnel conjoint" }] }] }, { "id": "projet professionnel conjoint", "entry-point": "s1", "states": [{ "id": "s1", "qid": "id_proj_pro_exist", "transitions": [{ "target": "s2", "condition": "v == true" }, { "target": "s3", "condition": "v == false" }] }, { "id": "s2", "qid": "id_proj_pro", "transitions": [{ "target": "s2a" }] }, { "id": "s2a", "qid": "id_promesse_job", "transitions": [{ "target": "s2b" }] }, { "id": "s2b", "qid": "id_last_diploma_name", "transitions": [{ "target-screen": "tests francais" }] }, { "id": "s3", "qid": "id_future_diploma_exist", "transitions": [{ "target": "s3a", "condition": "v == true" }, { "target-screen": "tests francais" }] }, { "id": "s3a", "qid": "id_future_diploma_name", "transitions": [{ "target": "s3b" }] }, { "id": "s3b", "qid": "id_future_diploma_school", "transitions": [{ "target-screen": "tests francais" }] }] }, { "id": "deplacement", "entry-point": "s1", "states": [{ "id": "s1", "qid": "id_voyagetour_date", "transitions": [{ "target-screen": "motif court sejour" }] }] }, { "id": "motif court sejour", "entry-point": "s1", "states": [{ "id": "s1", "qid": "id_courr_motif", "transitions": [{ "target-screen": "checkout", "condition": "v == false" }, { "target": "s2" }] }, { "id": "s2", "qid": "id_motif_quoi3", "transitions": [{ "target-screen": "checkout", "condition": "v.includes(0) || v.includes(1) || v.includes(2) || v.includes(3) || v.includes(4) || v.includes(5) || v.includes(6) || v.includes(7) || v.includes(8) || v.includes(9)" }] }] }, { "id": "parcours stage formation", "entry-points": [{ "target-screen": "summary" }] }, { "id": "parcours etablissement", "entry-points": [{ "target-screen": "summary" }] }, { "id": "parcours professionnelle", "entry-points": [{ "target-screen": "summary" }] }, { "id": "parcours mariage", "entry-points": [{ "target-screen": "summary" }] }, { "id": "parcours visa retour", "entry-points": [{ "target-screen": "summary" }] }, { "id": "parcours medicale", "entry-points": [{ "target-screen": "summary" }] }, { "id": "parcours fonctions officielles", "entry-points": [{ "target-screen": "summary" }] }, { "id": "parcours autre", "entry-points": [{ "target-screen": "summary" }] }, { "id": "parcours etude court", "entry-points": [{ "target-screen": "summary" }] }, { "id": "parcours famille court", "entry-points": [{ "target-screen": "summary" }] }, { "id": "parcours tourisme court", "entry-points": [{ "target-screen": "summary" }] }, { "id": "parcours affaire court", "entry-points": [{ "target-screen": "summary" }] }, { "id": "parcours culture court", "entry-points": [{ "target-screen": "summary" }] }, { "id": "parcours sport court", "entry-points": [{ "target-screen": "summary" }] }, { "id": "parcours officiel court", "entry-points": [{ "target-screen": "summary" }] }, { "id": "parcours medicale court", "entry-points": [{ "target-screen": "summary" }] }, { "id": "parcours transit court", "entry-points": [{ "target-screen": "summary" }] }, { "id": "parcours transit aero court", "entry-points": [{ "target-screen": "summary" }] }, { "id": "parcours autre court", "entry-points": [{ "target-screen": "summary" }] }, { "id": "parcours visa simple", "entry-point": "s1", "states": [{ "id": "s1", "qid": "id_whichvisa", "transitions": [{ "target": "s2", "condition": "v == 0" }, { "target": "s3", "condition": "v == 1" }] }, { "id": "s2", "qid": "id_why", "transitions": [{ "target-screen": "summary", "condition": "v == 0" }, { "target-screen": "summary", "condition": "v == 1" }, { "target-screen": "summary", "condition": "v == 2" }, { "target-screen": "summary", "condition": "v == 3" }, { "target-screen": "summary", "condition": "v == 4" }, { "target-screen": "summary", "condition": "v == 5" }, { "target-screen": "summary", "condition": "v == 6" }, { "target-screen": "summary", "condition": "v == 7" }, { "target-screen": "summary", "condition": "v == 8" }, { "target": "s21", "condition": "v == 9" }] }, { "id": "s21", "qid": "id_why_other", "transitions": [{ "target-screen": "summary" }] }, { "id": "s3", "qid": "id_why_short", "transitions": [{ "target": "s4", "condition": "v == 0" }, { "target": "s4", "condition": "v == 1" }, { "target": "s4", "condition": "v == 2" }, { "target": "s4", "condition": "v == 3" }, { "target": "s4", "condition": "v == 4" }, { "target": "s4", "condition": "v == 5" }, { "target": "s4", "condition": "v == 6" }, { "target": "s4", "condition": "v == 7" }, { "target": "s4", "condition": "v == 8" }, { "target": "s4", "condition": "v == 9" }, { "target": "s31", "condition": "v == 10" }] }, { "id": "s31", "qid": "id_why_short_other", "transitions": [{ "target-screen": "summary" }] }, { "id": "s4", "qid": "id_voyagetour_date", "transitions": [{ "target-screen": "summary" }] }] }, { "id": "relecture", "entry-point": "s1", "states": [{ "id": "s1", "qid": "id_confirmation_fichier", "transitions": [{ "target": "s2", "condition": "v == false" }, { "target": "s3", "condition": "v == true" }] }, { "id": "s2", "qid": "id_incomplet" }, { "id": "s3", "qid": "id_relecture", "transitions": [{ "target-screen": "attente relecture", "condition": "v == true" }] }], "leave": [{ "call": "requestReview()", "condition": "values.id_relecture == true" }] }, { "id": "attente relecture", "entry-points": [{ "target": "s2", "condition": "values.id_relecture_terminee == true" }, { "target": "s1" }], "states": [{ "id": "s1", "qid": "id_attente_relecture", "target-screen": "" }, { "id": "s2", "qid": "id_telechargement", "transitions": [{ "target-screen": "telechargement document" }] }] }] };

/***/ }),

/***/ 356:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(110);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _slicedToArray2 = __webpack_require__(15);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _promise = __webpack_require__(14);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _ServiceAccess = __webpack_require__(10);
	
	var _ServiceAccess2 = _interopRequireDefault(_ServiceAccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  data: function data() {
	    return {
	      displayModal: false,
	      modalTitle: '',
	      modalBody: '',
	
	      initialized: false,
	      initializationError: false,
	
	      breadcrumb: 0,
	
	      show1: false,
	      show2: false,
	      show3: false,
	      show4: false,
	      show5: false,
	      show6: false,
	      show7: false,
	      show8: false,
	
	      purchases: null,
	      values: null,
	      stage: null,
	      hasValues: false,
	      displayBackButton: false,
	      saveUnfolded: window.screen.width >= 600,
	      displaySave: false
	    };
	  },
	
	  watch: {
	    '$route': function $route(to, from) {
	      var _this = this;
	
	      _ServiceAccess2.default.instance.loadStage(this.$route.params.sessionId).then(function (stage) {
	        _this.stage = stage;
	        _this.updateBreadcrumb(to, from);
	      });
	    }
	  },
	
	  updated: function updated() {
	    this.updateBinding();
	    if (!this.customVariableSet && this.values && this.values.id_user_mail) {
	      this.customVariableSet = true;
	      if (global.LC_API) {
	        global.LC_API.set_custom_variables([{ email: this.values.id_user_mail }]);
	      }
	    }
	  },
	
	  created: function created() {
	    var _this2 = this;
	
	    global.navigationBarBus.$on('navigation-display-back', this.onDisplayBackButton);
	    global.navigationBarBus.$on('info', this.onInfo);
	    global.navigationBarBus.$on('display-save', this.onDisplaySave);
	
	    var promises = [_ServiceAccess2.default.instance.purchases(this.$route.params.sessionId), _ServiceAccess2.default.instance.loadStage(this.$route.params.sessionId), _ServiceAccess2.default.instance.loadValues(this.$route.params.sessionId)];
	    _promise2.default.all(promises).then(function (responses) {
	      var _responses = (0, _slicedToArray3.default)(responses, 3),
	          purchases = _responses[0],
	          stage = _responses[1],
	          values = _responses[2];
	
	      _this2.purchases = purchases;
	      _this2.stage = stage;
	      _this2.values = values;
	
	      _this2.updateBinding();
	      _this2.updateBreadcrumb(_this2.$route);
	      _this2.initialized = true;
	    }).catch(function (err) {
	      _this2.initializationError = true;
	      console.error('Initilization Error', err);
	    });
	
	    if (navigator) {
	      _ServiceAccess2.default.instance.track(this.$route.params.sessionId, 'navigator', { appName: navigator.appName, appCodeName: navigator.appCodeName, appVersion: navigator.appVersion, language: navigator.language, platform: navigator.platform, userAgent: navigator.userAgent });
	
	      if (navigator.userAgent.indexOf('MSIE ') > 0 || navigator.userAgent.indexOf('Trident') > 0) {
	        this.onInfo('Internet Explorer n\'est pas supporté. Nous vous invitons à utiliser Firefox ou Google Chrome. Merci pour votre compréhension.', 'Erreur');
	      }
	    }
	  },
	  destroyed: function destroyed() {
	    global.navigationBarBus.$off('navigation-display-back', this.onDisplayBackButton);
	    global.navigationBarBus.$off('info', this.onInfo);
	  },
	
	  methods: {
	    updateBinding: function updateBinding() {
	      this.hasValues = this.values && (0, _keys2.default)(this.values).length > 0;
	    },
	
	    updateBreadcrumb: function updateBreadcrumb(to, from) {
	      if (to && to.name !== 'home') {
	        this.breadcrumb = 1;
	      }
	      if (this.hasValues) {
	        this.breadcrumb = 1;
	      }
	      if (this.stage && this.stage.name === 'wait-payment') {
	        this.breadcrumb = 2;
	      }
	      if (to && to.name && to.name.startsWith('checkout')) {
	        this.breadcrumb = 2;
	      }
	      if (this.stage && this.stage.name === 'payment-done') {
	        this.breadcrumb = 3;
	      }
	
	      if (this.stage && (this.stage.name === 'in-review' || this.stage.name === 'document-ready')) {
	        this.breadcrumb = 4;
	      }
	    },
	
	    onDisplayBackButton: function onDisplayBackButton(v) {
	      this.displayBackButton = v;
	    },
	
	    onClickBack: function onClickBack() {
	      if (!this.$route.params.sessionId.startsWith('@')) {
	        global.navigationBarBus.$emit('navigation-back');
	      }
	    },
	
	    onSave: function onSave() {
	      this.displaySave = this.values.id_user_mail == null;
	      this.saveUnfolded = false;
	      if (this.values.id_user_mail) {
	        _ServiceAccess2.default.instance.saveUserCase(this.$route.params.sessionId, this.values);
	      }
	    },
	
	    onClickContact: function onClickContact() {
	      global.LC_API.open_chat_window();
	    },
	
	    onClickHome: function onClickHome() {
	      if (!this.$route.params.sessionId.startsWith('@')) {
	        this.$router.push('/f/' + this.$route.params.sessionId + '/');
	      }
	    },
	
	    onInfo: function onInfo(info) {
	      var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Aide';
	
	      this.modalTitle = title;
	      this.modalBody = info;
	      this.displayModal = true;
	    },
	
	    onDisplaySave: function onDisplaySave(displaySave) {
	      this.displaySave = displaySave;
	    },
	
	    onClickCloseModal: function onClickCloseModal() {
	      this.displayModal = false;
	    }
	
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(72);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getIterator2 = __webpack_require__(37);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    required: false,
	    date: {
	      type: Object,
	      required: true
	    },
	    option: {
	      type: Object,
	      default: function _default() {
	        return {
	          type: 'day',
	          SundayFirst: false,
	          week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
	          month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	          format: 'YYYY-MM-DD',
	          color: {
	            checked: '#F50057',
	            header: '#3f51b5',
	            headerText: '#fff'
	          },
	          inputStyle: {
	            'display': 'inline-block',
	            'padding': '6px',
	            'line-height': '22px',
	            'font-size': '16px',
	            'border': '2px solid #fff',
	            'box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
	            'border-radius': '2px',
	            'color': '#5F5F5F'
	          },
	          placeholder: 'when?',
	          buttons: {
	            ok: 'OK',
	            cancel: 'Cancel'
	          },
	          overlayOpacity: 0.5,
	          dismissible: true
	        };
	      }
	    },
	    limit: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    function hours() {
	      var list = [];
	      var hour = 24;
	      while (hour > 0) {
	        hour--;
	        list.push({
	          checked: false,
	          value: hour < 10 ? '0' + hour : hour
	        });
	      }
	      return list;
	    }
	    function mins() {
	      var list = [];
	      var min = 60;
	      while (min > 0) {
	        min--;
	        list.push({
	          checked: false,
	          value: min < 10 ? '0' + min : min
	        });
	      }
	      return list;
	    }
	    return {
	      hours: hours(),
	      mins: mins(),
	      showInfo: {
	        hour: false,
	        day: false,
	        month: false,
	        year: false,
	        check: false
	      },
	      displayInfo: {
	        month: ''
	      },
	      library: {
	        week: this.option.week,
	        month: this.option.month,
	        year: []
	      },
	      checked: {
	        oldtime: '',
	        currentMoment: null,
	        year: '',
	        month: '',
	        day: '',
	        hour: '00',
	        min: '00'
	      },
	      dayList: [],
	      selectedDays: []
	    };
	  },
	
	  methods: {
	    pad: function pad(n) {
	      n = Math.floor(n);
	      return n < 10 ? '0' + n : n;
	    },
	    nextMonth: function nextMonth(type) {
	      var next = null;
	      type === 'next' ? next = (0, _moment2.default)(this.checked.currentMoment).add(1, 'M') : next = (0, _moment2.default)(this.checked.currentMoment).add(-1, 'M');
	      this.showDay(next);
	    },
	    showDay: function showDay(time) {
	      if (time === undefined || !Date.parse(time)) {
	        this.checked.currentMoment = (0, _moment2.default)();
	      } else {
	        this.checked.currentMoment = (0, _moment2.default)(time, this.option.format);
	      }
	      this.showOne('day');
	      this.checked.year = (0, _moment2.default)(this.checked.currentMoment).format('YYYY');
	      this.checked.month = (0, _moment2.default)(this.checked.currentMoment).format('MM');
	      this.checked.day = (0, _moment2.default)(this.checked.currentMoment).format('DD');
	      this.displayInfo.month = this.library.month[(0, _moment2.default)(this.checked.currentMoment).month()];
	      var days = [];
	      var currentMoment = this.checked.currentMoment;
	      var firstDay = (0, _moment2.default)(currentMoment).date(1).day();
	
	      var previousMonth = (0, _moment2.default)(currentMoment);
	      var nextMonth = (0, _moment2.default)(currentMoment);
	      nextMonth.add(1, 'months');
	      previousMonth.subtract(1, 'months');
	      var monthDays = (0, _moment2.default)(currentMoment).daysInMonth();
	      var oldtime = this.checked.oldtime;
	      for (var i = 1; i <= monthDays; ++i) {
	        days.push({
	          value: i,
	          inMonth: true,
	          unavailable: false,
	          checked: false,
	          moment: (0, _moment2.default)(currentMoment).date(i)
	        });
	        if (i === Math.ceil((0, _moment2.default)(currentMoment).format('D')) && (0, _moment2.default)(oldtime, this.option.format).year() === (0, _moment2.default)(currentMoment).year() && (0, _moment2.default)(oldtime, this.option.format).month() === (0, _moment2.default)(currentMoment).month()) {
	          days[i - 1].checked = true;
	        }
	        this.checkBySelectDays(i, days);
	      }
	      if (firstDay === 0) firstDay = 7;
	      for (var _i = 0; _i < firstDay - (this.option.SundayFirst ? 0 : 1); _i++) {
	        var passiveDay = {
	          value: previousMonth.daysInMonth() - _i,
	          inMonth: false,
	          action: 'previous',
	          unavailable: false,
	          checked: false,
	          moment: (0, _moment2.default)(currentMoment).date(1).subtract(_i + 1, 'days')
	        };
	        days.unshift(passiveDay);
	      }
	      var passiveDaysAtFinal = 42 - days.length;
	      for (var _i2 = 1; _i2 <= passiveDaysAtFinal; _i2++) {
	        var _passiveDay = {
	          value: _i2,
	          inMonth: false,
	          action: 'next',
	          unavailable: false,
	          checked: false,
	          moment: (0, _moment2.default)(currentMoment).add(1, 'months').date(_i2)
	        };
	        days.push(_passiveDay);
	      }
	      if (this.limit.length > 0) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(this.limit), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var li = _step.value;
	
	            switch (li.type) {
	              case 'fromto':
	                days = this.limitFromTo(li, days);
	                break;
	              case 'weekday':
	                days = this.limitWeekDay(li, days);
	                break;
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	      this.dayList = days;
	    },
	    checkBySelectDays: function checkBySelectDays(d, days) {
	      var _this = this;
	
	      this.selectedDays.forEach(function (day) {
	        if (_this.checked.year === (0, _moment2.default)(day).format('YYYY') && _this.checked.month === (0, _moment2.default)(day).format('MM') && d === Math.ceil((0, _moment2.default)(day).format('D'))) {
	          days[d - 1].checked = true;
	        }
	      });
	    },
	    limitWeekDay: function limitWeekDay(limit, days) {
	      days.map(function (day) {
	        if (limit.available.indexOf(Math.floor(day.moment.format('d'))) === -1) {
	          day.unavailable = true;
	        }
	      });
	      return days;
	    },
	    limitFromTo: function limitFromTo(limit, days) {
	      var _this2 = this;
	
	      if (limit.from || limit.to) {
	        days.map(function (day) {
	          if (_this2.getLimitCondition(limit, day)) {
	            day.unavailable = true;
	          }
	        });
	      }
	      return days;
	    },
	    getLimitCondition: function getLimitCondition(limit, day) {
	      var tmpMoment = (0, _moment2.default)(day.moment.year() + '-' + this.pad(day.moment.month() + 1) + '-' + this.pad(day.value));
	      if (limit.from && !limit.to) {
	        return !tmpMoment.isAfter(limit.from);
	      } else if (!limit.from && limit.to) {
	        return !tmpMoment.isBefore(limit.to);
	      } else {
	        return !tmpMoment.isBetween(limit.from, limit.to);
	      }
	    },
	    checkDay: function checkDay(obj) {
	      if (obj.unavailable || obj.value === '') {
	        return false;
	      }
	      if (!obj.inMonth) {
	        this.nextMonth(obj.action);
	      }
	      if (this.option.type === 'day' || this.option.type === 'min') {
	        this.dayList.forEach(function (x) {
	          x.checked = false;
	        });
	        this.checked.day = this.pad(obj.value);
	        obj.checked = true;
	      } else {
	        var day = this.pad(obj.value);
	        var ctime = this.checked.year + '-' + this.checked.month + '-' + day;
	        if (obj.checked === true) {
	          obj.checked = false;
	          this.selectedDays.$remove(ctime);
	        } else {
	          this.selectedDays.push(ctime);
	          obj.checked = true;
	        }
	      }
	      switch (this.option.type) {
	        case 'day':
	          this.picked();
	          break;
	        case 'min':
	          this.showOne('hour');
	
	          this.shiftActTime();
	          break;
	      }
	    },
	    showYear: function showYear() {
	      var _this3 = this;
	
	      var year = (0, _moment2.default)(this.checked.currentMoment).year();
	      this.library.year = [];
	      var yearTmp = [];
	      for (var i = year - 100; i < year + 5; ++i) {
	        yearTmp.push(i);
	      }
	      this.library.year = yearTmp;
	      this.showOne('year');
	      this.$nextTick(function () {
	        var listDom = document.getElementById('yearList');
	        listDom.scrollTop = listDom.scrollHeight - 100;
	        _this3.addYear();
	      });
	    },
	    showOne: function showOne(type) {
	      switch (type) {
	        case 'year':
	          this.showInfo.hour = false;
	          this.showInfo.day = false;
	          this.showInfo.year = true;
	          this.showInfo.month = false;
	          break;
	        case 'month':
	          this.showInfo.hour = false;
	          this.showInfo.day = false;
	          this.showInfo.year = false;
	          this.showInfo.month = true;
	          break;
	        case 'day':
	          this.showInfo.hour = false;
	          this.showInfo.day = true;
	          this.showInfo.year = false;
	          this.showInfo.month = false;
	          break;
	        case 'hour':
	          this.showInfo.hour = true;
	          this.showInfo.day = false;
	          this.showInfo.year = false;
	          this.showInfo.month = false;
	          break;
	        default:
	          this.showInfo.day = true;
	          this.showInfo.year = false;
	          this.showInfo.month = false;
	          this.showInfo.hour = false;
	      }
	    },
	    showMonth: function showMonth() {
	      this.showOne('month');
	    },
	    addYear: function addYear() {
	      var _this4 = this;
	
	      var listDom = document.getElementById('yearList');
	      listDom.addEventListener('scroll', function (e) {
	        if (listDom.scrollTop < listDom.scrollHeight - 100) {
	          var len = _this4.library.year.length;
	          var lastYear = _this4.library.year[len - 1];
	          _this4.library.year.push(lastYear + 1);
	        }
	      }, false);
	    },
	    setYear: function setYear(year) {
	      this.checked.currentMoment = (0, _moment2.default)(year + '-' + this.checked.month + '-' + this.checked.day);
	      this.showDay(this.checked.currentMoment);
	    },
	    setMonth: function setMonth(month) {
	      var mo = this.library.month.indexOf(month) + 1;
	      if (mo < 10) {
	        mo = '0' + '' + mo;
	      }
	      this.checked.currentMoment = (0, _moment2.default)(this.checked.year + '-' + mo + '-' + this.checked.day);
	      this.showDay(this.checked.currentMoment);
	    },
	    showCheck: function showCheck() {
	      if (this.date.time === '') {
	        this.showDay();
	      } else {
	        if (this.option.type === 'day' || this.option.type === 'min') {
	          this.checked.oldtime = this.date.time;
	          this.showDay(this.date.time);
	        } else {
	          this.selectedDays = JSON.parse(this.date.time);
	          if (this.selectedDays.length) {
	            this.checked.oldtime = this.selectedDays[0];
	            this.showDay(this.selectedDays[0]);
	          } else {
	            this.showDay();
	          }
	        }
	      }
	      this.showInfo.check = true;
	    },
	    setTime: function setTime(type, obj, list) {
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var item = _step2.value;
	
	          item.checked = false;
	          if (item.value === obj.value) {
	            item.checked = true;
	            this.checked[type] = item.value;
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    },
	    picked: function picked() {
	      if (this.option.type === 'day' || this.option.type === 'min') {
	        var ctime = this.checked.year + '-' + this.checked.month + '-' + this.checked.day + ' ' + this.checked.hour + ':' + this.checked.min;
	        this.checked.currentMoment = (0, _moment2.default)(ctime, 'YYYY-MM-DD HH:mm');
	        this.date.time = (0, _moment2.default)(this.checked.currentMoment).format(this.option.format);
	      } else {
	        this.date.time = (0, _stringify2.default)(this.selectedDays);
	      }
	      this.showInfo.check = false;
	      this.$emit('change', this.date.time);
	    },
	    dismiss: function dismiss(evt) {
	      if (this.option.dismissible === undefined || this.option.dismissible) {
	        this.showInfo.check = false;
	        this.$emit('cancel');
	      }
	    },
	    shiftActTime: function shiftActTime() {
	      this.$nextTick(function () {
	        if (!document.querySelector('.hour-item.active')) {
	          return false;
	        }
	        document.querySelector('.hour-box').scrollTop = (document.querySelector('.hour-item.active').offsetTop || 0) - 250;
	        document.querySelector('.min-box').scrollTop = (document.querySelector('.min-item.active').offsetTop || 0) - 250;
	      });
	    }
	  }
	};

/***/ }),

/***/ 358:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Question = __webpack_require__(151);
	
	var _Question2 = _interopRequireDefault(_Question);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    'form-question': _Question2.default
	  },
	
	  props: {
	    questions: {
	      type: Object,
	      required: true
	    },
	    values: {
	      type: Object,
	      required: true
	    },
	    errorMessages: {
	      type: Object,
	      required: true
	    }
	  },
	
	  data: function data() {
	    return {
	      questionIds: ['id_why_no_cb']
	    };
	  },
	
	  created: function created() {},
	
	  methods: {
	    hasError: function hasError() {
	      var _this = this;
	
	      return !this.questionIds.every(function (qid) {
	        return _this.questions[qid].checkCondition(_this.values[qid], _this.values);
	      });
	    },
	
	    valueUpdated: function valueUpdated(qid, v) {
	      this.values[qid] = v;
	    }
	
	  }
	};

/***/ }),

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DatePicker = __webpack_require__(699);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    'date-picker': _DatePicker2.default
	  },
	
	  props: {
	    question: {
	      type: Object,
	      required: true
	    },
	    values: {
	      type: Object,
	      required: true
	    },
	    errorMessage: {
	      type: Object,
	      required: false
	    },
	    value: {
	      required: false
	    }
	  },
	
	  watch: {
	    question: function question(newVal, oldVal) {
	      this.updateQuestion(newVal);
	    },
	
	    value: function value(newVal, oldVal) {
	      this.updateValue(newVal);
	    },
	
	    v: function v(newVal, oldVal) {
	      var _this = this;
	
	      if (!this.question.a) {
	        this.$emit('answer-value', newVal);
	        return;
	      }
	
	      if (newVal !== oldVal && this.value !== newVal) {
	
	        this.$nextTick(function () {
	          _this.$forceUpdate();
	        });
	
	        var v = void 0;
	        if (this.question.a.type === 'check') {
	          v = newVal;
	        } else if (this.question.a.type === 'boolean') {
	          v = newVal === 'true';
	        } else if (this.question.a.type === 'number') {
	          v = newVal;
	        } else if (this.question.a.type === 'text') {
	          v = newVal;
	        } else if (this.question.a.type === 'date') {
	          v = newVal;
	        } else if (this.question.a.type === 'array') {
	          v = newVal;
	        } else if (this.question.a.type === 'arraycomplete') {
	          for (var i = 0; i < this.array.length; i++) {
	            if (this.array[i].en === newVal) {
	              v = i;
	            }
	          }
	        }
	
	        var hasError = !this.question.checkCondition(v, this.values);
	        if (hasError) {
	          this.$emit('answer-error', v);
	        }
	        this.hasError = hasError;
	
	        if (v !== this.value) {
	          this.$emit('answer-value', v);
	        }
	      }
	    },
	
	    varray: function varray(newVal, oldVal) {
	      if (newVal !== this.value && newVal !== oldVal) {
	        this.v = newVal;
	      }
	    },
	
	    'date.time': function dateTime(newVal, oldVal) {
	      if (newVal !== this.value && newVal !== oldVal) {
	        this.v = newVal;
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      displayArray: false,
	      v: null,
	      varray: [],
	
	      date: {
	        time: ''
	      },
	      datePickerOption: {
	        type: 'day',
	        week: ['Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa', 'Di'],
	        month: ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
	        format: 'YYYY-MM-DD',
	        placeholder: '',
	        inputStyle: {
	          'display': 'inline-block',
	          'width': '100%',
	          'padding': '0px',
	          'line-height': '32px',
	          'font-family': 'Roboto,Lato,sans-serif',
	          'font-size': '16px',
	          'border': '0px solid',
	          'border-radius': '0px',
	          'border-bottom': '1px solid #e1e1e1'
	        },
	        color: {
	          checked: '#F50057',
	          header: '#2196F3',
	          headerText: '#fff'
	        },
	        buttons: {
	          ok: 'Ok',
	          cancel: 'Annuler'
	        },
	        overlayOpacity: 0.5,
	        dismissible: true },
	
	      viewInfo: false,
	
	      hasError: false
	    };
	  },
	
	  computed: {
	    vcheckbox: {
	      get: function get() {
	        if (this.v == null) {
	          return null;
	        }
	        return this.v + 1;
	      },
	      set: function set(newVal) {
	        this.v = newVal - 1;
	      }
	    },
	
	    minDate: function minDate() {
	      if (this.question.a.type === 'date') {
	        return this.question.a.min;
	      }
	      return null;
	    },
	    maxDate: function maxDate() {
	      if (this.question.a.type === 'date') {
	        if (this.question.a.max === 'today') {
	          return (0, _moment2.default)().format('YYYY-MM-DD');
	        } else {
	          return this.question.a.max;
	        }
	      }
	      return null;
	    },
	
	    array: {
	      get: function get() {
	        if (this.displayArray) {
	          return [];
	        } else {
	          return this.question.array(this.values);
	        }
	      }
	    }
	
	  },
	
	  created: function created() {
	    this.updateQuestion(this.question);
	    if (this.value != null) {
	      this.updateValue(this.value);
	    }
	  },
	  mounted: function mounted() {},
	  updated: function updated() {},
	
	  methods: {
	    reset: function reset() {
	      var _this2 = this;
	
	      this.displayArray = true;
	      this.$nextTick(function () {
	        _this2.displayArray = false;
	      });
	    },
	
	    onClickCheck: function onClickCheck(val) {
	      var index = this.varray.indexOf(val);
	      if (index >= 0) {
	        this.varray.splice(index, 1);
	      } else {
	        this.varray.push(val);
	      }
	      this.v = this.varray.slice(0);
	    },
	    isChecked: function isChecked(val) {
	      return this.varray.indexOf(val) >= 0;
	    },
	
	    onClickInfo: function onClickInfo(info) {
	      global.navigationBarBus.$emit('info', info);
	    },
	
	    updateQuestion: function updateQuestion(val) {
	      this.hasError = false;
	    },
	
	    updateValue: function updateValue(newVal) {
	      if (!this.question.a) {
	        this.v = newVal;
	        return;
	      }
	
	      if (newVal == null) {
	        this.v = newVal;
	      } else {
	        if (this.question.a.type === 'check') {
	          this.v = newVal;
	        }
	
	        if (this.question.a.type === 'boolean') {
	          if (typeof newVal === 'boolean') {
	            this.v = newVal ? 'true' : 'false';
	          }
	        }
	
	        if (this.question.a.type === 'number') {
	          if (typeof newVal === 'number') {
	            this.v = newVal;
	          }
	        }
	
	        if (this.question.a.type === 'text') {
	          this.v = newVal;
	        }
	
	        if (this.question.a.type === 'date') {
	          this.date.time = newVal;
	        }
	
	        if (this.question.a.type === 'array') {
	          if (this.question.a.max === 1) {
	            this.v = newVal;
	          } else {
	            this.varray = newVal;
	          }
	        }
	
	        if (this.question.a.type === 'arraycomplete') {
	          var array = this.array;
	          if (newVal in array) {
	            this.v = array[newVal].en;
	          }
	        }
	      }
	    },
	
	    err: function err() {
	      if (!this.question.a) {
	        return;
	      }
	
	      var msg = this.question.a['error-message'];
	      if (msg == null) {
	        msg = this.errorMessage;
	      }
	
	      if (msg != null) {
	        return msg.en;
	      }
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(37);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _slicedToArray2 = __webpack_require__(15);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _Question = __webpack_require__(151);
	
	var _Question2 = _interopRequireDefault(_Question);
	
	var _ServiceAccess = __webpack_require__(10);
	
	var _ServiceAccess2 = _interopRequireDefault(_ServiceAccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    'form-question': _Question2.default
	  },
	
	  props: {
	    sessionId: {
	      type: String,
	      required: true
	    },
	    values: {
	      type: Object,
	      required: true
	    },
	    questions: {
	      type: Object,
	      required: true
	    },
	    screens: {
	      type: Object,
	      required: true
	    },
	    errorMessages: {
	      type: Object,
	      required: true
	    },
	    screen: {
	      type: Object,
	      required: true
	    }
	  },
	
	  watch: {
	    screen: function screen(newVal, oldVal) {
	      if (oldVal != null && newVal !== oldVal) {
	        this.updateStatePath(newVal);
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      statePath: [],
	      transitionToScreen: null,
	      hasError: false,
	      loading: false
	    };
	  },
	
	  created: function created() {
	    this.updateStatePath(this.screen);
	  },
	
	  methods: {
	    errorMessage: function errorMessage(qid) {
	      if (this.errorMessages && this.questions) {
	        var question = this.questions[qid];
	        if (question && question.a) {
	          return this.errorMessages[question.a.type];
	        }
	      }
	      return null;
	    },
	
	    updateStatePath: function updateStatePath(screen) {
	      var _this = this;
	
	      this.hasError = false;
	
	      var _screen$statePath = this.screen.statePath(this.values),
	          _screen$statePath2 = (0, _slicedToArray3.default)(_screen$statePath, 2),
	          statePath = _screen$statePath2[0],
	          transistionToScreenId = _screen$statePath2[1];
	
	      if (statePath == null && transistionToScreenId) {
	        this.$emit('transition-to-next-screen', transistionToScreenId);
	      } else {
	        this.transitionToScreen = transistionToScreenId;
	        this.statePath = [];
	        this.$nextTick(function () {
	          _this.statePath = statePath;
	        });
	      }
	    },
	
	    currentState: function currentState() {
	      return;
	    },
	
	    nextState: function nextState(state, v) {
	      var _this2 = this;
	
	      if (state.qid === 'id_crrv') {
	        _ServiceAccess2.default.instance.track(this.$route.params.sessionId, 'user-crrv', { value: v });
	      } else if (state.qid === 'id_user_country') {
	        var text = this.questions[state.qid].a.values[v].en;
	        this.values.id_user_adress_country = text;
	        _ServiceAccess2.default.instance.track(this.$route.params.sessionId, 'user-country', { country: text });
	      } else if (state.qid === 'id_user_visacountry') {
	        var _text = this.questions[state.qid].a.values[v].en;
	        this.values.id_user_adress_country = _text;
	        _ServiceAccess2.default.instance.track(this.$route.params.sessionId, 'user-country', { country: _text });
	      } else if (state.qid === 'id_why') {
	        var _text2 = this.questions[state.qid].a.values[v].en;
	        _ServiceAccess2.default.instance.track(this.$route.params.sessionId, 'user-why', { why: _text2 });
	      } else if (state.qid === 'id_demande_visa' && v === true) {
	        this.values.id_user_visacountry = this.values.id_user_country;
	      }
	
	      var oldVal = this.values[state.qid];
	      if (oldVal !== v) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          var _loop = function _loop() {
	            var dependentId = _step.value;
	
	            delete _this2.values[dependentId];
	            var index = _this2.statePath.findIndex(function (s) {
	              return s.qid === dependentId;
	            });
	            if (index > 0) {
	              _this2.$refs.question[index].reset();
	            }
	          };
	
	          for (var _iterator = (0, _getIterator3.default)(this.questions[state.qid].dependencies), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            _loop();
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	
	      this.values[state.qid] = v;
	
	      var _screen$statePath3 = this.screen.statePath(this.values),
	          _screen$statePath4 = (0, _slicedToArray3.default)(_screen$statePath3, 2),
	          statePath = _screen$statePath4[0],
	          transistionToScreenId = _screen$statePath4[1];
	
	      if (statePath == null && transistionToScreenId) {
	        this.$emit('transition-to-next-screen', transistionToScreenId);
	      } else {
	        this.transitionToScreen = transistionToScreenId;
	        this.statePath = statePath;
	
	        this.hasError = !this.statePath.filter(function (s) {
	          return s.qid != null;
	        }).every(function (s) {
	          return _this2.questions[s.qid].checkCondition(_this2.values[s.qid]);
	        }, this.values);
	      }
	    },
	
	    onPrevButton: function onPrevButton() {
	      this.$emit('transition-to-prev-screen');
	    },
	
	    onClickContinue: function onClickContinue() {
	      var _this3 = this;
	
	      if (!this.hasError) {
	        this.loading = true;
	        this.screen.onLeave(this.values, this.sessionId).then(function (res) {
	          _this3.loading = false;
	          _this3.$emit('transition-to-next-screen', _this3.transitionToScreen);
	        }, function (err) {
	          _this3.loading = false;
	          console.error('Unable to leave screen, error: ', err);
	        });
	      }
	    }
	
	  }
	};

/***/ }),

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Question = __webpack_require__(151);
	
	var _Question2 = _interopRequireDefault(_Question);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    'form-question': _Question2.default
	  },
	
	  props: {
	    questions: {
	      type: Object,
	      required: true
	    },
	    values: {
	      type: Object,
	      required: true
	    },
	    errorMessages: {
	      type: Object,
	      required: true
	    }
	  },
	
	  data: function data() {
	    return {
	      questionIds1: ['id_user_civilite', 'id_user_prenom', 'id_user_nom', 'id_user_birthdate', 'id_user_birthplace', 'id_user_nationality'],
	      questionIds2: ['id_user_adress_street', 'id_user_adress_zip', 'id_user_adress_city', 'id_user_adress_country'],
	      questionIds3: ['id_user_phnum', 'id_user_mail', 'id_user_mail_verification']
	
	    };
	  },
	
	  created: function created() {},
	
	  methods: {
	    hasError: function hasError() {
	      var _this = this;
	
	      return !this.questionIds1.every(function (qid) {
	        return _this.questions[qid].checkCondition(_this.values[qid], _this.values);
	      }) || !this.questionIds2.every(function (qid) {
	        return _this.questions[qid].checkCondition(_this.values[qid], _this.values);
	      }) || !this.questionIds3.every(function (qid) {
	        return _this.questions[qid].checkCondition(_this.values[qid], _this.values);
	      });
	    },
	
	    valueUpdated: function valueUpdated(qid, v) {
	      this.values[qid] = v;
	    }
	
	  }
	};

/***/ }),

/***/ 362:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(15);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _promise = __webpack_require__(14);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _ServiceAccess = __webpack_require__(10);
	
	var _ServiceAccess2 = _interopRequireDefault(_ServiceAccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  data: function data() {
	    return {
	      values: null
	    };
	  },
	
	  computed: {
	    recoursType: function recoursType() {
	      if (this.values) {
	        if (this.values.id_tiers !== 2) {
	          if (this.values.id_crrv_type_recours) {
	            if (this.values.id_crrv_type_recours.includes(2)) {
	              return 'premium';
	            } else {
	              return this.values.id_crrv_type_recours.includes(1) ? 'ta' : 'crrv';
	            }
	          } else {
	            return 'crrv';
	          }
	        } else {
	          return 'visa';
	        }
	      }
	    }
	  },
	
	  created: function created() {
	    var _this = this;
	
	    _ServiceAccess2.default.instance.track(this.$route.params.sessionId, 'checkout-display');
	
	    global.navigationBarBus.$on('navigation-back', this.prevScreen);
	    global.navigationBarBus.$emit('navigation-display-back', true);
	    global.navigationBarBus.$emit('display-save', false);
	
	    var promises = [_ServiceAccess2.default.instance.loadValues(this.$route.params.sessionId)];
	    _promise2.default.all(promises).then(function (responses) {
	      var _responses = (0, _slicedToArray3.default)(responses, 1),
	          values = _responses[0];
	
	      _this.values = values;
	    });
	  },
	  destroyed: function destroyed() {
	    global.navigationBarBus.$off('navigation-back', this.prevScreen);
	  },
	
	  methods: {
	    openWithoutReferrer: function openWithoutReferrer(url) {
	      window.open(url, '_blank');
	    },
	
	    prevScreen: function prevScreen() {
	      this.$router.back();
	    },
	
	    onClickDetails: function onClickDetails() {
	      window.open('https://www.getmyvisatofrance.com/tarifs.html', '_blank');
	    },
	
	    onClickSelect: function onClickSelect(item) {
	      _ServiceAccess2.default.instance.track(this.$route.params.sessionId, 'checkout-item', { item: item });
	      this.$router.push('/f/' + this.$route.params.sessionId + '/checkoutform/' + item);
	    }
	
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 363:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(15);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _promise = __webpack_require__(14);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _UserForm = __webpack_require__(343);
	
	var _UserForm2 = _interopRequireDefault(_UserForm);
	
	var _ServiceAccess = __webpack_require__(10);
	
	var _ServiceAccess2 = _interopRequireDefault(_ServiceAccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    'user-form': _UserForm2.default
	  },
	
	  data: function data() {
	    return {
	      email: null,
	      questions: null,
	      errorMessages: null,
	      values: null,
	      userFormHasError: false
	    };
	  },
	
	  created: function created() {
	    var _this = this;
	
	    global.navigationBarBus.$on('navigation-back', this.prevScreen);
	    global.navigationBarBus.$emit('navigation-display-back', true);
	    global.navigationBarBus.$emit('display-save', false);
	
	    var promises = [_ServiceAccess2.default.instance.loadValues(this.$route.params.sessionId), _ServiceAccess2.default.instance.loadErrorMessages(), _ServiceAccess2.default.instance.loadQuestions()];
	    _promise2.default.all(promises).then(function (responses) {
	      var _responses = (0, _slicedToArray3.default)(responses, 3),
	          values = _responses[0],
	          errorMessages = _responses[1],
	          questions = _responses[2];
	
	      _this.values = values;
	
	      _this.errorMessages = errorMessages;
	      _this.questions = questions;
	      _this.$forceUpdate();
	    });
	  },
	  destroyed: function destroyed() {
	    global.navigationBarBus.$off('navigation-back', this.prevScreen);
	  },
	
	  methods: {
	    prevScreen: function prevScreen() {
	      this.$router.back();
	    },
	
	    valueUpdated: function valueUpdated(qid, v) {
	      this.values[qid] = v;
	    },
	
	    onClickValidate: function onClickValidate() {
	      this.userFormHasError = this.$refs.userForm.hasError();
	      if (!this.userFormHasError) {
	        _ServiceAccess2.default.instance.storeValues(this.$route.params.sessionId, this.values);
	
	        if (this.$route.params.cart === 'VISA') {
	          this.$router.push('/f/' + this.$route.params.sessionId + '/payment/' + this.$route.params.cart);
	        } else {
	          this.$router.push('/f/' + this.$route.params.sessionId + '/preview/' + this.$route.params.cart);
	        }
	      }
	    }
	
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 364:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(15);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _promise = __webpack_require__(14);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _ServiceAccess = __webpack_require__(10);
	
	var _ServiceAccess2 = _interopRequireDefault(_ServiceAccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: false,
	      paymentDone: false
	    };
	  },
	
	  created: function created() {
	    var _this = this;
	
	    global.navigationBarBus.$on('navigation-back', this.prevScreen);
	    global.navigationBarBus.$emit('navigation-display-back', true);
	    global.navigationBarBus.$emit('display-save', false);
	
	    var promises = [_ServiceAccess2.default.instance.loadValues(this.$route.params.sessionId)];
	    _promise2.default.all(promises).then(function (responses) {
	      var _responses = (0, _slicedToArray3.default)(responses, 1),
	          values = _responses[0];
	
	      _this.values = values;
	    });
	  },
	  destroyed: function destroyed() {
	    global.navigationBarBus.$off('navigation-back', this.prevScreen);
	  },
	
	  methods: {
	    prevScreen: function prevScreen() {
	      if (this.paymentDone) {
	        this.$router.replace('/f/' + this.$route.params.sessionId + '/');
	      } else {
	        this.$router.back();
	      }
	    },
	
	    onClickPay: function onClickPay() {
	      var _this2 = this;
	
	      this.loading = true;
	      var medium = 'mandat-express';
	      _ServiceAccess2.default.instance.track(this.$route.params.sessionId, 'checkout-pay', { kind: medium });
	
	      _ServiceAccess2.default.instance.checkoutWire(this.$route.params.sessionId, medium, this.$route.params.cart).then(function (resp) {
	        _this2.loading = false;
	        _this2.paymentDone = true;
	        _this2.values.id_virement_type = medium;
	        _this2.values.id_attente_virement = true;
	        _this2.trackAdsConversion();
	      }, function (err) {
	        _this2.loading = false;
	        console.error('Failed Wire checkout: ', err);
	      });
	    },
	
	    trackAdsConversion: function trackAdsConversion() {
	      var google_conversion_id = 865811613;
	      var google_conversion_language = 'en';
	      var google_conversion_format = '3';
	      var google_conversion_color = 'ffffff';
	      var google_conversion_label = 'IzYDCM7i4WwQnfnsnAM';
	      var google_remarketing_only = false;
	
	      var script = document.createElement('script');
	      script.src = '//www.googleadservices.com/pagead/conversion.js';
	
	      var image = new global.Image(1, 1);
	      image.src = '//www.googleadservices.com/pagead/conversion/865811613/?label=IzYDCM7i4WwQnfnsnAM&amp;guid=ON&amp;script=0';
	    },
	
	    onClickContinue: function onClickContinue() {
	      this.$router.replace('/f/' + this.$route.params.sessionId + '/');
	    }
	
	  }
	
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 365:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ServiceAccess = __webpack_require__(10);
	
	var _ServiceAccess2 = _interopRequireDefault(_ServiceAccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  created: function created() {
	    global.navigationBarBus.$on('navigation-back', this.prevScreen);
	    global.navigationBarBus.$emit('navigation-display-back', true);
	    global.navigationBarBus.$emit('display-save', false);
	
	    _ServiceAccess2.default.instance.track(this.$route.params.sessionId, 'checkout-payment-display');
	
	    window.scrollTo(0, 0);
	  },
	  destroyed: function destroyed() {
	    global.navigationBarBus.$off('navigation-back', this.prevScreen);
	  },
	
	  methods: {
	    prevScreen: function prevScreen() {
	      if (this.paymentDone) {
	        this.$router.replace('/f/' + this.$route.params.sessionId + '/');
	      } else {
	        this.$router.back();
	      }
	    },
	
	    valueUpdated: function valueUpdated(qid, v) {
	      this.values[qid] = v;
	    },
	
	    onClick: function onClick(medium) {
	      _ServiceAccess2.default.instance.track(this.$route.params.sessionId, 'checkout-payment', { kind: medium });
	      if (medium === 'stripe' || medium === 'stripe-friend') {
	        this.$router.push('/f/' + this.$route.params.sessionId + '/' + medium + '/' + this.$route.params.cart);
	      } else {
	        this.$router.push('/f/' + this.$route.params.sessionId + '/payment-why/' + medium + '/' + this.$route.params.cart);
	      }
	    }
	
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 366:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(15);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _promise = __webpack_require__(14);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _PaymentWhyForm = __webpack_require__(700);
	
	var _PaymentWhyForm2 = _interopRequireDefault(_PaymentWhyForm);
	
	var _ServiceAccess = __webpack_require__(10);
	
	var _ServiceAccess2 = _interopRequireDefault(_ServiceAccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    'why-form': _PaymentWhyForm2.default
	  },
	
	  data: function data() {
	    return {
	      questionIds: ['id_why_no_cb'],
	      questions: null,
	      errorMessages: null,
	      values: null,
	      userFormHasError: false
	    };
	  },
	
	  created: function created() {
	    var _this = this;
	
	    global.navigationBarBus.$on('navigation-back', this.prevScreen);
	    global.navigationBarBus.$emit('navigation-display-back', true);
	    global.navigationBarBus.$emit('display-save', false);
	
	    var promises = [_ServiceAccess2.default.instance.loadValues(this.$route.params.sessionId), _ServiceAccess2.default.instance.loadErrorMessages(), _ServiceAccess2.default.instance.loadQuestions()];
	    _promise2.default.all(promises).then(function (responses) {
	      var _responses = (0, _slicedToArray3.default)(responses, 3),
	          values = _responses[0],
	          errorMessages = _responses[1],
	          questions = _responses[2];
	
	      _this.values = values;
	      _this.questions = questions;
	      _this.errorMessages = errorMessages;
	      _this.$forceUpdate();
	    });
	  },
	  destroyed: function destroyed() {
	    global.navigationBarBus.$off('navigation-back', this.prevScreen);
	  },
	
	  methods: {
	    prevScreen: function prevScreen() {
	      this.$router.back();
	    },
	
	    onClickValidate: function onClickValidate() {
	      var _this2 = this;
	
	      var qid = this.questionIds[0];
	      var v = this.values[qid];
	      var texts = v.map(function (i) {
	        return _this2.questions[qid].a.values[i].en;
	      });
	      _ServiceAccess2.default.instance.track(this.$route.params.sessionId, 'payment-why', { values: texts });
	
	      _ServiceAccess2.default.instance.storeValues(this.$route.params.sessionId, this.values);
	      this.$router.push('/f/' + this.$route.params.sessionId + '/' + this.$route.params.medium + '/' + this.$route.params.cart);
	    }
	
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 367:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(15);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _promise = __webpack_require__(14);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _ServiceAccess = __webpack_require__(10);
	
	var _ServiceAccess2 = _interopRequireDefault(_ServiceAccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: false,
	      paymentDone: false
	    };
	  },
	
	  created: function created() {
	    var _this = this;
	
	    global.navigationBarBus.$on('navigation-back', this.prevScreen);
	    global.navigationBarBus.$emit('navigation-display-back', true);
	    global.navigationBarBus.$emit('display-save', false);
	
	    var promises = [_ServiceAccess2.default.instance.loadValues(this.$route.params.sessionId)];
	    _promise2.default.all(promises).then(function (responses) {
	      var _responses = (0, _slicedToArray3.default)(responses, 1),
	          values = _responses[0];
	
	      _this.values = values;
	    });
	  },
	  destroyed: function destroyed() {
	    global.navigationBarBus.$off('navigation-back', this.prevScreen);
	  },
	
	  methods: {
	    prevScreen: function prevScreen() {
	      this.$router.back();
	    },
	
	    onClickPay: function onClickPay() {
	      var _this2 = this;
	
	      this.loading = true;
	
	      _ServiceAccess2.default.instance.track(this.$route.params.sessionId, 'checkout-pay', { kind: 'wire' });
	
	      _ServiceAccess2.default.instance.checkout(this.$route.params.sessionId, null, this.$route.params.cart).then(function (resp) {
	        _ServiceAccess2.default.instance.track(_this2.$route.params.sessionId, 'checkout-stripe-success');
	        _this2.loading = false;
	        _this2.paymentDone = true;
	        _this2.trackAdsConversion();
	      }, function (err) {
	        _ServiceAccess2.default.instance.track(_this2.$route.params.sessionId, 'checkout-stripe-error');
	        _this2.loading = false;
	        console.error('Failed Stripe checkout: ', err);
	      });
	    },
	
	    trackAdsConversion: function trackAdsConversion() {
	      var google_conversion_id = 865811613;
	      var google_conversion_language = 'en';
	      var google_conversion_format = '3';
	      var google_conversion_color = 'ffffff';
	      var google_conversion_label = 'IzYDCM7i4WwQnfnsnAM';
	      var google_remarketing_only = false;
	
	      var script = document.createElement('script');
	      script.src = '//www.googleadservices.com/pagead/conversion.js';
	
	      var image = new global.Image(1, 1);
	      image.src = '//www.googleadservices.com/pagead/conversion/865811613/?label=IzYDCM7i4WwQnfnsnAM&amp;guid=ON&amp;script=0';
	    },
	
	    onClickContinue: function onClickContinue() {
	      this.$router.replace('/f/' + this.$route.params.sessionId + '/');
	    }
	
	  }
	
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ServiceAccess = __webpack_require__(10);
	
	var _ServiceAccess2 = _interopRequireDefault(_ServiceAccess);
	
	var _pdfjsDist = __webpack_require__(674);
	
	var _pdfjsDist2 = _interopRequireDefault(_pdfjsDist);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  data: function data() {
	    return {
	      pdfDoc: null,
	      pageNum: 1,
	      pageRendering: false,
	      pageRendered: false,
	      pageNumPending: null,
	      scale: 2,
	      canvas: null,
	      ctx: null
	    };
	  },
	
	  created: function created() {
	    global.navigationBarBus.$on('navigation-back', this.prevScreen);
	    global.navigationBarBus.$emit('navigation-display-back', true);
	    global.navigationBarBus.$emit('display-save', false);
	
	    _ServiceAccess2.default.instance.track(this.$route.params.sessionId, 'checkout-preview-display');
	  },
	
	  mounted: function mounted() {
	    this.canvas = document.getElementById('pdfcanvas');
	    this.ctx = this.canvas.getContext('2d');
	    var url = _ServiceAccess2.default.instance.previewURL(this.$route.params.sessionId);
	    var that = this;
	
	    _pdfjsDist2.default.PDFJS.workerSrc = '/pdf.worker.js';
	    _pdfjsDist2.default.getDocument(url).then(function (pdfDoc_) {
	      that.pdfDoc = pdfDoc_;
	
	      that.renderPage(that.pageNum);
	    });
	  },
	
	  destroyed: function destroyed() {
	    global.navigationBarBus.$off('navigation-back', this.prevScreen);
	  },
	
	  methods: {
	    prevScreen: function prevScreen() {
	      if (this.paymentDone) {
	        this.$router.replace('/f/' + this.$route.params.sessionId + '/');
	      } else {
	        this.$router.back();
	      }
	    },
	
	    renderPage: function renderPage(num) {
	      this.pageRendering = true;
	
	      var that = this;
	      this.pdfDoc.getPage(num).then(function (page) {
	        var viewport = page.getViewport(that.scale);
	        that.canvas.height = viewport.height;
	        that.canvas.width = viewport.width;
	        that.canvas.style.width = '100%';
	        that.canvas.style.height = '100%';
	        that.pageRendered = true;
	
	        var renderContext = {
	          canvasContext: that.ctx,
	          viewport: viewport
	        };
	        var renderTask = page.render(renderContext);
	
	        renderTask.promise.then(function () {
	          that.pageRendering = false;
	          var ctx = that.ctx;
	          ctx.globalAlpha = 0.4;
	          ctx.font = '128px sans-serif';
	          ctx.fillStyle = 'black';
	          var metrics = ctx.measureText('SPECIMEN');
	          var width = metrics.width;
	
	          ctx.translate(that.canvas.width / 2 - width / 4, that.canvas.height / 2 + width / 3);
	          ctx.rotate(-45 * Math.PI / 180);
	          ctx.fillText('SPECIMEN', 0, 0);
	        });
	      });
	    },
	
	    onContinue: function onContinue() {
	      this.$router.push('/f/' + this.$route.params.sessionId + '/payment/' + this.$route.params.cart);
	    }
	
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 369:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(393);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(388);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _slicedToArray2 = __webpack_require__(15);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _promise = __webpack_require__(14);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _ServiceAccess = __webpack_require__(10);
	
	var _ServiceAccess2 = _interopRequireDefault(_ServiceAccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var stripe = global.Stripe('pk_live_x9YLrkFJrCACMzy3yduLQw8E');
	
	exports.default = {
	  data: function data() {
	    return {
	      isFriendPay: false,
	
	      cart: null,
	
	      cardNumberInvalid: false,
	      cardExpireInvalid: false,
	      cardCVCInvalid: false,
	      card: {
	        number: '',
	        expireMonth: '',
	        expireYear: '',
	        cvc: ''
	      },
	      coupon: null,
	      discount: 0,
	      loading: false,
	      paymentDone: false
	    };
	  },
	
	  computed: {
	    price: function price() {
	      var price = 0;
	      if (this.cart === 'PREMIUM') {
	        price = 999;
	      } else if (this.cart === 'VISA') {
	        price = 120;
	      } else if (this.cart === 'CRRV') {
	        price = 299;
	      } else if (this.cart === 'TA') {
	        price = 299;
	      }
	
	      return price - this.discount;
	    }
	  },
	
	  created: function created() {
	    var _this = this;
	
	    global.navigationBarBus.$on('navigation-back', this.prevScreen);
	    global.navigationBarBus.$emit('navigation-display-back', true);
	    global.navigationBarBus.$emit('display-save', false);
	
	    this.isFriendPay = this.$route.params.sessionId.startsWith('@');
	    if (this.isFriendPay) {
	      _ServiceAccess2.default.instance.purchases(this.$route.params.sessionId).then(function (purchases) {
	        _this.cart = purchases[0];
	      });
	    } else {
	      this.cart = this.$route.params.cart;
	      var promises = [_ServiceAccess2.default.instance.loadValues(this.$route.params.sessionId)];
	      _promise2.default.all(promises).then(function (responses) {
	        var _responses = (0, _slicedToArray3.default)(responses, 1),
	            values = _responses[0];
	
	        _this.values = values;
	      });
	    }
	  },
	
	  mounted: function mounted() {
	    var elements = stripe.elements();
	    var style = {
	      base: {
	        color: '#32325d',
	        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
	        fontSmoothing: 'antialiased',
	        fontSize: '16px',
	        '::placeholder': {
	          color: '#aab7c4'
	        }
	      },
	      invalid: {
	        color: '#fa755a',
	        iconColor: '#fa755a'
	      }
	    };
	
	    this.card = elements.create('card', { style: style });
	
	    this.card.mount('#card-element');
	  },
	
	  destroyed: function destroyed() {
	    global.navigationBarBus.$off('navigation-back', this.prevScreen);
	  },
	
	  methods: {
	    prevScreen: function prevScreen() {
	      if (this.paymentDone) {
	        this.$router.replace('/f/' + this.$route.params.sessionId + '/');
	      } else {
	        this.$router.back();
	      }
	    },
	
	    onFetchCouponAmount: function onFetchCouponAmount() {
	      var _this2 = this;
	
	      if (!this.isFetchingCoupon) {
	        this.isFetchingCoupon = true;
	        setTimeout(function () {
	          _this2.isFetchingCoupon = false;
	          _ServiceAccess2.default.instance.fetchCouponAmount(_this2.coupon, _this2.cart).then(function (resp) {
	            _this2.discount = resp;
	          });
	        }, 1000);
	      }
	    },
	
	    onClickPay: function () {
	      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var commonErrorMessage, paymentMethodResp, checkoutResp, cardAction;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                this.loading = true;
	                commonErrorMessage = 'Votre carte a été refusée. Nous vous invitons à vérifier et resaisir les informations ou à utiliser une autre carte.';
	                _context.prev = 2;
	
	                _ServiceAccess2.default.instance.track(this.$route.params.sessionId, 'checkout-pay', { kind: 'stripe' });
	                _context.next = 6;
	                return stripe.createPaymentMethod('card', this.card);
	
	              case 6:
	                paymentMethodResp = _context.sent;
	                _context.next = 9;
	                return _ServiceAccess2.default.instance.checkout(this.$route.params.sessionId, { paymentMethodId: paymentMethodResp.paymentMethod.id, cart: this.cart, coupon: this.coupon });
	
	              case 9:
	                checkoutResp = _context.sent;
	
	                if (!checkoutResp.error) {
	                  _context.next = 16;
	                  break;
	                }
	
	                console.error(checkoutResp);
	                global.navigationBarBus.$emit('info', checkoutResp.error.message);
	                _ServiceAccess2.default.instance.track(this.$route.params.sessionId, 'checkout-stripe-error');
	                _context.next = 28;
	                break;
	
	              case 16:
	                if (!checkoutResp.requires_action) {
	                  _context.next = 28;
	                  break;
	                }
	
	                _context.next = 19;
	                return stripe.handleCardAction(checkoutResp.payment_intent_client_secret);
	
	              case 19:
	                cardAction = _context.sent;
	
	                if (!cardAction.error) {
	                  _context.next = 26;
	                  break;
	                }
	
	                console.error(cardAction);
	                global.navigationBarBus.$emit('info', cardAction.error.message);
	                _ServiceAccess2.default.instance.track(this.$route.params.sessionId, 'checkout-stripe-error');
	                _context.next = 28;
	                break;
	
	              case 26:
	                _context.next = 28;
	                return _ServiceAccess2.default.instance.checkout(this.$route.params.sessionId, { paymentIntentId: cardAction.paymentIntent.id, cart: this.cart, coupon: this.coupon });
	
	              case 28:
	                _ServiceAccess2.default.instance.track(this.$route.params.sessionId, 'checkout-stripe-success');
	                this.paymentDone = true;
	                this.trackAdsConversion();
	
	                _ServiceAccess2.default.instance.purchases(this.$route.params.sessionId);
	
	                _context.next = 38;
	                break;
	
	              case 34:
	                _context.prev = 34;
	                _context.t0 = _context['catch'](2);
	
	                console.error('Failed Stripe checkout', _context.t0);
	                global.navigationBarBus.$emit('info', commonErrorMessage);
	
	              case 38:
	                this.loading = false;
	
	              case 39:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this, [[2, 34]]);
	      }));
	
	      function onClickPay() {
	        return _ref.apply(this, arguments);
	      }
	
	      return onClickPay;
	    }(),
	
	    trackAdsConversion: function trackAdsConversion() {
	      var google_conversion_id = 865811613;
	      var google_conversion_language = 'en';
	      var google_conversion_format = '3';
	      var google_conversion_color = 'ffffff';
	      var google_conversion_label = 'IzYDCM7i4WwQnfnsnAM';
	      var google_remarketing_only = false;
	
	      var script = document.createElement('script');
	      script.src = '//www.googleadservices.com/pagead/conversion.js';
	
	      var image = new global.Image(1, 1);
	      image.src = '//www.googleadservices.com/pagead/conversion/865811613/?label=IzYDCM7i4WwQnfnsnAM&amp;guid=ON&amp;script=0';
	
	      try {
	        window.ga('ec:addProduct', { 'name': this.cart });
	        window.ga('send', 'event', {
	          'eventCategory': 'checkout',
	          'eventAction': 'checkout-success'
	        });
	      } catch (err) {}
	    },
	
	    entryScreenId: function entryScreenId() {
	
	      if (this.values.id_why === 0) {
	        return 'parcours etudiant';
	      } else if (this.values.id_why === 1) {
	        return 'parcours conjoint';
	      }
	
	      return '';
	    },
	
	    onClickContinue: function onClickContinue() {
	      this.$router.replace('/f/' + this.$route.params.sessionId + '/' + this.entryScreenId());
	    }
	
	  }
	
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(15);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _promise = __webpack_require__(14);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _ServiceAccess = __webpack_require__(10);
	
	var _ServiceAccess2 = _interopRequireDefault(_ServiceAccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      payURL: '...',
	      loading: false,
	      paymentDone: false
	    };
	  },
	
	  computed: {
	    price: function price() {
	      var price = 0;
	      if (this.$route.params.cart === 'PREMIUM') {
	        price = 999;
	      } else if (this.$route.params.cart === 'VISA') {
	        price = 120;
	
	        return;
	      } else if (this.$route.params.cart === 'CRRV') {
	        price = 299;
	      } else if (this.$route.params.cart === 'TA') {
	        price = 299;
	      }
	      return price;
	    }
	  },
	
	  created: function created() {
	    var _this = this;
	
	    global.navigationBarBus.$on('navigation-back', this.prevScreen);
	    global.navigationBarBus.$emit('navigation-display-back', true);
	    global.navigationBarBus.$emit('display-save', false);
	
	    var promises = [_ServiceAccess2.default.instance.loadValues(this.$route.params.sessionId), _ServiceAccess2.default.instance.checkoutFriendURL(this.$route.params.sessionId)];
	    _promise2.default.all(promises).then(function (responses) {
	      var _responses = (0, _slicedToArray3.default)(responses, 2),
	          values = _responses[0],
	          url = _responses[1];
	
	      _this.values = values;
	      _this.payURL = url;
	    });
	  },
	  destroyed: function destroyed() {
	    global.navigationBarBus.$off('navigation-back', this.prevScreen);
	  },
	
	  methods: {
	    prevScreen: function prevScreen() {
	      if (this.paymentDone) {
	        this.$router.replace('/f/' + this.$route.params.sessionId + '/');
	      } else {
	        this.$router.back();
	      }
	    },
	
	    onClickPay: function onClickPay() {
	      var _this2 = this;
	
	      _ServiceAccess2.default.instance.track(this.$route.params.sessionId, 'checkout-pay', { kind: 'stripe-friend' });
	      this.loading = true;
	
	      _ServiceAccess2.default.instance.checkoutFriend(this.$route.params.sessionId, this.$route.params.cart).then(function (resp) {
	        _this2.paymentDone = true;
	        _this2.loading = false;
	      });
	    },
	
	    onCopy: function onCopy() {
	      var selection = window.getSelection();
	      selection.removeAllRanges();
	      var payUrlSpan = this.$el.querySelector('.pay-url').firstChild;
	      var range = document.createRange();
	      range.selectNode(payUrlSpan);
	      selection.addRange(range);
	
	      try {
	        document.execCommand('copy');
	      } catch (err) {
	        console.error('Unable to copy', err);
	      }
	    },
	    onEmail: function onEmail() {
	      window.open('mailto:?subject=Aide pour dossier de visa pour la France&body=Bonjour,%0A%0AAfin de compléter ma procédure de visa pour la France, il faut effectuer un paiement en utilisant le lien sécurisé suivant :%0A' + this.payURL);
	    },
	
	    onClickContinue: function onClickContinue() {
	      this.$router.replace('/f/' + this.$route.params.sessionId + '/');
	    }
	
	  }
	
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(15);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _promise = __webpack_require__(14);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _ServiceAccess = __webpack_require__(10);
	
	var _ServiceAccess2 = _interopRequireDefault(_ServiceAccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: false,
	      paymentDone: false
	    };
	  },
	
	  created: function created() {
	    var _this = this;
	
	    global.navigationBarBus.$on('navigation-back', this.prevScreen);
	    global.navigationBarBus.$emit('navigation-display-back', true);
	    global.navigationBarBus.$emit('display-save', false);
	
	    var promises = [_ServiceAccess2.default.instance.loadValues(this.$route.params.sessionId)];
	    _promise2.default.all(promises).then(function (responses) {
	      var _responses = (0, _slicedToArray3.default)(responses, 1),
	          values = _responses[0];
	
	      _this.values = values;
	    });
	  },
	  destroyed: function destroyed() {
	    global.navigationBarBus.$off('navigation-back', this.prevScreen);
	  },
	
	  methods: {
	    prevScreen: function prevScreen() {
	      if (this.paymentDone) {
	        this.$router.replace('/f/' + this.$route.params.sessionId + '/');
	      } else {
	        this.$router.back();
	      }
	    },
	
	    onClickPay: function onClickPay() {
	      var _this2 = this;
	
	      this.loading = true;
	
	      var medium = 'western-union';
	      _ServiceAccess2.default.instance.track(this.$route.params.sessionId, 'checkout-pay', { kind: medium });
	
	      _ServiceAccess2.default.instance.checkoutWire(this.$route.params.sessionId, medium, this.$route.params.cart).then(function (resp) {
	        _this2.loading = false;
	        _this2.paymentDone = true;
	        _this2.values.id_virement_type = medium;
	        _this2.values.id_attente_virement = true;
	        _this2.trackAdsConversion();
	      }, function (err) {
	        _this2.loading = false;
	        console.error('Failed Wire checkout: ', err);
	      });
	    },
	
	    trackAdsConversion: function trackAdsConversion() {
	      var google_conversion_id = 865811613;
	      var google_conversion_language = 'en';
	      var google_conversion_format = '3';
	      var google_conversion_color = 'ffffff';
	      var google_conversion_label = 'IzYDCM7i4WwQnfnsnAM';
	      var google_remarketing_only = false;
	
	      var script = document.createElement('script');
	      script.src = '//www.googleadservices.com/pagead/conversion.js';
	
	      var image = new global.Image(1, 1);
	      image.src = '//www.googleadservices.com/pagead/conversion/865811613/?label=IzYDCM7i4WwQnfnsnAM&amp;guid=ON&amp;script=0';
	    },
	
	    onClickContinue: function onClickContinue() {
	      this.$router.replace('/f/' + this.$route.params.sessionId + '/');
	    }
	
	  }
	
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(15);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _promise = __webpack_require__(14);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _Screen = __webpack_require__(701);
	
	var _Screen2 = _interopRequireDefault(_Screen);
	
	var _ServiceAccess = __webpack_require__(10);
	
	var _ServiceAccess2 = _interopRequireDefault(_ServiceAccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  components: {
	    'screen-view': _Screen2.default
	  },
	
	  data: function data() {
	    return {
	      screens: null,
	      questions: {},
	      errorMessages: {},
	      values: {}
	    };
	  },
	
	  computed: {
	    screen: function screen() {
	      if (this.screens) {
	        if (this.$route.params.screenId != null) {
	          return this.screens.screen(this.$route.params.screenId);
	        } else {
	          return this.screens.screen();
	        }
	      }
	    }
	  },
	
	  created: function created() {
	    var _this = this;
	
	    global.navigationBarBus.$on('navigation-back', this.prevScreen);
	    global.navigationBarBus.$emit('navigation-display-back', true);
	
	    var promises = [_ServiceAccess2.default.instance.loadValues(this.$route.params.sessionId), _ServiceAccess2.default.instance.loadScreens(), _ServiceAccess2.default.instance.loadErrorMessages(), _ServiceAccess2.default.instance.loadQuestions()];
	    _promise2.default.all(promises).then(function (responses) {
	      var _responses = (0, _slicedToArray3.default)(responses, 4),
	          values = _responses[0],
	          screens = _responses[1],
	          errorMessages = _responses[2],
	          questions = _responses[3];
	
	      _this.values = values;
	      global.navigationBarBus.$emit('display-save', values.id_user_mail == null);
	      _this.screens = screens;
	      _this.errorMessages = errorMessages;
	      _this.questions = questions;
	    });
	  },
	
	  destroyed: function destroyed() {
	    global.navigationBarBus.$off('navigation-back', this.prevScreen);
	  },
	
	  methods: {
	    sessionPathTo: function sessionPathTo(path) {
	      return path + '/' + this.$route.params.sessionId;
	    },
	
	    prevScreen: function prevScreen() {
	      var currentScreen = this.screen;
	
	      var screenPath = this.screens.screenPath(this.values);
	      if (!screenPath.find(function (s) {
	        return currentScreen.id === s.id;
	      })) {
	        screenPath = this.screens.screenPath(this.values, 'parcours standard');
	      }
	
	      while (screenPath.length > 0) {
	        var screen = screenPath.pop();
	        if (screen.id === currentScreen.id) {
	          break;
	        }
	      }
	      var prevScreen = screenPath.length > 0 ? screenPath.pop() : currentScreen;
	      if (prevScreen !== currentScreen) {
	        this.$router.replace('/f/' + this.$route.params.sessionId + '/' + prevScreen.id);
	      } else {
	        this.$router.back();
	      }
	    },
	    nextScreen: function nextScreen(transitionToScreen) {
	      _ServiceAccess2.default.instance.storeValues(this.$route.params.sessionId, this.values);
	      this.$router.push('/f/' + this.$route.params.sessionId + '/' + transitionToScreen);
	    }
	  }
	
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(110);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _slicedToArray2 = __webpack_require__(15);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _promise = __webpack_require__(14);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _ServiceAccess = __webpack_require__(10);
	
	var _ServiceAccess2 = _interopRequireDefault(_ServiceAccess);
	
	var _UserForm = __webpack_require__(343);
	
	var _UserForm2 = _interopRequireDefault(_UserForm);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  components: {
	    'user-form': _UserForm2.default
	  },
	
	  data: function data() {
	    return {
	      displayUserForm: false,
	      userFormHasError: false,
	      initialized: false,
	
	      purchases: [],
	      questions: {},
	      errorMessages: {},
	      values: null,
	      stage: null,
	      screens: null,
	
	      hasValues: false,
	      hasValueFiles: false,
	
	      payURL: '...'
	    };
	  },
	
	  computed: {
	    isWaitingWire: function isWaitingWire() {
	      return this.stage && this.stage.name === 'wait-payment';
	    },
	    paymentDone: function paymentDone() {
	      return this.stage && this.stage.name === 'payment-done';
	    },
	    isInReview: function isInReview() {
	      return this.stage && this.stage.name === 'in-review';
	    },
	    documentReady: function documentReady() {
	      return this.stage && this.stage.name === 'document-ready';
	    },
	    remainingDays: function remainingDays() {
	      var days = this.dateLimite.diff((0, _moment2.default)(), 'days') + 1;
	      return days;
	    },
	    remainingDaysStr: function remainingDaysStr() {
	      var days = this.remainingDays;
	      if (days > 1) {
	        return days + ' jours';
	      } else {
	        return days + ' jour';
	      }
	    },
	    dateLimite: function dateLimite() {
	      _moment2.default.locale('fr');
	      if (this.values.id_when_refus_crrv) {
	        return (0, _moment2.default)(this.values.id_when_refus, 'YYYY-MM-DD').add(2, 'months').subtract(5, 'days');
	      } else if (this.values.id_when_crrv) {
	        return (0, _moment2.default)(this.values.id_when_crrv, 'YYYY-MM-DD').add(4, 'months').subtract(5, 'days');
	      } else if (this.values.id_when_refus) {
	        return (0, _moment2.default)(this.values.id_when_refus, 'YYYY-MM-DD').add(2, 'months').subtract(5, 'days');
	      } else if (this.values.id_when_app) {
	        return (0, _moment2.default)(this.values.id_when_app, 'YYYY-MM-DD').add(4, 'months').subtract(5, 'days');
	      }
	    },
	    dateLimiteStr: function dateLimiteStr() {
	      var date = this.dateLimite;
	      if (date) {
	        return date.format('Do MMMM YYYY');
	      } else {
	        return null;
	      }
	    }
	  },
	
	  updated: function updated() {
	    this.updateBinding();
	  },
	
	  created: function created() {
	    var _this = this;
	
	    global.navigationBarBus.$emit('navigation-display-back', false);
	    global.navigationBarBus.$emit('display-save', false);
	
	    var promises = [_ServiceAccess2.default.instance.purchases(this.$route.params.sessionId), _ServiceAccess2.default.instance.loadStage(this.$route.params.sessionId), _ServiceAccess2.default.instance.loadValues(this.$route.params.sessionId), _ServiceAccess2.default.instance.loadScreens(), _ServiceAccess2.default.instance.loadErrorMessages(), _ServiceAccess2.default.instance.loadQuestions(), _ServiceAccess2.default.instance.checkoutFriendURL(this.$route.params.sessionId)];
	    _promise2.default.all(promises).then(function (responses) {
	      var _responses = (0, _slicedToArray3.default)(responses, 7),
	          purchases = _responses[0],
	          stage = _responses[1],
	          values = _responses[2],
	          screens = _responses[3],
	          errorMessages = _responses[4],
	          questions = _responses[5],
	          url = _responses[6];
	
	      _this.values = values;
	      _this.stage = stage;
	      global.navigationBarBus.$emit('display-save', (0, _keys2.default)(values).length > 0 && values.id_user_mail == null);
	
	      _this.purchases = purchases;
	      _this.screens = screens;
	      _this.errorMessages = errorMessages;
	      _this.questions = questions;
	      _this.payURL = url;
	      _this.initialized = true;
	      _this.updateBinding();
	    });
	  },
	
	  methods: {
	    updateBinding: function updateBinding() {
	      this.hasValues = this.values && (0, _keys2.default)(this.values).length > 0;
	      this.hasValueFiles = this.values && this.values._files && (0, _keys2.default)(this.values._files).length > 0;
	    },
	
	    screen: function screen(screenId) {
	      var target = screenId || 'start';
	      return '/f/' + this.$route.params.sessionId + '/' + target;
	    },
	
	    entryScreenId: function entryScreenId() {
	      if (this.values.id_howlong >= 0) {
	        if (this.values.id_howlong === 0) {
	          if (this.values.id_why === 0) {
	            return 'parcours etudiant';
	          } else if (this.values.id_why === 1) {
	            return 'parcours conjoint';
	          } else if (this.values.id_why === 2) {
	            return 'parcours stage formation';
	          } else if (this.values.id_why === 3) {
	            return 'parcours etablissement';
	          } else if (this.values.id_why === 4) {
	            return 'parcours professionnelle';
	          } else if (this.values.id_why === 5) {
	            return 'parcours mariage';
	          } else if (this.values.id_why === 6) {
	            return 'parcours visa retour';
	          } else if (this.values.id_why === 7) {
	            return 'parcours medicale';
	          } else if (this.values.id_why === 8) {
	            return 'parcours fonctions officielles';
	          } else if (this.values.id_why === 9) {
	            return 'parcours autre';
	          }
	        } else {
	          if (this.values.id_why_short === 0) {
	            return 'parcours etude court';
	          } else if (this.values.id_why_short === 1) {
	            return 'parcours famille court';
	          } else if (this.values.id_why_short === 2) {
	            return 'parcours tourisme court';
	          } else if (this.values.id_why_short === 3) {
	            return 'parcours affaire court';
	          } else if (this.values.id_why_short === 4) {
	            return 'parcours culture court';
	          } else if (this.values.id_why_short === 5) {
	            return 'parcours sport court';
	          } else if (this.values.id_why_short === 6) {
	            return 'parcours officiel court';
	          } else if (this.values.id_why_short === 7) {
	            return 'parcours medicale court';
	          } else if (this.values.id_why_short === 8) {
	            return 'parcours transit court';
	          } else if (this.values.id_why_short === 9) {
	            return 'parcours transit aero court';
	          } else if (this.values.id_why_short === 10) {
	            return 'parcours autre court';
	          }
	        }
	      } else {
	        return 'parcours visa simple';
	      }
	    },
	
	    startScreen: function startScreen() {
	      if (this.purchases && this.purchases instanceof Array && (this.purchases.includes('VISA') || this.purchases.includes('CRRV') || this.purchases.includes('TA') || this.purchases.includes('PREMIUM'))) {
	        return this.screen(this.entryScreenId());
	      }
	    },
	
	    latestScreen: function latestScreen() {
	
	      if (this.purchases && this.purchases instanceof Array && (this.purchases.includes('VISA') || this.purchases.includes('CRRV') || this.purchases.includes('TA') || this.purchases.includes('PREMIUM'))) {
	        var screenId = this.screens.lastestScreenId(this.values, this.entryScreenId());
	        return this.screen(screenId);
	      } else {
	        var _screenId = this.screens.lastestScreenId(this.values);
	
	        if (_screenId) {
	          return this.screen(_screenId);
	        } else {
	          return this.screen();
	        }
	      }
	    },
	
	    onClickStart: function onClickStart() {
	      _ServiceAccess2.default.instance.track(this.$route.params.sessionId, 'start');
	      this.$router.push(this.screen());
	    },
	
	    onClickComplete: function onClickComplete() {
	      this.$router.push(this.latestScreen());
	    },
	
	    onClickConsult: function onClickConsult() {
	      this.$router.push(this.startScreen());
	    },
	
	    onCopy: function onCopy() {
	      var selection = window.getSelection();
	      selection.removeAllRanges();
	      var payUrlSpan = this.$el.querySelector('.pay-url').firstChild;
	      var range = document.createRange();
	      range.selectNode(payUrlSpan);
	      selection.addRange(range);
	
	      try {
	        document.execCommand('copy');
	      } catch (err) {
	        console.error('Unable to copy', err);
	      }
	    },
	    onEmail: function onEmail() {
	      window.open('mailto:?subject=Aide pour dossier de visa pour la France&body=Bonjour,%0A%0AAfin de compléter ma procédure de visa pour la France, il faut effectuer un paiement en utilisant le lien sécurisé suivant :%0A' + this.payURL);
	    },
	
	    onClickView: function onClickView() {
	      var renderURL = _ServiceAccess2.default.instance.serviceURL + '/file/' + this.$route.params.sessionId + '/' + this.values.document_livrable;
	      console.log('RenderURL', renderURL);
	      window.open(renderURL, '_blank');
	    },
	
	    onClickRender: function onClickRender() {
	      if (this.paymentDone) {
	        _ServiceAccess2.default.instance.track(this.$route.params.sessionId, 'review');
	        var screenId = this.screens.lastestScreenId(this.values, 'relecture');
	        this.$router.push(this.screen(screenId));
	      } else {
	        global.navigationBarBus.$emit('info', 'Nous n\'avons toujours pas encore reçu votre paiement. Nous ne pouvons pas finaliser votre dossier pour le moment.');
	      }
	    },
	
	    onClickValidate: function onClickValidate() {
	      this.userFormHasError = this.$refs.userForm.hasError();
	      if (!this.userFormHasError) {
	        _ServiceAccess2.default.instance.storeValues(this.$route.params.sessionId, this.values);
	        this.displayUserForm = false;
	      }
	    }
	
	  }
	
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 374:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(15);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _promise = __webpack_require__(14);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _ServiceAccess = __webpack_require__(10);
	
	var _ServiceAccess2 = _interopRequireDefault(_ServiceAccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  data: function data() {
	    return {
	      purchases: [],
	      stage: null,
	      values: null,
	      screens: null,
	
	      uploadingFiles: {},
	      loading: false
	    };
	  },
	
	  computed: {
	    documentReady: function documentReady() {
	      return this.stage && this.stage.name === 'document-ready';
	    }
	  },
	
	  created: function created() {
	    var _this = this;
	
	    global.navigationBarBus.$emit('display-save', false);
	
	    var promises = [_ServiceAccess2.default.instance.purchases(this.$route.params.sessionId), _ServiceAccess2.default.instance.loadStage(this.$route.params.sessionId), _ServiceAccess2.default.instance.loadValues(this.$route.params.sessionId), _ServiceAccess2.default.instance.loadScreens()];
	    _promise2.default.all(promises).then(function (responses) {
	      var _responses = (0, _slicedToArray3.default)(responses, 4),
	          purchases = _responses[0],
	          stage = _responses[1],
	          values = _responses[2],
	          screens = _responses[3];
	
	      _this.values = values;
	      _this.stage = stage;
	      _this.purchases = purchases;
	      _this.screens = screens;
	    });
	  },
	
	  methods: {
	    onClickUpload: function onClickUpload(event) {
	      event.currentTarget.querySelector('input').click();
	    },
	    fileInputClick: function fileInputClick(event) {},
	    fileInputChange: function fileInputChange(event) {
	      var files = event.target.files;
	      if (files.length > 0) {
	        var file = files[0];
	        this.fileUpload(file);
	      }
	    },
	    uploadProgress: function uploadProgress(file, event) {
	      this.uploadingFiles[file.name] = Math.round(event.loaded / event.total * 100);
	    },
	    fileUpload: function fileUpload(file) {
	      var _this2 = this;
	
	      this.loading = true;
	      var sessionId = this.$route.params.sessionId;
	      var sign = this.$route.params.sign;
	      _ServiceAccess2.default.instance.convertFileSigned(sessionId, sign, 'students.pdf', file, this.uploadProgress).then(function (fileResponse) {
	        delete _this2.uploadingFiles[file];
	        _this2.loading = false;
	        var filename = fileResponse.filename;
	        _this2.$router.push('/confirm/' + sessionId + '/' + sign + '/' + filename);
	      });
	    },
	
	    onClickConfirm: function onClickConfirm() {
	      var _this3 = this;
	
	      this.loading = true;
	      var sessionId = this.$route.params.sessionId;
	      var sign = this.$route.params.sign;
	      _ServiceAccess2.default.instance.convertAsciiDoc(sessionId, sign, 'students.pdf', this.uploadProgress).then(function (fileResponse) {
	        _this3.loading = false;
	        var filename = fileResponse.filename;
	        _this3.$router.push('/confirm/' + sessionId + '/' + sign + '/' + filename);
	      });
	    }
	
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray2 = __webpack_require__(15);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _promise = __webpack_require__(14);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _ServiceAccess = __webpack_require__(10);
	
	var _ServiceAccess2 = _interopRequireDefault(_ServiceAccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  data: function data() {
	    return {
	      values: null,
	      stage: null,
	      pdfOpened: false,
	      loading: false,
	      confirmed: false
	    };
	  },
	
	  computed: {
	    documentReady: function documentReady() {
	      return this.stage && this.stage.name === 'document-ready';
	    }
	  },
	
	  created: function created() {
	    var _this = this;
	
	    global.navigationBarBus.$emit('display-save', false);
	
	    var promises = [_ServiceAccess2.default.instance.loadValues(this.$route.params.sessionId), _ServiceAccess2.default.instance.loadStage(this.$route.params.sessionId)];
	    _promise2.default.all(promises).then(function (responses) {
	      var _responses = (0, _slicedToArray3.default)(responses, 2),
	          values = _responses[0],
	          stage = _responses[1];
	
	      _this.values = values;
	      _this.stage = stage;
	    });
	  },
	
	  methods: {
	    onClickView: function onClickView() {
	      var pdfURL = _ServiceAccess2.default.instance.serviceURL + '/file/' + this.$route.params.sessionId + '/' + this.$route.params.filename;
	      window.open(pdfURL, '_blank');
	      this.pdfOpened = true;
	    },
	    onClickConfirm: function onClickConfirm() {
	      var _this2 = this;
	
	      this.loading = true;
	      _ServiceAccess2.default.instance.confirmFileReview(this.$route.params.sessionId, this.$route.params.sign, this.$route.params.filename).then(function (response) {
	        _this2.loading = false;
	        _this2.confirmed = true;
	      }, function (err) {
	        console.err('Error: ', err);
	        _this2.loading = false;
	      });
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(72);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__(110);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _slicedToArray2 = __webpack_require__(15);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _promise = __webpack_require__(14);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _ServiceAccess = __webpack_require__(10);
	
	var _ServiceAccess2 = _interopRequireDefault(_ServiceAccess);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  data: function data() {
	    return {
	      purchases: [],
	      values: null,
	      questions: null
	
	    };
	  },
	
	  created: function created() {
	    var _this = this;
	
	    global.navigationBarBus.$emit('display-save', false);
	
	    var promises = [_ServiceAccess2.default.instance.purchases(this.$route.params.sessionId), _ServiceAccess2.default.instance.loadValues(this.$route.params.sessionId), _ServiceAccess2.default.instance.loadQuestions()];
	    _promise2.default.all(promises).then(function (responses) {
	      var _responses = (0, _slicedToArray3.default)(responses, 3),
	          purchases = _responses[0],
	          values = _responses[1],
	          questions = _responses[2];
	
	      _this.values = values;
	      _this.purchases = purchases;
	      _this.questions = questions;
	    });
	  },
	
	  methods: {
	
	    getQuestionContent: function getQuestionContent(k) {
	
	      if (this.questions[k]) {
	        return this.questions[k].q.fr;
	      } else {
	        if (k === '_files') {
	          return 'Fichiers';
	        }
	      }
	      return k;
	    },
	
	    getResponse: function getResponse(v, k, i) {
	      var _this2 = this;
	
	      if (k === '_files') {
	        var ffiles = this.values[k];
	        return (0, _keys2.default)(ffiles).map(function (kf) {
	          var files = ffiles[kf];
	          var kqs = (0, _keys2.default)(_this2.questions).filter(function (kq) {
	            return kf.startsWith(kq);
	          });
	
	          var kq = null;
	          if (kqs && kqs.length > 0) {
	            kq = kqs.reduce(function (prev, curr, index, array) {
	              return curr.length > prev.length ? curr : prev;
	            });
	          }
	          var label = '';
	
	          if (kq) {
	            if (kf.length > kq.length) {
	              console.log('kq', kq, ' - kf', kf);
	              var index = parseInt(kf.substring(kq.length + 1));
	              console.log('Index', index);
	              label = _this2.questions[kq].a.files[index].label.fr;
	            } else {
	              label = _this2.questions[kq].a.file.label.fr;
	            }
	          }
	
	          return label + '<ul><li>' + files.map(function (f) {
	            return '<a href="' + _ServiceAccess2.default.instance.serviceURL + '/file/' + _this2.$route.params.sessionId + '/' + f.hashname + '">' + f.filename + '</a>';
	          }).join('</li><li>') + '</li></ul>';
	        }).join('<br>');
	      } else if (this.questions[k]) {
	        var qtype = this.questions[k].a.type;
	        if (qtype === 'number' || qtype === 'text') {
	          return v;
	        } else if (qtype === 'boolean' || qtype === 'check') {
	          return v ? 'Oui' : 'Non';
	        } else if (qtype === 'date') {
	          _moment2.default.locale('fr');
	          var date = (0, _moment2.default)(v, 'YYYY-MM-DD');
	          return date.format('Do MMMM YYYY');
	        } else if (qtype === 'array') {
	          if (v instanceof Array) {
	            return '<ul><li>' + v.map(function (v) {
	              return _this2.questions[k].array(_this2.values)[v].fr;
	            }).join('</li><li>') + '</li></ul>';
	          } else {
	            return this.questions[k].array(this.values)[v].fr;
	          }
	        } else {
	          return (0, _stringify2.default)(v);
	        }
	      } else {
	        return (0, _stringify2.default)(v);
	      }
	    }
	  }
	
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ServiceAccess = __webpack_require__(10);
	
	var _ServiceAccess2 = _interopRequireDefault(_ServiceAccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  created: function created() {
	    global.navigationBarBus.$on('navigation-back', this.prevScreen);
	    global.navigationBarBus.$emit('navigation-display-back', true);
	    global.navigationBarBus.$emit('display-save', false);
	
	    _ServiceAccess2.default.instance.track(this.$route.params.sessionId, 'screen-ko', { kind: 'Avocat', path: this.$route.path });
	  },
	  destroyed: function destroyed() {
	    global.navigationBarBus.$off('navigation-back', this.prevScreen);
	  },
	
	  methods: {
	    prevScreen: function prevScreen() {
	      this.$router.back();
	    },
	
	    onClickContact: function onClickContact() {
	      global.LC_API.open_chat_window();
	    }
	
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ServiceAccess = __webpack_require__(10);
	
	var _ServiceAccess2 = _interopRequireDefault(_ServiceAccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  created: function created() {
	    global.navigationBarBus.$on('navigation-back', this.prevScreen);
	    global.navigationBarBus.$emit('navigation-display-back', true);
	    global.navigationBarBus.$emit('display-save', false);
	
	    _ServiceAccess2.default.instance.track(this.$route.params.sessionId, 'screen-ko', { kind: 'Demande Visa' });
	  },
	  destroyed: function destroyed() {
	    global.navigationBarBus.$off('navigation-back', this.prevScreen);
	  },
	  methods: {
	    prevScreen: function prevScreen() {
	      this.$router.back();
	    }
	  }
	
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ServiceAccess = __webpack_require__(10);
	
	var _ServiceAccess2 = _interopRequireDefault(_ServiceAccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  created: function created() {
	    global.navigationBarBus.$on('navigation-back', this.prevScreen);
	    global.navigationBarBus.$emit('navigation-display-back', true);
	    global.navigationBarBus.$emit('display-save', false);
	
	    _ServiceAccess2.default.instance.track(this.$route.params.sessionId, 'screen-ko', { kind: 'N/A' });
	  },
	  destroyed: function destroyed() {
	    global.navigationBarBus.$off('navigation-back', this.prevScreen);
	  },
	
	  methods: {
	    prevScreen: function prevScreen() {
	      this.$router.back();
	    },
	    onClickContact: function onClickContact() {
	      global.LC_API.open_chat_window();
	    }
	
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ServiceAccess = __webpack_require__(10);
	
	var _ServiceAccess2 = _interopRequireDefault(_ServiceAccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  created: function created() {
	    global.navigationBarBus.$on('navigation-back', this.prevScreen);
	    global.navigationBarBus.$emit('navigation-display-back', true);
	    global.navigationBarBus.$emit('display-save', false);
	
	    _ServiceAccess2.default.instance.track(this.$route.params.sessionId, 'screen-contact', { path: this.$route.path });
	  },
	  destroyed: function destroyed() {
	    global.navigationBarBus.$off('navigation-back', this.prevScreen);
	  },
	
	  methods: {
	    prevScreen: function prevScreen() {
	      this.$router.back();
	    },
	    onClickContact: function onClickContact() {
	      global.LC_API.open_chat_window();
	    }
	
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(72);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getIterator2 = __webpack_require__(37);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _typeof2 = __webpack_require__(390);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _slicedToArray2 = __webpack_require__(15);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _promise = __webpack_require__(14);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _ServiceAccess = __webpack_require__(10);
	
	var _ServiceAccess2 = _interopRequireDefault(_ServiceAccess);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  data: function data() {
	    return {
	      values: {},
	
	      questions: {},
	      questionsWithFile: [],
	
	      uploadingFiles: {}
	
	    };
	  },
	
	  created: function created() {
	    var _this = this;
	
	    global.navigationBarBus.$on('navigation-back', this.prevScreen);
	    global.navigationBarBus.$emit('navigation-display-back', true);
	    global.navigationBarBus.$emit('display-save', false);
	
	    var promises = [_ServiceAccess2.default.instance.loadValues(this.$route.params.sessionId), _ServiceAccess2.default.instance.loadQuestions()];
	    _promise2.default.all(promises).then(function (responses) {
	      var _responses = (0, _slicedToArray3.default)(responses, 2),
	          values = _responses[0],
	          questions = _responses[1];
	
	      _this.questions = questions;
	
	      if (!('_files' in values)) {
	        values._files = {};
	      }
	
	      for (var key in values) {
	        if (key.startsWith('_')) {
	          continue;
	        }
	        var question = _this.questions[key];
	        if (question != null && question.hasFile()) {
	          _this.questionsWithFile.push(question);
	        }
	      }
	
	      _this.values = values;
	    });
	  },
	
	  destroyed: function destroyed() {
	    global.navigationBarBus.$off('navigation-back', this.prevScreen);
	  },
	
	  methods: {
	    prevScreen: function prevScreen() {
	      this.$router.push('/f/' + this.$route.params.sessionId);
	    },
	
	    onClickUpload: function onClickUpload(event) {
	      event.currentTarget.querySelector('input').click();
	    },
	
	    onClickShowFile: function onClickShowFile(hashname) {
	      window.open(this.fileRef(hashname), '_blank');
	    },
	
	    fileInputClick: function fileInputClick(event, fid) {},
	    fileInputChange: function fileInputChange(event, fid) {
	      var files = event.target.files;
	      if (!(files instanceof Array)) {
	        if ('length' in files && 'item' in files) {
	          var array = [];
	          for (var i = 0; i < files.length; i++) {
	            array.push(files.item(i));
	          }
	          files = array;
	        } else {
	          window.alert('Unknown file type: ' + (typeof files === 'undefined' ? 'undefined' : (0, _typeof3.default)(files)));
	          console.error('Unknown file type: ' + (typeof files === 'undefined' ? 'undefined' : (0, _typeof3.default)(files)));
	        }
	      }
	      this.fileUpload(files, fid);
	    },
	
	    uploadProgress: function uploadProgress(file, event) {
	      var forceUpdate = !(file.name in this.uploadingFiles);
	      this.uploadingFiles[file.name] = Math.round(event.loaded / event.total * 100);
	      if (forceUpdate) {
	        this.$forceUpdate();
	      }
	    },
	
	    fileUpload: function fileUpload(files, fid) {
	      var _this2 = this;
	
	      if (!(fid in this.values._files)) {
	        this.values._files[fid] = [];
	      }
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        var _loop = function _loop() {
	          var file = _step.value;
	
	          _ServiceAccess2.default.instance.storeFile(_this2.$route.params.sessionId, file, _this2.uploadProgress).then(function (fileResponse) {
	            delete _this2.uploadingFiles[file.name];
	            _this2.removeFile(fid, fileResponse.hashname);
	            _this2.values._files[fid].push(fileResponse);
	            _ServiceAccess2.default.instance.storeValues(_this2.$route.params.sessionId, _this2.values);
	            console.log('File uploaded: ' + (0, _stringify2.default)(fileResponse));
	            _this2.$forceUpdate();
	          }, function (err) {
	            delete _this2.uploadingFiles[file.name];
	            _this2.$forceUpdate();
	            console.error('File error: ', err);
	          });
	        };
	
	        for (var _iterator = (0, _getIterator3.default)(files), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          _loop();
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    },
	
	    fileRef: function fileRef(filename) {
	      return _ServiceAccess2.default.instance.serviceURL + '/file/' + this.$route.params.sessionId + '/' + filename;
	    },
	
	    removeFile: function removeFile(fid, hashname) {
	      if (this.values._files[fid]) {
	        this.values._files[fid] = this.values._files[fid].filter(function (f) {
	          return f.hashname !== hashname;
	        });
	      }
	      _ServiceAccess2.default.instance.storeValues(this.$route.params.sessionId, this.values);
	      this.$forceUpdate();
	    },
	
	    onClickContinue: function onClickContinue() {
	      this.$router.replace('/f/' + this.$route.params.sessionId + '/');
	    }
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 644:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 645:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 646:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 647:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 648:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 649:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 650:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 651:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 652:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 653:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 654:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 655:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 656:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 657:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 658:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 659:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 660:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 661:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 665:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 204,
		"./af.js": 204,
		"./ar": 211,
		"./ar-dz": 205,
		"./ar-dz.js": 205,
		"./ar-kw": 206,
		"./ar-kw.js": 206,
		"./ar-ly": 207,
		"./ar-ly.js": 207,
		"./ar-ma": 208,
		"./ar-ma.js": 208,
		"./ar-sa": 209,
		"./ar-sa.js": 209,
		"./ar-tn": 210,
		"./ar-tn.js": 210,
		"./ar.js": 211,
		"./az": 212,
		"./az.js": 212,
		"./be": 213,
		"./be.js": 213,
		"./bg": 214,
		"./bg.js": 214,
		"./bm": 215,
		"./bm.js": 215,
		"./bn": 216,
		"./bn.js": 216,
		"./bo": 217,
		"./bo.js": 217,
		"./br": 218,
		"./br.js": 218,
		"./bs": 219,
		"./bs.js": 219,
		"./ca": 220,
		"./ca.js": 220,
		"./cs": 221,
		"./cs.js": 221,
		"./cv": 222,
		"./cv.js": 222,
		"./cy": 223,
		"./cy.js": 223,
		"./da": 224,
		"./da.js": 224,
		"./de": 227,
		"./de-at": 225,
		"./de-at.js": 225,
		"./de-ch": 226,
		"./de-ch.js": 226,
		"./de.js": 227,
		"./dv": 228,
		"./dv.js": 228,
		"./el": 229,
		"./el.js": 229,
		"./en-SG": 230,
		"./en-SG.js": 230,
		"./en-au": 231,
		"./en-au.js": 231,
		"./en-ca": 232,
		"./en-ca.js": 232,
		"./en-gb": 233,
		"./en-gb.js": 233,
		"./en-ie": 234,
		"./en-ie.js": 234,
		"./en-il": 235,
		"./en-il.js": 235,
		"./en-nz": 236,
		"./en-nz.js": 236,
		"./eo": 237,
		"./eo.js": 237,
		"./es": 240,
		"./es-do": 238,
		"./es-do.js": 238,
		"./es-us": 239,
		"./es-us.js": 239,
		"./es.js": 240,
		"./et": 241,
		"./et.js": 241,
		"./eu": 242,
		"./eu.js": 242,
		"./fa": 243,
		"./fa.js": 243,
		"./fi": 244,
		"./fi.js": 244,
		"./fo": 245,
		"./fo.js": 245,
		"./fr": 248,
		"./fr-ca": 246,
		"./fr-ca.js": 246,
		"./fr-ch": 247,
		"./fr-ch.js": 247,
		"./fr.js": 248,
		"./fy": 249,
		"./fy.js": 249,
		"./ga": 250,
		"./ga.js": 250,
		"./gd": 251,
		"./gd.js": 251,
		"./gl": 252,
		"./gl.js": 252,
		"./gom-latn": 253,
		"./gom-latn.js": 253,
		"./gu": 254,
		"./gu.js": 254,
		"./he": 255,
		"./he.js": 255,
		"./hi": 256,
		"./hi.js": 256,
		"./hr": 257,
		"./hr.js": 257,
		"./hu": 258,
		"./hu.js": 258,
		"./hy-am": 259,
		"./hy-am.js": 259,
		"./id": 260,
		"./id.js": 260,
		"./is": 261,
		"./is.js": 261,
		"./it": 263,
		"./it-ch": 262,
		"./it-ch.js": 262,
		"./it.js": 263,
		"./ja": 264,
		"./ja.js": 264,
		"./jv": 265,
		"./jv.js": 265,
		"./ka": 266,
		"./ka.js": 266,
		"./kk": 267,
		"./kk.js": 267,
		"./km": 268,
		"./km.js": 268,
		"./kn": 269,
		"./kn.js": 269,
		"./ko": 270,
		"./ko.js": 270,
		"./ku": 271,
		"./ku.js": 271,
		"./ky": 272,
		"./ky.js": 272,
		"./lb": 273,
		"./lb.js": 273,
		"./lo": 274,
		"./lo.js": 274,
		"./lt": 275,
		"./lt.js": 275,
		"./lv": 276,
		"./lv.js": 276,
		"./me": 277,
		"./me.js": 277,
		"./mi": 278,
		"./mi.js": 278,
		"./mk": 279,
		"./mk.js": 279,
		"./ml": 280,
		"./ml.js": 280,
		"./mn": 281,
		"./mn.js": 281,
		"./mr": 282,
		"./mr.js": 282,
		"./ms": 284,
		"./ms-my": 283,
		"./ms-my.js": 283,
		"./ms.js": 284,
		"./mt": 285,
		"./mt.js": 285,
		"./my": 286,
		"./my.js": 286,
		"./nb": 287,
		"./nb.js": 287,
		"./ne": 288,
		"./ne.js": 288,
		"./nl": 290,
		"./nl-be": 289,
		"./nl-be.js": 289,
		"./nl.js": 290,
		"./nn": 291,
		"./nn.js": 291,
		"./pa-in": 292,
		"./pa-in.js": 292,
		"./pl": 293,
		"./pl.js": 293,
		"./pt": 295,
		"./pt-br": 294,
		"./pt-br.js": 294,
		"./pt.js": 295,
		"./ro": 296,
		"./ro.js": 296,
		"./ru": 297,
		"./ru.js": 297,
		"./sd": 298,
		"./sd.js": 298,
		"./se": 299,
		"./se.js": 299,
		"./si": 300,
		"./si.js": 300,
		"./sk": 301,
		"./sk.js": 301,
		"./sl": 302,
		"./sl.js": 302,
		"./sq": 303,
		"./sq.js": 303,
		"./sr": 305,
		"./sr-cyrl": 304,
		"./sr-cyrl.js": 304,
		"./sr.js": 305,
		"./ss": 306,
		"./ss.js": 306,
		"./sv": 307,
		"./sv.js": 307,
		"./sw": 308,
		"./sw.js": 308,
		"./ta": 309,
		"./ta.js": 309,
		"./te": 310,
		"./te.js": 310,
		"./tet": 311,
		"./tet.js": 311,
		"./tg": 312,
		"./tg.js": 312,
		"./th": 313,
		"./th.js": 313,
		"./tl-ph": 314,
		"./tl-ph.js": 314,
		"./tlh": 315,
		"./tlh.js": 315,
		"./tr": 316,
		"./tr.js": 316,
		"./tzl": 317,
		"./tzl.js": 317,
		"./tzm": 319,
		"./tzm-latn": 318,
		"./tzm-latn.js": 318,
		"./tzm.js": 319,
		"./ug-cn": 320,
		"./ug-cn.js": 320,
		"./uk": 321,
		"./uk.js": 321,
		"./ur": 322,
		"./ur.js": 322,
		"./uz": 324,
		"./uz-latn": 323,
		"./uz-latn.js": 323,
		"./uz.js": 324,
		"./vi": 325,
		"./vi.js": 325,
		"./x-pseudo": 326,
		"./x-pseudo.js": 326,
		"./yo": 327,
		"./yo.js": 327,
		"./zh-cn": 328,
		"./zh-cn.js": 328,
		"./zh-hk": 329,
		"./zh-hk.js": 329,
		"./zh-tw": 330,
		"./zh-tw.js": 330
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 665;


/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(645)
	}
	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(356),
	  /* template */
	  __webpack_require__(723),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 699:
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(655)
	}
	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(357),
	  /* template */
	  __webpack_require__(737),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-5b6e1d94",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 700:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(358),
	  /* template */
	  __webpack_require__(732),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 701:
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(646)
	}
	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(360),
	  /* template */
	  __webpack_require__(726),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 702:
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(658)
	}
	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(362),
	  /* template */
	  __webpack_require__(739),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-5bded13f",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(363),
	  /* template */
	  __webpack_require__(724),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 704:
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(648)
	}
	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(364),
	  /* template */
	  __webpack_require__(729),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-3ab88264",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 705:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(365),
	  /* template */
	  __webpack_require__(747),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 706:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(366),
	  /* template */
	  __webpack_require__(725),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 707:
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(654)
	}
	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(367),
	  /* template */
	  __webpack_require__(736),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-51828192",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 708:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(368),
	  /* template */
	  __webpack_require__(744),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 709:
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(644)
	}
	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(369),
	  /* template */
	  __webpack_require__(722),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-01957428",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 710:
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(652)
	  __webpack_require__(651)
	}
	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(370),
	  /* template */
	  __webpack_require__(734),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-4e3bdeaa",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 711:
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(647)
	}
	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(371),
	  /* template */
	  __webpack_require__(728),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-2a1bd0fc",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 712:
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(660)
	}
	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(372),
	  /* template */
	  __webpack_require__(743),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-d5f20b86",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 713:
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(656)
	  __webpack_require__(657)
	}
	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(373),
	  /* template */
	  __webpack_require__(738),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-5bd05cd8",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 714:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(374),
	  /* template */
	  __webpack_require__(731),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 715:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(375),
	  /* template */
	  __webpack_require__(741),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 716:
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(653)
	}
	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(376),
	  /* template */
	  __webpack_require__(735),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  "data-v-4f4d435a",
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 717:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(377),
	  /* template */
	  __webpack_require__(745),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 718:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(378),
	  /* template */
	  __webpack_require__(727),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 719:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(379),
	  /* template */
	  __webpack_require__(742),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 720:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(380),
	  /* template */
	  __webpack_require__(746),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 721:
/***/ (function(module, exports, __webpack_require__) {

	function injectStyle (ssrContext) {
	  __webpack_require__(659)
	}
	var Component = __webpack_require__(7)(
	  /* script */
	  __webpack_require__(381),
	  /* template */
	  __webpack_require__(740),
	  /* styles */
	  injectStyle,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 722:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._m(0), _vm._v(" "), (!_vm.paymentDone) ? _c('div', [_vm._m(1), _vm._v(" "), (_vm.cart == 'VISA') ? _c('md-card', {
	    staticClass: "light-frame"
	  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v("Help with your visa application file " + _vm._s(_vm.price) + "€ TTC")]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v(">Help with your visa application file")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
	    attrs: {
	      "src": "/static/contract.svg"
	    }
	  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.cart == 'CRRV') ? _c('md-card', {
	    staticClass: "light-frame"
	  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v(" Appeal to the Appeals Board on Visa Refusals " + _vm._s(_vm.price) + "€ TTC")]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v(" Appeal to the Appeals Board on Visa Refusals.")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
	    attrs: {
	      "src": "/static/contract.svg"
	    }
	  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.cart == 'TA') ? _c('md-card', {
	    staticClass: "light-frame"
	  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v("Appeal to the Administrative Court of Nantes " + _vm._s(_vm.price) + "€ TTC")]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v("Appeal to the Administrative Court of Nantes")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
	    attrs: {
	      "src": "/static/contract.svg"
	    }
	  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.cart == 'PREMIUM') ? _c('md-card', {
	    staticClass: "light-frame"
	  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v("Premium Pack " + _vm._s(_vm.price) + "€ TTC")]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v("You are assisted and defended by a lawyer.")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
	    attrs: {
	      "src": "/static/lawyer.svg"
	    }
	  })])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "light-frame visa-frame"
	  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "margin-top": "24px"
	    }
	  }, [_c('md-button', {
	    staticClass: "md-raised md-primary large-button",
	    attrs: {
	      "disabled": _vm.loading
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onClickPay()
	      }
	    }
	  }, [_c('span', [_vm._v("Payer")])])], 1), _vm._v(" "), _vm._m(4)])], 1) : _c('div', [_c('h2', [_vm._v("Payment received!")]), _vm._v(" "), (_vm.isFriendPay) ? _c('div', [_c('p', [_vm._v("A confirmation email has just been sent to your friend")]), _vm._v(" "), _c('p', [_vm._v("He/She can now continue the creation of your file")]), _vm._v(" "), _c('p', [_vm._v("We thank you for your help")])]) : _c('div', [_c('p', [_vm._v("A confirmation email has just been sent to you")]), _vm._v(" "), _c('p', [_vm._v("You can now continue the creation of your file.")]), _vm._v(" "), _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "margin-top": "48px"
	    }
	  }, [_c('md-button', {
	    staticClass: "md-raised md-primary large-button",
	    on: {
	      "click": function($event) {
	        return _vm.onClickContinue()
	      }
	    }
	  }, [_vm._v("Continue")])], 1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "padding-bottom": "16px"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "width": "40%",
	      "max-width": "200px"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/credit-card.svg"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "padding": "16px"
	    }
	  }, [_c('h2', [_vm._v("Payment with an international credit card ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "centered-child"
	  }, [_c('div', {
	    staticStyle: {
	      "margin-top": "16px"
	    }
	  }, [_c('img', {
	    staticStyle: {
	      "height": "48px",
	      "margin": "0px 4px"
	    },
	    attrs: {
	      "src": "/static/visa.svg"
	    }
	  }), _vm._v(" "), _c('img', {
	    staticStyle: {
	      "height": "48px",
	      "margin": "0px 4px"
	    },
	    attrs: {
	      "src": "/static/mastercard.svg"
	    }
	  }), _vm._v(" "), _c('img', {
	    staticStyle: {
	      "height": "48px",
	      "margin": "0px 4px"
	    },
	    attrs: {
	      "src": "/static/american-express.svg"
	    }
	  }), _vm._v(" "), _c('img', {
	    staticStyle: {
	      "height": "24px",
	      "margin": "0px 4px"
	    },
	    attrs: {
	      "src": "/static/locked.svg"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "centered-child"
	  }, [_c('div', {
	    staticClass: "form-row",
	    staticStyle: {
	      "width": "80%",
	      "min-width": "400px"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "card-element"
	    }
	  }), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "card-errors",
	      "role": "alert"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "padding": "16px 0px",
	      "flex-direction": "column",
	      "align-items": "center"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "width": "40%",
	      "max-width": "100px"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/powered_by_stripe.svg"
	    }
	  })])])
	}]}

/***/ }),

/***/ 723:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "md-theme",
	      rawName: "v-md-theme",
	      value: ('default'),
	      expression: "'default'"
	    }],
	    staticStyle: {
	      "padding-bottom": "240px"
	    },
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('svg', {
	    staticStyle: {
	      "display": "none"
	    }
	  }, [_c('symbol', {
	    attrs: {
	      "id": "svg-visafrance-id",
	      "viewBox": "0, 0, 226, 226"
	    }
	  }, [_c('g', {
	    attrs: {
	      "id": "Layer_1"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "M208.092,139.805 L173.592,172.305 L113.092,160.805 L164.092,139.805 z",
	      "fill": "#FFFFFF"
	    }
	  }), _vm._v(" "), _c('path', {
	    attrs: {
	      "d": "M173.592,172.305 L120.092,186.805 L58.342,220.305 L85.092,191.805 L113.092,160.805 z",
	      "fill": "#FFFFFF"
	    }
	  }), _vm._v(" "), _c('path', {
	    attrs: {
	      "d": "M208.092,139.805 L208.092,153.805 L200.662,146.805 z",
	      "fill": "#FFFFFF"
	    }
	  }), _vm._v(" "), _c('path', {
	    attrs: {
	      "d": "M138.592,77.805 L164.092,139.805 L113.092,160.805 z",
	      "fill": "#FFFFFF"
	    }
	  }), _vm._v(" "), _c('path', {
	    attrs: {
	      "d": "M208.092,139.805 L164.092,139.805 L186.092,130.305 z",
	      "fill": "#FFFFFF"
	    }
	  }), _vm._v(" "), _c('path', {
	    attrs: {
	      "d": "M138.592,77.805 L113.092,160.805 L96.592,36.805 z",
	      "fill": "#FFFFFF"
	    }
	  }), _vm._v(" "), _c('path', {
	    attrs: {
	      "d": "M96.592,36.805 L113.092,160.805 L82.092,130.305 z",
	      "fill": "#FFFFFF"
	    }
	  }), _vm._v(" "), _c('path', {
	    attrs: {
	      "d": "M96.592,36.805 L82.092,130.305 L66.092,57.305 z",
	      "fill": "#FFFFFF"
	    }
	  }), _vm._v(" "), _c('path', {
	    attrs: {
	      "d": "M96.592,36.805 L66.092,57.305 L74.092,14.305 z",
	      "fill": "#FFFFFF"
	    }
	  }), _vm._v(" "), _c('path', {
	    attrs: {
	      "d": "M74.092,14.305 L66.092,57.305 L37.592,5.305 z",
	      "fill": "#FFFFFF"
	    }
	  }), _vm._v(" "), _c('path', {
	    attrs: {
	      "d": "M85.092,191.805 L58.342,220.305 L31.592,202.805 z",
	      "fill": "#FFFFFF"
	    }
	  })])])]), _vm._v(" "), _c('svg', {
	    staticStyle: {
	      "display": "none"
	    }
	  }, [_c('symbol', {
	    attrs: {
	      "id": "svg-right-chevron",
	      "viewBox": "0 0 404.258 404.258"
	    }
	  }, [_c('polygon', {
	    attrs: {
	      "points": "138.331,0 114.331,18 252.427,202.129 114.331,386.258 138.331,404.258 289.927,202.129 ",
	      "fill": "currentColor"
	    }
	  })])]), _vm._v(" "), _c('svg', {
	    staticStyle: {
	      "display": "none"
	    }
	  }, [_c('symbol', {
	    attrs: {
	      "id": "svg-star",
	      "viewBox": "0 0 426.667 426.667"
	    }
	  }, [_c('polygon', {
	    attrs: {
	      "points": "213.333,10.441 279.249,144.017 426.667,165.436 320,269.41 345.173,416.226 213.333,346.91\n        81.485,416.226 106.667,269.41 0,165.436 147.409,144.017 ",
	      "fill": "currentColor"
	    }
	  })])]), _vm._v(" "), _c('svg', {
	    staticStyle: {
	      "display": "none"
	    }
	  }, [_c('symbol', {
	    attrs: {
	      "id": "svg-star-half",
	      "viewBox": "0 0 426.667 426.667"
	    }
	  }, [_c('path', {
	    attrs: {
	      "d": "m 213.33594,0 0.0215,0.04297 v 336.43751 l -0.0215,-0.0117 -131.8418,69.3164 L 106.66797,258.96876 0,154.99415 147.41992,133.57618 Z",
	      "fill": "currentColor"
	    }
	  }), _vm._v(" "), _c('path', {
	    attrs: {
	      "d": "m 213.33304,6e-6 0.002,0.002 -65.91602,133.574224 h -0.002 z m 0.0234,0.04688 65.90039,133.529294 147.41016,21.41797 -106.66797,103.97461 25.18359,146.81641 -131.82617,-69.30469 z",
	      "fill": "#cccccc"
	    }
	  })])]), _vm._v(" "), _c('md-toolbar', [(_vm.displayBackButton) ? _c('md-button', {
	    staticClass: "md-icon-button",
	    on: {
	      "click": function($event) {
	        return _vm.onClickBack()
	      }
	    }
	  }, [_c('md-icon', [_vm._v("arrow_back")])], 1) : _c('div', {
	    staticStyle: {
	      "margin": "0px 8px 8px 8px"
	    }
	  }, [_c('svg', {
	    attrs: {
	      "width": "40px",
	      "height": "40px"
	    }
	  }, [_c('use', {
	    attrs: {
	      "xlink:href": "#svg-visafrance-id"
	    }
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "md-title",
	    staticStyle: {
	      "flex": "1"
	    }
	  }, [_vm._v("Visa To France")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-icon-button",
	    on: {
	      "click": function($event) {
	        return _vm.onClickHome()
	      }
	    }
	  }, [_c('md-icon', [_vm._v("home")])], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "breadcrumb-container"
	  }, [_c('div', {
	    style: ({
	      color: _vm.breadcrumb > 0 ? '#eee' : '#555'
	    })
	  }, [_vm._v("1. Qualification")]), _vm._v(" "), _c('svg', {
	    style: ({
	      color: _vm.breadcrumb > 1 ? '#eee' : '#555'
	    })
	  }, [_c('use', {
	    attrs: {
	      "xlink:href": "#svg-right-chevron"
	    }
	  })]), _vm._v(" "), _c('div', {
	    style: ({
	      color: _vm.breadcrumb > 1 ? '#eee' : '#555'
	    })
	  }, [_vm._v("2. Payment")]), _vm._v(" "), _c('svg', {
	    style: ({
	      color: _vm.breadcrumb > 2 ? '#eee' : '#555'
	    })
	  }, [_c('use', {
	    attrs: {
	      "xlink:href": "#svg-right-chevron"
	    }
	  })]), _vm._v(" "), _c('div', {
	    style: ({
	      color: _vm.breadcrumb > 2 ? '#eee' : '#555'
	    })
	  }, [_vm._v("3. Constitution of your file")]), _vm._v(" "), _c('svg', {
	    style: ({
	      color: _vm.breadcrumb > 3 ? '#eee' : '#555'
	    })
	  }, [_c('use', {
	    attrs: {
	      "xlink:href": "#svg-right-chevron"
	    }
	  })]), _vm._v(" "), _c('div', {
	    style: ({
	      color: _vm.breadcrumb > 3 ? '#eee' : '#555'
	    })
	  }, [_vm._v("4. Reading and mailing")])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "display": "flex",
	      "flex-direction": "column"
	    }
	  }, [(_vm.displaySave) ? _c('div', {
	    staticClass: "save-container",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.saveUnfolded = true
	      }
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_c('span', {
	    staticStyle: {
	      "font-size": "1.2em",
	      "font-weight": "500"
	    }
	  }, [_vm._v("Save your answers")]), _c('br'), _vm._v(" "), (_vm.saveUnfolded) ? _c('span', {
	    staticStyle: {
	      "font-size": "0.8em"
	    }
	  }, [_vm._v("Enter your email address and click on save")]) : _vm._e()]), _vm._v(" "), (_vm.saveUnfolded) ? _c('md-input-container', {
	    staticStyle: {
	      "min-width": "260px",
	      "margin-left": "32px",
	      "margin-right": "32px"
	    }
	  }, [_c('md-input', {
	    attrs: {
	      "type": "email",
	      "placeholder": "Your e-mail address"
	    },
	    on: {
	      "keyup": [function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.onSave($event)
	      }, function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
	        _vm.values.id_user_mail = null
	      }]
	    },
	    model: {
	      value: (_vm.values.id_user_mail),
	      callback: function($$v) {
	        _vm.$set(_vm.values, "id_user_mail", $$v)
	      },
	      expression: "values.id_user_mail"
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.saveUnfolded) ? _c('md-button', {
	    staticClass: "md-raised md-primary save-button",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.onSave($event)
	      }
	    }
	  }, [_vm._v("Save")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "centered-child"
	  }, [_c('md-whiteframe', {
	    staticClass: "main-container",
	    attrs: {
	      "md-elevation": "1"
	    }
	  }, [_c('router-view')], 1)], 1), _vm._v(" "), (_vm.initialized && (_vm.$route.name == 'home' || _vm.$route.name == 'checkout')) ? _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "margin-top": "16px"
	    }
	  }, [_c('md-whiteframe', {
	    staticClass: "main-container faq-container",
	    attrs: {
	      "md-elevation": "1"
	    }
	  }, [_c('h3', [_vm._v("Need help?")]), _vm._v(" "), (_vm.breadcrumb <= 2) ? _c('div', {
	    staticClass: "light-frame faq-item",
	    on: {
	      "click": function($event) {
	        _vm.show1 = !_vm.show1
	      }
	    }
	  }, [_c('div', {
	    staticClass: "faq-title"
	  }, [_c('div', {
	    staticClass: "faq-plus"
	  }, [_vm._v("+")]), _c('div', [_vm._v("Why should I appeal ?")])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.show1) ? _c('div', {
	    staticStyle: {
	      "padding": "16px 32px"
	    }
	  }, [_c('p', [_vm._v("The consulate can refuse your visa application for different reasons. Generally, it means that they have some  "), _c('b', [_vm._v("doubts about the reason ")]), _vm._v("of your stay in France, you do not have enough money to stay in France, doubts about your wish to go back in your country by the end of your trip… ")]), _vm._v(" "), _c('p', [_vm._v("Most of the time, it is caused by a lack of supporting documents.")]), _vm._v(" "), _c('p', [_vm._v("In case of short stay visa, you might have received another document with your refusal which indicates the reason of your refusal. You will find more explications  "), _c('a', {
	    attrs: {
	      "href": "https://getmyvisatofrance.com/motifs-refus-visa-france.html"
	    }
	  }, [_vm._v("of the reasons here")]), _vm._v(".")])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.breadcrumb <= 4) ? _c('div', {
	    staticClass: "light-frame faq-item",
	    on: {
	      "click": function($event) {
	        _vm.show2 = !_vm.show2
	      }
	    }
	  }, [_c('div', {
	    staticClass: "faq-title"
	  }, [_c('div', {
	    staticClass: "faq-plus"
	  }, [_vm._v("+")]), _c('div', [_vm._v("What are the chances of success ?")])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.show2) ? _c('div', {
	    staticStyle: {
	      "padding": "16px 32px"
	    }
	  }, [_c('p', [_vm._v("To get a visa, the first step is to make an administrative appeal. It is useful if you need to complete your file quickly. The consulate rarely review the files. If you do not have an answer after 2 months you can consider that your appeal has been refused.")]), _vm._v(" "), _c('p', [_vm._v("You also need to appeal to the Appeals Board on Visa Refusals. You will get the answer within 2 months (if there is no answer after 2 months you can consider that your appeal is refused). The board only review 1 out of 3 file, and only 30% get a positive answer. Our success rate is 50%.")]), _vm._v(" "), _c('p', [_vm._v("If you have a negative answer from the Appeals Board on Visa Refusals, you still can appeal to the Administrative Court of Nantes. All the files are reviewed and our success rate is about 75%")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("To sum up : You multiplied by 3 your chances to have a positive appeal with us !")])])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.breadcrumb <= 2) ? _c('div', {
	    staticClass: "light-frame faq-item",
	    on: {
	      "click": function($event) {
	        _vm.show3 = !_vm.show3
	      }
	    }
	  }, [_c('div', {
	    staticClass: "faq-title"
	  }, [_c('div', {
	    staticClass: "faq-plus"
	  }, [_vm._v("+")]), _c('div', [_vm._v("Is it free ?")])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.show3) ? _c('div', {
	    staticStyle: {
	      "padding": "16px 32px"
	    }
	  }, [_c('p', [_vm._v("You can appeal by yourself to the Appeals Board on Visa Refusals and to the Administrative Court of Nantes by following this instructions "), _c('a', {
	    attrs: {
	      "href": "http://www.ambafrance-ht.org/Refus-de-visa-Comment-saisir-la"
	    }
	  })]), _vm._v(" "), _c('p', [_vm._v("GetMyVisa service is "), _c('b', [_vm._v("profitable")]), _vm._v(" and deliver you some personalised appeal according to your situation. The appeals are reviewed by our experts before being sending back to you after 48 working hours")]), _vm._v(" "), _c('p', [_vm._v("Our prices are "), _c('b', [_vm._v("all-inclusive")]), _vm._v("! and we propose you 2 different rates"), _c('br'), _vm._v(" "), _c('ul', [_c('li', [_c('b', [_vm._v("299€ TTC")]), _vm._v(": You will receive a personalised appeal, you will prepare your file only online , your file will be processed thanks to our tool developed with our lawyers")]), _vm._v(" "), _c('li', [_c('b', [_vm._v("999€ TTC")]), _vm._v(": We offer you the possibility to make your file with our lawyers. You will have some online meetings with them. Our lawyers will make all your appeals.")])])]), _vm._v(" "), _c('p', [_vm._v("Normally, an appeal made by a lawyer costs between 1800-2500€ in Paris.")]), _vm._v(" "), _c('p', [_vm._v("If your appeal is positive, the French state can pay you back all the fees.")])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.breadcrumb <= 3) ? _c('div', {
	    staticClass: "light-frame faq-item",
	    on: {
	      "click": function($event) {
	        _vm.show4 = !_vm.show4
	      }
	    }
	  }, [_c('div', {
	    staticClass: "faq-title"
	  }, [_c('div', {
	    staticClass: "faq-plus"
	  }, [_vm._v("+")]), _c('div', [_vm._v("What are the deadlines to appeal ?")])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.show4) ? _c('div', {
	    staticStyle: {
	      "padding": "16px 32px"
	    }
	  }, [_c('p', [_vm._v("GetMyVisa service is "), _c('b', [_vm._v("profitable")]), _vm._v(" and deliver you some personalised appeal according to your situation. The appeals are reviewed by our experts before being sending back to you after 48 working hours")]), _vm._v(" "), _c('p', [_vm._v("the Appeals Board on Visa Refusals gives an answer "), _c('b', [_vm._v("within 2 months")]), _vm._v(". The Administrative Court of Nantes gives an answer "), _c('b', [_vm._v("within 10 months.")])]), _vm._v(" "), _c('p', [_vm._v("In case of emergency : health problem, special events (wedding, contest), it is possible to get a review of your case "), _c('b', [_vm._v("within 15 days")]), _vm._v(" with a referred procedure. You only can have this service with our Premium Pack because you need the help of our lawyers")])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.breadcrumb <= 2) ? _c('div', {
	    staticClass: "light-frame faq-item",
	    on: {
	      "click": function($event) {
	        _vm.show5 = !_vm.show5
	      }
	    }
	  }, [_c('div', {
	    staticClass: "faq-title"
	  }, [_c('div', {
	    staticClass: "faq-plus"
	  }, [_vm._v("+")]), _c('div', [_vm._v("I appealed to the Appeals Board on Visa Refusals but I still de not have answer !")])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.show5) ? _c('div', {
	    staticStyle: {
	      "padding": "16px 32px"
	    }
	  }, [_c('p', [_vm._v(" The Appeals Board on Visa Refusals only reviews 1 out of 3 appeals. If you do not have answer "), _c('b', [_vm._v("within 2 months")]), _vm._v(" it means that your appeal has been refused."), _vm._v(".\n              ")]), _vm._v(" "), _c('p', [_vm._v(" The "), _c('b', [_vm._v("good news")]), _vm._v(" is that you are now able to appeal to the the Administrative Court of Nantes. This administration reviews each appeal. The waiting time is longer but you have more chances to get a positive answer.\n              ")])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.$route.name == 'checkout') ? _c('div', {
	    staticClass: "light-frame faq-item",
	    on: {
	      "click": function($event) {
	        _vm.show6 = !_vm.show6
	      }
	    }
	  }, [_c('div', {
	    staticClass: "faq-title"
	  }, [_c('div', {
	    staticClass: "faq-plus"
	  }, [_vm._v("+")]), _c('div', [_vm._v("What guarantees do I have ? Am I repaid if I have a refusal ?")])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.show6) ? _c('div', {
	    staticStyle: {
	      "padding": "16px 32px"
	    }
	  }, [_c('p', [_vm._v("It’s impossible for us to guarantee the success of your appeal. It depends on different factors like your capacity to get all the documents we ask you and sent it by mail to the administration.")]), _vm._v(" "), _c('p', [_vm._v("But you can be sure that you will get a personalised appeal with a list of the documents you need to send. If we are not able to make a personalised appeal you will be refund.")]), _vm._v(" "), _c('p', [_vm._v("Moreover, our appeals"), _c('b', [_vm._v("are reviewed by our lawyers")])]), _vm._v(" "), _c('p', [_vm._v("If your appeal is positive, the French state can pay you back all the all the fees.")])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.breadcrumb == 2) ? _c('div', {
	    staticClass: "light-frame faq-item",
	    on: {
	      "click": function($event) {
	        _vm.show7 = !_vm.show7
	      }
	    }
	  }, [_c('div', {
	    staticClass: "faq-title"
	  }, [_c('div', {
	    staticClass: "faq-plus"
	  }, [_vm._v("+")]), _c('div', [_vm._v("Do I have to pay first ?")])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.show7) ? _c('div', {
	    staticStyle: {
	      "padding": "16px 32px"
	    }
	  }, [_c('p', [_vm._v("Yes. You can be sure that you will get your personalised appeal in a few days. If we do not respect our promess you will be paid back.")]), _vm._v(" "), _c('p', [_vm._v("Once the payment made, you will ahve access to our tool. If you have all the documents we need, you will receive your appeal within 48 working hours.")])]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.breadcrumb <= 4) ? _c('div', {
	    staticClass: "light-frame faq-item",
	    on: {
	      "click": function($event) {
	        _vm.show8 = !_vm.show8
	      }
	    }
	  }, [_c('div', {
	    staticClass: "faq-title"
	  }, [_c('div', {
	    staticClass: "faq-plus"
	  }, [_vm._v("+")]), _c('div', [_vm._v("I do not have news for my appeal, what happens ?")])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.show8) ? _c('div', {
	    staticStyle: {
	      "padding": "16px 32px"
	    }
	  }, [_c('p', [_vm._v("If you gave us all the documents we asked, you will get your appeal within 48 working hours. As the appeal has to be reviewed by our lawyers, they might be non available for personal issues. "), _c('u', [_vm._v("You will get your appeal as soon as possible")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("We never forget you !")])]) : _vm._e()])], 1) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (!_vm.initialized) ? _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "margin-top": "16px"
	    }
	  }, [_c('md-whiteframe', {
	    staticClass: "main-container centered-child",
	    attrs: {
	      "md-elevation": "1"
	    }
	  }, [(_vm.initializationError) ? _c('p', [_vm._v("\n          We have a problem with our IT server. Our team is repairing the problem."), _c('br'), _vm._v("\n         You can contact us at "), _c('a', {
	    attrs: {
	      "href": "mailto:contact-visa@getmyvisatofrance.com"
	    }
	  }, [_vm._v("contact-visa@getmyvisatofrance.com")]), _vm._v(" in case of emergency.\n        ")]) : _c('p', [_vm._v("\n          Please wait, charging in progress.\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.initializationError) ? _c('i', {
	    staticClass: "fa fa-exclamation-triangle",
	    staticStyle: {
	      "font-size": "64px",
	      "margin-top": "16px",
	      "color": "#888"
	    }
	  }) : _c('i', {
	    staticClass: "fa fa-gear fa-spin",
	    staticStyle: {
	      "font-size": "48px",
	      "margin-top": "0px",
	      "color": "#888"
	    }
	  })])], 1) : _vm._e()]), _vm._v(" "), (_vm.displayModal) ? _c('transition', {
	    attrs: {
	      "name": "modal"
	    }
	  }, [_c('div', {
	    staticClass: "modal-mask",
	    on: {
	      "click": function($event) {
	        return _vm.onClickCloseModal()
	      }
	    }
	  }, [_c('div', {
	    staticClass: "modal-wrapper"
	  }, [_c('div', {
	    staticClass: "modal-container",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	      }
	    }
	  }, [_c('md-toolbar', {
	    staticClass: "md-dense"
	  }, [_c('h2', {
	    staticClass: "md-title",
	    staticStyle: {
	      "flex": "2"
	    }
	  }, [_vm._v(_vm._s(_vm.modalTitle))]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-icon-button",
	    staticStyle: {
	      "padding-right": "0px"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onClickCloseModal()
	      }
	    }
	  }, [_c('md-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "md-body-2",
	    staticStyle: {
	      "padding": "16px"
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.modalBody)
	    }
	  })], 1)])])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 724:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v("Administrative form")]), _vm._v(" "), (_vm.questions != null && _vm.values != null && _vm.errorMessages != null) ? _c('user-form', {
	    ref: "userForm",
	    attrs: {
	      "questions": _vm.questions,
	      "values": _vm.values,
	      "error-messages": _vm.errorMessages
	    }
	  }) : _c('div', [_vm._v("\n    Update the webpage ...\n  ")]), _vm._v(" "), (_vm.userFormHasError) ? _c('div', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("\n    Complete the form before paying\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "margin-top": "48px"
	    }
	  }, [_c('md-button', {
	    staticClass: "md-raised md-primary large-button",
	    on: {
	      "click": function($event) {
	        return _vm.onClickValidate()
	      }
	    }
	  }, [_vm._v("Confirm")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 725:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v("\nBefore continue and in order to better assist you...")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.questions != null && _vm.values != null && _vm.errorMessages != null) ? _c('div', [(_vm.questions != null && _vm.values != null && _vm.errorMessages != null) ? _c('why-form', {
	    ref: "userForm",
	    attrs: {
	      "questions": _vm.questions,
	      "values": _vm.values,
	      "error-messages": _vm.errorMessages
	    }
	  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "margin-top": "48px"
	    }
	  }, [_c('md-button', {
	    staticClass: "md-raised md-primary large-button",
	    on: {
	      "click": function($event) {
	        return _vm.onClickValidate()
	      }
	    }
	  }, [_vm._v("Confirm")])], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "padding-bottom": "16px"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "width": "100%",
	      "max-width": "200px"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/question.svg",
	      "width": "100%"
	    }
	  })])])
	}]}

/***/ }),

/***/ 726:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', _vm._l((_vm.statePath), function(state) {
	    return _c('form-question', {
	      key: state,
	      ref: "question",
	      refInFor: true,
	      staticClass: "light-frame",
	      attrs: {
	        "question": _vm.questions[state.qid],
	        "values": _vm.values,
	        "value": _vm.values[state.qid],
	        "error-message": _vm.errorMessage(state.qid)
	      },
	      on: {
	        "answer-value": function($event) {
	          return _vm.nextState(state, $event)
	        }
	      }
	    })
	  }), 1), _vm._v(" "), (_vm.transitionToScreen != null) ? _c('div', {
	    staticClass: "centered-child"
	  }, [_c('md-button', {
	    staticClass: "md-raised md-primary large-button",
	    attrs: {
	      "disabled": _vm.loading
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onClickContinue()
	      }
	    }
	  }, [_vm._v("Continue")]), _vm._v(" "), (_vm.hasError) ? _c('div', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("Please correct the mistakes before ")]) : _vm._e()], 1) : _vm._e()])
	},staticRenderFns: []}

/***/ }),

/***/ 727:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "width": "100%",
	      "height": "100%"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Application for a visa for France")]), _vm._v(" "), _c('p', [_vm._v("\n      You mentioned that you did not apply for a visa yet. ")]), _vm._v(" "), _c('p', [_vm._v("Our lawyers can help you to build your application file and write a cover letter. Ce service est un service premium (999€ TTC). ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', [_vm._v("\n      réalisé une demande de visa\nIf you have made a mistake in your answers and you have already applied for a visa, you can "), _c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_vm._v("restart our questionnaire")]), _vm._v(".\n    ")], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "padding-bottom": "16px"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "width": "100%",
	      "max-width": "200px"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/justice-scale.svg",
	      "width": "100%"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("Pour y souscrire, il vous suffit de cliquer sur ce lien suivant : XXX"), _c('br')])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("\n      Sinon nous vous invitons à effectuer une demande de visa auprès des services consulaires français "), _c('a', {
	    attrs: {
	      "href": "https://www.service-public.fr/particuliers/vosdroits/N105"
	    }
	  }, [_vm._v("for more information")]), _vm._v(".\n    ")])
	}]}

/***/ }),

/***/ 728:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._m(0), _vm._v(" "), (!_vm.paymentDone) ? _c('div', [_vm._m(1), _vm._v(" "), (_vm.$route.params.cart == 'VISA') ? _c('md-card', {
	    staticClass: "light-frame"
	  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v("Help with your visa application file 120€ TTC")]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v("Help with your visa application file.")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
	    attrs: {
	      "src": "/static/contract.svg"
	    }
	  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.cart == 'CRRV') ? _c('md-card', {
	    staticClass: "light-frame"
	  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v("Appeal to the Appeals Board on Visa Refusals 299€ TTC")]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v("Appeal to the Appeals Board on Visa Refusals.")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
	    attrs: {
	      "src": "/static/contract.svg"
	    }
	  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.cart == 'TA') ? _c('md-card', {
	    staticClass: "light-frame"
	  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v("Appeal to the Administrative Court of Nantes 299€ TTC")]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v("appeal to the Administrative Court of Nantes.")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
	    attrs: {
	      "src": "/static/contract.svg"
	    }
	  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.cart == 'PREMIUM') ? _c('md-card', {
	    staticClass: "light-frame"
	  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v("Premium Pack 999€ TTC")]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v("You are assisted and defended by a specialised lawyer..")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
	    attrs: {
	      "src": "/static/lawyer.svg"
	    }
	  })])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "light-frame visa-frame"
	  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', [_vm._v("We send you the details of the procedure an the mounts by email once you accept the engagement conditions")]), _vm._v(" "), _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "margin-top": "24px"
	    }
	  }, [_c('md-button', {
	    staticClass: "md-raised md-primary large-button",
	    attrs: {
	      "disabled": _vm.loading
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onClickPay()
	      }
	    }
	  }, [_c('span', [_vm._v("Pay")])])], 1)])], 1) : _c('div', [_c('h2', [_vm._v("Waiting for the Western Union transfer")]), _vm._v(" "), _c('p', [_vm._v("A confirmation email has just been sent to you")]), _c('p'), _c('p', [_vm._v("Once the Western Union transfer made, please follow the instructions we sent you by email \n        to enter the transfer number (MTCN) in order to finish to constitute your file.")]), _vm._v(" "), _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "margin-top": "48px"
	    }
	  }, [_c('md-button', {
	    staticClass: "md-raised md-primary large-button",
	    on: {
	      "click": function($event) {
	        return _vm.onClickContinue()
	      }
	    }
	  }, [_vm._v("Continue")])], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "padding-bottom": "16px"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "width": "40%",
	      "max-width": "200px"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/western-union.svg"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "padding": "16px"
	    }
	  }, [_c('h2', [_vm._v("Payment by Western Union")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("If you click on the “pay” button you accept to go  "), _c('u', [_vm._v("in a Western Union insitute")]), _vm._v(" to make a transfer to the legal representative of OCTAGRAM SAS company, GetMyVIsaToFrance oprator :")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticStyle: {
	      "padding-left": "16px"
	    }
	  }, [_c('b', [_vm._v("Firstname : Alexandre, René, Georges")]), _c('br'), _vm._v(" "), _c('b', [_vm._v("Last name : GRUX")]), _c('br'), _vm._v(" "), _c('b', [_vm._v("Adress : 59 rue Chardon Lagache 75016 Paris")])])
	}]}

/***/ }),

/***/ 729:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._m(0), _vm._v(" "), (!_vm.paymentDone) ? _c('div', [_vm._m(1), _vm._v(" "), (_vm.$route.params.cart == 'VISA') ? _c('md-card', {
	    staticClass: "light-frame"
	  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v("Help with your visa application file 120€ TTC")]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v("Help with your visa application file")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
	    attrs: {
	      "src": "/static/contract.svg"
	    }
	  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.cart == 'CRRV') ? _c('md-card', {
	    staticClass: "light-frame"
	  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v("Appeal to the Appeals Board on Visa Refusals 299€ TTC")]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v("Appeal to the Appeals Board on Visa Refusals ")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
	    attrs: {
	      "src": "/static/contract.svg"
	    }
	  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.cart == 'TA') ? _c('md-card', {
	    staticClass: "light-frame"
	  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v("Appeal to the Administrative Court of Nantes 299€ TTC")]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v("Appeal to the Administrative Court of Nantes")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
	    attrs: {
	      "src": "/static/contract.svg"
	    }
	  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.cart == 'PREMIUM') ? _c('md-card', {
	    staticClass: "light-frame"
	  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v("Premium Pack 999€ TTC")]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v("You are assisted and defended by a specialised lawyer.")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
	    attrs: {
	      "src": "/static/lawyer.svg"
	    }
	  })])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "light-frame visa-frame"
	  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', [_vm._v("We will send you the details of the procedure by email once you accept the engagement conditions")]), _vm._v(" "), _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "margin-top": "24px"
	    }
	  }, [_c('md-button', {
	    staticClass: "md-raised md-primary large-button",
	    attrs: {
	      "disabled": _vm.loading
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onClickPay()
	      }
	    }
	  }, [_c('span', [_vm._v("Pay")])])], 1)])], 1) : _c('div', [_c('h2', [_vm._v("Waiting for the International Express Money Order payment reception")]), _vm._v(" "), _c('p', [_vm._v("An confirmation email has just been sent to you")]), _c('p'), _c('p', [_vm._v("Once the International Express Money Order transfer made please follow the instruction that you received by email \n        To indicate the money order reference in order to finish to create your file.")]), _vm._v(" "), _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "margin-top": "48px"
	    }
	  }, [_c('md-button', {
	    staticClass: "md-raised md-primary large-button",
	    on: {
	      "click": function($event) {
	        return _vm.onClickContinue()
	      }
	    }
	  }, [_vm._v("Continue")])], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "padding-bottom": "16px"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "width": "40%",
	      "max-width": "200px"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/mandatexpress.svg"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "padding": "16px"
	    }
	  }, [_c('h2', [_vm._v("Payment with International Express Money Order")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("If you click on the “pay” button you accept to go  "), _c('u', [_vm._v("in a poste office ")]), _vm._v(" to make an International Express Money Order for the OCTAGRAM SAS account, GetMyVIsaToFrance operatore :")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticStyle: {
	      "padding-left": "16px"
	    }
	  }, [_c('b', [_vm._v("Name of the company : OCTAGRAM SAS")]), _c('br'), _vm._v(" "), _c('b', [_vm._v("Adress : 59 rue Chardon Lagache 75016 Paris")])])
	}]}

/***/ }),

/***/ 730:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('p', {
	    staticClass: "md-body-2",
	    domProps: {
	      "innerHTML": _vm._s(_vm.question.q.en)
	    }
	  }), _vm._v(" "), (_vm.question.a) ? _c('div', {
	    staticStyle: {
	      "display": "flex",
	      "justify-content": "space-between",
	      "align-items": "center"
	    }
	  }, [(_vm.question.a.type == 'check') ? _c('div', {
	    staticStyle: {
	      "flex-grow": "2"
	    }
	  }, [_c('md-checkbox', {
	    staticClass: "md-primary",
	    attrs: {
	      "name": _vm.question.id
	    },
	    model: {
	      value: (_vm.v),
	      callback: function($$v) {
	        _vm.v = $$v
	      },
	      expression: "v"
	    }
	  }, [_vm._v(_vm._s(_vm.question.a.value.en))])], 1) : _vm._e(), _vm._v(" "), (_vm.question.a.type == 'boolean') ? _c('div', [_c('md-radio', {
	    staticClass: "md-primary",
	    staticStyle: {
	      "padding-right": "16px"
	    },
	    attrs: {
	      "name": _vm.question.id,
	      "md-value": "false"
	    },
	    model: {
	      value: (_vm.v),
	      callback: function($$v) {
	        _vm.v = $$v
	      },
	      expression: "v"
	    }
	  }, [_vm._v("No")]), _vm._v(" "), _c('md-radio', {
	    staticClass: "md-primary",
	    staticStyle: {
	      "padding-right": "16px"
	    },
	    attrs: {
	      "name": _vm.question.id,
	      "md-value": "true"
	    },
	    model: {
	      value: (_vm.v),
	      callback: function($$v) {
	        _vm.v = $$v
	      },
	      expression: "v"
	    }
	  }, [_vm._v("Yes")])], 1) : _vm._e(), _vm._v(" "), (_vm.question.a.type == 'number') ? _c('div', {
	    staticStyle: {
	      "flex-grow": "2"
	    }
	  }, [_c('md-input-container', [_c('md-input', {
	    attrs: {
	      "type": "number",
	      "placeholder": _vm.question.a.placeholder
	    },
	    model: {
	      value: (_vm.v),
	      callback: function($$v) {
	        _vm.v = $$v
	      },
	      expression: "v"
	    }
	  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.question.a.type == 'text') ? _c('div', {
	    staticStyle: {
	      "flex-grow": "2"
	    }
	  }, [_c('md-input-container', [_c('md-input', {
	    attrs: {
	      "placeholder": _vm.question.a.placeholder
	    },
	    model: {
	      value: (_vm.v),
	      callback: function($$v) {
	        _vm.v = $$v
	      },
	      expression: "v"
	    }
	  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.question.a.type == 'date') ? _c('div', {
	    staticStyle: {
	      "flex-grow": "2"
	    }
	  }, [_c('date-picker', {
	    staticStyle: {
	      "margin": "4px 0px 24px 0px"
	    },
	    attrs: {
	      "date": _vm.date,
	      "option": _vm.datePickerOption
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.question.a.type == 'array') ? _c('div', {
	    staticStyle: {
	      "flex-grow": "2"
	    }
	  }, [(_vm.question.a.max == 1 && _vm.question.a.display == 'radio') ? _c('div', _vm._l((_vm.array), function(item, i) {
	    return _c('md-radio', {
	      key: i,
	      staticClass: "md-primary",
	      staticStyle: {
	        "padding-right": "16px"
	      },
	      attrs: {
	        "name": _vm.question.id,
	        "md-value": i + 1
	      },
	      model: {
	        value: (_vm.vcheckbox),
	        callback: function($$v) {
	          _vm.vcheckbox = _vm._n($$v)
	        },
	        expression: "vcheckbox"
	      }
	    }, [_vm._v(_vm._s(item.en))])
	  }), 1) : (_vm.question.a.max == 1) ? _c('div', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.v),
	      expression: "v"
	    }],
	    staticClass: "mdc-select",
	    attrs: {
	      "size": "1"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.v = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option'), _vm._v(" "), _vm._l((_vm.array), function(item, i) {
	    return _c('option', {
	      domProps: {
	        "value": i
	      }
	    }, [_vm._v(_vm._s(item.en))])
	  })], 2)]) : _c('div', _vm._l((_vm.array), function(item, i) {
	    return _c('div', [_c('div', {
	      staticClass: "md-checkbox md-primary",
	      class: {
	        'md-checked': _vm.varray.indexOf(i) >= 0
	      },
	      staticStyle: {
	        "margin": "8px 0px"
	      }
	    }, [_c('div', {
	      staticClass: "md-checkbox-container",
	      staticStyle: {
	        "min-width": "20px"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.onClickCheck(i)
	        }
	      }
	    }, [_c('input', {
	      attrs: {
	        "type": "checkbox",
	        "name": _vm.question.id
	      }
	    }), _vm._v(" "), _vm._m(0, true)]), _vm._v(" "), _c('label', {
	      staticClass: "md-checkbox-label",
	      staticStyle: {
	        "height": "auto"
	      },
	      attrs: {
	        "for": _vm.question.id
	      }
	    }, [_vm._v(_vm._s(item.en))])])])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.question.a.type == 'arraycomplete') ? _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.v),
	      expression: "v"
	    }],
	    attrs: {
	      "list": _vm.question.id,
	      "type": "search"
	    },
	    domProps: {
	      "value": (_vm.v)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.v = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('datalist', {
	    attrs: {
	      "id": _vm.question.id
	    }
	  }, _vm._l((_vm.array), function(item, i) {
	    return _c('option', {
	      key: i,
	      domProps: {
	        "value": item.en
	      }
	    })
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.question.info) ? _c('div', {
	    staticStyle: {
	      "margin-left": "16px"
	    }
	  }, [_c('md-button', {
	    staticClass: "md-icon-button",
	    on: {
	      "click": function($event) {
	        _vm.viewInfo = !_vm.viewInfo
	      }
	    }
	  }, [_c('md-icon', {
	    staticStyle: {
	      "width": "10px",
	      "color": "#FF5722"
	    }
	  }, [_vm._v("help_outline")])], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.viewInfo && _vm.question.info) ? _c('div', {
	    staticStyle: {
	      "padding": "8px 16px 8px 0px"
	    },
	    domProps: {
	      "innerHTML": _vm._s(_vm.question.info.en)
	    }
	  }) : _vm._e()]), _vm._v(" "), (_vm.hasError) ? _c('div', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v(_vm._s(_vm.err()))]) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "md-ink-ripple"
	  }, [_c('div', {
	    staticClass: "md-ripple",
	    staticStyle: {
	      "width": "20px",
	      "height": "20px"
	    }
	  })])
	}]}

/***/ }),

/***/ 731:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v("Envoi du document à transmettre au client")]), _vm._v(" "), (_vm.values) ? _c('div', {
	    staticClass: "light-frame",
	    staticStyle: {
	      "display": "flex",
	      "justify-content": "space-between"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "padding": "16px 16px"
	    }
	  }, [_c('div', {
	    staticClass: "md-headline"
	  }, [_vm._v(_vm._s(_vm.values.id_user_prenom) + " " + _vm._s(_vm.values.id_user_nom))]), _vm._v(" "), _c('div', {
	    staticClass: "md-caption"
	  }, [_vm._v(_vm._s(_vm.values.id_user_adress_street) + ", " + _vm._s(_vm.values.id_user_adress_city) + ", " + _vm._s(_vm.values.id_user_adress_country))]), _vm._v(" "), _c('div', {
	    staticClass: "md-caption"
	  }, [_vm._v(_vm._s(_vm.values.id_user_mail))]), _vm._v(" "), _c('div', {
	    staticClass: "md-caption"
	  }, [_vm._v(_vm._s(_vm.values.id_user_phnum))])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.uploadingFiles), function(percent, name) {
	    return _c('div', [_vm._v("\n      Téléchargement de " + _vm._s(name) + " : " + _vm._s(percent) + "%\n    ")])
	  }), _vm._v(" "), (_vm.documentReady) ? _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "margin-top": "48px",
	      "color": "white",
	      "background-color": "red"
	    }
	  }, [_c('div', {
	    staticClass: "md-headline"
	  }, [_vm._v("Dossier déjà validé")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "margin-top": "48px"
	    }
	  }, [_c('div', {
	    on: {
	      "click": function($event) {
	        return _vm.onClickUpload($event)
	      }
	    }
	  }, [_c('input', {
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "type": "file",
	      "accept": "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.fileInputClick($event)
	      },
	      "change": function($event) {
	        return _vm.fileInputChange($event)
	      }
	    }
	  }), _vm._v(" "), _c('md-button', {
	    staticClass: "md-raised md-primary large-button",
	    attrs: {
	      "disabled": _vm.loading
	    }
	  }, [_vm._v("Envoyer DOCX Corrigé")])], 1), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "width": "100%",
	      "text-align": "center"
	    }
	  }, [_vm._v("OU")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-raised md-primary large-button",
	    attrs: {
	      "disabled": _vm.loading
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onClickConfirm()
	      }
	    }
	  }, [_vm._v("Valider Doc Sans Correction")])], 1)], 2)
	},staticRenderFns: []}

/***/ }),

/***/ 732:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.questions && _vm.values) ? _c('div', _vm._l((_vm.questionIds), function(qid) {
	    return _c('form-question', {
	      key: qid,
	      staticClass: "light-frame",
	      attrs: {
	        "question": _vm.questions[qid],
	        "values": _vm.values,
	        "value": _vm.values[qid],
	        "error-message": _vm.errorMessages[_vm.questions[qid].a.type]
	      },
	      on: {
	        "answer-value": function($event) {
	          return _vm.valueUpdated(qid, $event)
	        }
	      }
	    })
	  }), 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),

/***/ 733:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.questions && _vm.values) ? _c('div', [_c('div', {
	    staticClass: "light-frame"
	  }, [_c('h3', [_vm._v("General information (answer the questions in french)")]), _vm._v(" "), _vm._l((_vm.questionIds1), function(qid) {
	    return _c('form-question', {
	      key: qid,
	      staticClass: "light-frame",
	      attrs: {
	        "question": _vm.questions[qid],
	        "values": _vm.values,
	        "value": _vm.values[qid],
	        "error-message": _vm.errorMessages[_vm.questions[qid].a.type]
	      },
	      on: {
	        "answer-value": function($event) {
	          return _vm.valueUpdated(qid, $event)
	        }
	      }
	    })
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "light-frame"
	  }, [_c('h3', [_vm._v("Address")]), _vm._v(" "), _vm._l((_vm.questionIds2), function(qid) {
	    return _c('form-question', {
	      key: qid,
	      staticClass: "light-frame",
	      attrs: {
	        "question": _vm.questions[qid],
	        "values": _vm.values,
	        "value": _vm.values[qid],
	        "error-message": _vm.errorMessages[_vm.questions[qid].a.type]
	      },
	      on: {
	        "answer-value": function($event) {
	          return _vm.valueUpdated(qid, $event)
	        }
	      }
	    })
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "light-frame"
	  }, [_c('h3', [_vm._v("Contact Information")]), _vm._v(" "), _vm._l((_vm.questionIds3), function(qid) {
	    return _c('form-question', {
	      key: qid,
	      staticClass: "light-frame",
	      attrs: {
	        "question": _vm.questions[qid],
	        "values": _vm.values,
	        "value": _vm.values[qid],
	        "error-message": _vm.errorMessages[_vm.questions[qid].a.type]
	      },
	      on: {
	        "answer-value": function($event) {
	          return _vm.valueUpdated(qid, $event)
	        }
	      }
	    })
	  })], 2)]) : _vm._e()
	},staticRenderFns: []}

/***/ }),

/***/ 734:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._m(0), _vm._v(" "), (!_vm.paymentDone) ? _c('div', [_vm._m(1), _vm._v(" "), (_vm.$route.params.cart == 'VISA') ? _c('md-card', {
	    staticClass: "light-frame"
	  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v("Help with your visa application file" + _vm._s(_vm.price) + "€ TTC")]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v("Help for your visa application file.")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
	    attrs: {
	      "src": "/static/contract.svg"
	    }
	  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.cart == 'CRRV') ? _c('md-card', {
	    staticClass: "light-frame"
	  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v("Appeal to the Appeals Board on Visa Refusals " + _vm._s(_vm.price) + "€ TTC")]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v("Appeal to the Appeals Board on Visa Refusals.")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
	    attrs: {
	      "src": "/static/contract.svg"
	    }
	  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.cart == 'TA') ? _c('md-card', {
	    staticClass: "light-frame"
	  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v("Appeal to the Administrative Court of Nantes" + _vm._s(_vm.price) + "€ TTC")]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v("appeal to the Administrative Court of Nantes")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
	    attrs: {
	      "src": "/static/contract.svg"
	    }
	  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.cart == 'PREMIUM') ? _c('md-card', {
	    staticClass: "light-frame"
	  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v("Pack Premium " + _vm._s(_vm.price) + "€ TTC")]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v("You are assisted and defended by a lawyer.")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
	    attrs: {
	      "src": "/static/lawyer.svg"
	    }
	  })])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "light-frame visa-frame"
	  }, [_c('div', {
	    staticStyle: {
	      "margin-top": "16px"
	    }
	  }, [_vm._v("\n      Your friend needs to have a payment card like MasterCard, VISA, AMEX\n      ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
	    staticClass: "centered-child"
	  }, [_vm._v("\n       Copy the link below and send it to your friend :\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "centered-child"
	  }, [_c('span', {
	    staticClass: "pay-url"
	  }, [_vm._v(_vm._s(_vm.payURL))]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "display": "flex",
	      "flex-wrap": "wrap",
	      "justify-content": "center"
	    }
	  }, [_c('md-button', {
	    on: {
	      "click": function($event) {
	        return _vm.onCopy()
	      }
	    }
	  }, [_vm._v("Copy")]), _vm._v(" "), _c('md-button', {
	    on: {
	      "click": function($event) {
	        return _vm.onEmail()
	      }
	    }
	  }, [_vm._v("Send by email")])], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "margin-top": "32px"
	    }
	  }, [_vm._v("\n        Once the payment made by your friend, You will receive an email to continue to fill your file and get your appeal.\n      ")]), _vm._v(" "), _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "margin-top": "24px"
	    }
	  }, [_c('md-button', {
	    staticClass: "md-raised md-primary large-button",
	    attrs: {
	      "disabled": _vm.loading
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onClickPay()
	      }
	    }
	  }, [_c('span', [_vm._v("Continue")])])], 1)])], 1) : _c('div', [_c('h2', [_vm._v("We are wainting for your friend payment")]), _vm._v(" "), _c('p', [_vm._v("A summary email has just been sent to you")]), _c('p'), _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "margin-top": "48px"
	    }
	  }, [_c('md-button', {
	    staticClass: "md-raised md-primary large-button",
	    on: {
	      "click": function($event) {
	        return _vm.onClickContinue()
	      }
	    }
	  }, [_vm._v("Continue")])], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "padding-bottom": "16px"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "width": "40%",
	      "max-width": "200px"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/credit-card2.svg"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "padding": "16px"
	    }
	  }, [_c('h2', [_vm._v("Ask a friend to pay for you")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "centered-child"
	  }, [_c('div', [_c('img', {
	    staticStyle: {
	      "height": "48px",
	      "margin": "0px 4px"
	    },
	    attrs: {
	      "src": "/static/visa.svg"
	    }
	  }), _vm._v(" "), _c('img', {
	    staticStyle: {
	      "height": "48px",
	      "margin": "0px 4px"
	    },
	    attrs: {
	      "src": "/static/mastercard.svg"
	    }
	  }), _vm._v(" "), _c('img', {
	    staticStyle: {
	      "height": "48px",
	      "margin": "0px 4px"
	    },
	    attrs: {
	      "src": "/static/american-express.svg"
	    }
	  }), _vm._v(" "), _c('img', {
	    staticStyle: {
	      "height": "24px",
	      "margin": "0px 4px"
	    },
	    attrs: {
	      "src": "/static/locked.svg"
	    }
	  })])])
	}]}

/***/ }),

/***/ 735:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v("Dossier")]), _vm._v(" "), (_vm.values) ? _c('table', [_vm._m(0), _vm._v(" "), _vm._l((_vm.values), function(v, k, i) {
	    return _c('tr', [_c('td', [_c('span', {
	      domProps: {
	        "innerHTML": _vm._s(_vm.getQuestionContent(k))
	      }
	    })]), _vm._v(" "), _c('td', {
	      domProps: {
	        "innerHTML": _vm._s(_vm.getResponse(v, k, i))
	      }
	    })])
	  })], 2) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('tr', [_c('th', {
	    attrs: {
	      "width": "30%"
	    }
	  }, [_vm._v("Question")]), _c('th', [_vm._v("Réponse")])])
	}]}

/***/ }),

/***/ 736:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._m(0), _vm._v(" "), (!_vm.paymentDone) ? _c('div', [_vm._m(1), _vm._v(" "), (_vm.$route.params.cart == 'CRRV') ? _c('md-card', {
	    staticClass: "light-frame"
	  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v("Standard - 299€ TTC")]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v("Appeal to the Appeals Board on Visa Refusals")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
	    attrs: {
	      "src": "/static/contract.svg"
	    }
	  })])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params.cart == 'PREMIUM') ? _c('md-card', {
	    staticClass: "light-frame"
	  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v("Premium - 999€ TTC")]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v("I am assisted and defended by a lawyer ")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
	    attrs: {
	      "src": "/static/lawyer.svg"
	    }
	  })])], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "light-frame visa-frame"
	  }, [_c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "margin-top": "32px"
	    }
	  }, [(_vm.$route.params.cart == 'CRRV') ? _c('form', {
	    attrs: {
	      "action": "https://www.paypal.com/cgi-bin/webscr",
	      "method": "post",
	      "target": "_top"
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "cmd",
	      "value": "_xclick"
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "business",
	      "value": "team-visa@getmyvisatofrance.com"
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "lc",
	      "value": "US"
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "item_name",
	      "value": "Offre Standard CRRV"
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "amount",
	      "value": "299.00"
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "currency_code",
	      "value": "EUR"
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "button_subtype",
	      "value": "services"
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "no_note",
	      "value": "0"
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "bn",
	      "value": "PP-BuyNowBF:btn_buynowCC_LG.gif:NonHostedGuest"
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "image",
	      "src": "https://www.paypalobjects.com/fr_XC/i/btn/btn_buynowCC_LG.gif",
	      "border": "0",
	      "name": "submit",
	      "alt": "PayPal - la solution de paiement en ligne la plus simple et la plus sécurisée !"
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "alt": "",
	      "border": "0",
	      "src": "https://www.paypalobjects.com/fr_XC/i/scr/pixel.gif",
	      "width": "1",
	      "height": "1"
	    }
	  })]) : _vm._e(), _vm._v(" "), (_vm.$route.params.cart == 'PREMIUM') ? _c('form', {
	    attrs: {
	      "action": "https://www.paypal.com/cgi-bin/webscr",
	      "method": "post",
	      "target": "_top"
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "cmd",
	      "value": "_xclick"
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "business",
	      "value": "team-visa@getmyvisatofrance.com"
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "lc",
	      "value": "US"
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "item_name",
	      "value": "Offre Premium"
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "amount",
	      "value": "999.00"
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "currency_code",
	      "value": "EUR"
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "button_subtype",
	      "value": "services"
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "no_note",
	      "value": "0"
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "bn",
	      "value": "PP-BuyNowBF:btn_buynowCC_LG.gif:NonHostedGuest"
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "image",
	      "src": "https://www.paypalobjects.com/fr_XC/i/btn/btn_buynowCC_LG.gif",
	      "border": "0",
	      "name": "submit",
	      "alt": "PayPal - la solution de paiement en ligne la plus simple et la plus sécurisée !"
	    }
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "alt": "",
	      "border": "0",
	      "src": "https://www.paypalobjects.com/fr_XC/i/scr/pixel.gif",
	      "width": "1",
	      "height": "1"
	    }
	  })]) : _vm._e()])])], 1) : _c('div', [_c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "margin-top": "48px"
	    }
	  }, [_c('md-button', {
	    staticClass: "md-raised md-primary large-button",
	    on: {
	      "click": function($event) {
	        return _vm.onClickContinue()
	      }
	    }
	  }, [_vm._v("Continue")])], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "padding-bottom": "16px"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "width": "40%",
	      "max-width": "200px"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/paypal.svg"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "padding": "16px"
	    }
	  }, [_c('h2', [_vm._v("Payment with Paypal")])])
	}]}

/***/ }),

/***/ 737:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "cov-vue-date"
	  }, [_c('div', {
	    staticClass: "datepickbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.date.time),
	      expression: "date.time"
	    }],
	    staticClass: "cov-datepicker",
	    style: (_vm.option.inputStyle ? _vm.option.inputStyle : {}),
	    attrs: {
	      "type": "text",
	      "title": "input date",
	      "readonly": "readonly",
	      "placeholder": _vm.option.placeholder,
	      "required": _vm.required
	    },
	    domProps: {
	      "value": (_vm.date.time)
	    },
	    on: {
	      "click": _vm.showCheck,
	      "foucus": _vm.showCheck,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.date, "time", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.showInfo.check) ? _c('div', {
	    staticClass: "datepicker-overlay",
	    style: ({
	      'background': _vm.option.overlayOpacity ? 'rgba(0,0,0,' + _vm.option.overlayOpacity + ')' : 'rgba(0,0,0,0.5)'
	    }),
	    on: {
	      "click": function($event) {
	        return _vm.dismiss($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "cov-date-wrapper",
	    on: {
	      "click": function($event) {
	        return _vm.dismiss($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "cov-date-body",
	    style: ({
	      'background-color': _vm.option.color ? _vm.option.color.header : '#3f51b5'
	    }),
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	      }
	    }
	  }, [_c('div', {
	    staticClass: "cov-date-monthly"
	  }, [_c('div', {
	    staticClass: "cov-date-previous",
	    on: {
	      "click": function($event) {
	        return _vm.nextMonth('pre')
	      }
	    }
	  }, [_vm._v("«")]), _vm._v(" "), _c('div', {
	    staticClass: "cov-date-caption",
	    style: ({
	      'color': _vm.option.color ? _vm.option.color.headerText : '#fff'
	    })
	  }, [_c('span', {
	    on: {
	      "click": _vm.showYear
	    }
	  }, [_c('small', [_vm._v(_vm._s(_vm.checked.year))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
	    on: {
	      "click": _vm.showMonth
	    }
	  }, [_vm._v(_vm._s(_vm.displayInfo.month))])]), _vm._v(" "), _c('div', {
	    staticClass: "cov-date-next",
	    on: {
	      "click": function($event) {
	        return _vm.nextMonth('next')
	      }
	    }
	  }, [_vm._v("»")])]), _vm._v(" "), (_vm.showInfo.day) ? _c('div', {
	    staticClass: "cov-date-box"
	  }, [_c('div', {
	    staticClass: "cov-picker-box"
	  }, [_c('div', {
	    staticClass: "week"
	  }, [_c('ul', _vm._l((_vm.library.week), function(weekie) {
	    return _c('li', [_vm._v(_vm._s(weekie))])
	  }), 0)]), _vm._v(" "), _vm._l((_vm.dayList), function(day) {
	    return _c('div', {
	      staticClass: "day",
	      class: {
	        'checked': day.checked, 'unavailable': day.unavailable, 'passive-day': !(day.inMonth)
	      },
	      style: (day.checked ? (_vm.option.color && _vm.option.color.checkedDay ? {
	        background: _vm.option.color.checkedDay
	      } : {
	        background: '#F50057'
	      }) : {}),
	      attrs: {
	        "track-by": "$index"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.checkDay(day)
	        }
	      }
	    }, [_vm._v(_vm._s(day.value))])
	  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.showInfo.year) ? _c('div', {
	    staticClass: "cov-date-box list-box"
	  }, [_c('div', {
	    staticClass: "cov-picker-box date-list",
	    attrs: {
	      "id": "yearList"
	    }
	  }, _vm._l((_vm.library.year), function(yearItem) {
	    return _c('div', {
	      staticClass: "date-item",
	      attrs: {
	        "track-by": "$index"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setYear(yearItem)
	        }
	      }
	    }, [_vm._v(_vm._s(yearItem))])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.showInfo.month) ? _c('div', {
	    staticClass: "cov-date-box list-box"
	  }, [_c('div', {
	    staticClass: "cov-picker-box date-list"
	  }, _vm._l((_vm.library.month), function(monthItem) {
	    return _c('div', {
	      staticClass: "date-item",
	      attrs: {
	        "track-by": "$index"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setMonth(monthItem)
	        }
	      }
	    }, [_vm._v(_vm._s(monthItem))])
	  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.showInfo.hour) ? _c('div', {
	    staticClass: "cov-date-box list-box"
	  }, [_c('div', {
	    staticClass: "cov-picker-box date-list"
	  }, [_c('div', {
	    staticClass: "watch-box"
	  }, [_c('div', {
	    staticClass: "hour-box"
	  }, [_c('div', {
	    staticClass: "mui-pciker-rule mui-pciker-rule-ft"
	  }), _vm._v(" "), _c('ul', _vm._l((_vm.hours), function(hitem) {
	    return _c('li', {
	      staticClass: "hour-item",
	      class: {
	        'active': hitem.checked
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setTime('hour', hitem, _vm.hours)
	        }
	      }
	    }, [_vm._v(_vm._s(hitem.value))])
	  }), 0)]), _vm._v(" "), _c('div', {
	    staticClass: "min-box"
	  }, [_c('div', {
	    staticClass: "mui-pciker-rule mui-pciker-rule-ft"
	  }), _vm._v(" "), _vm._l((_vm.mins), function(mitem) {
	    return _c('div', {
	      staticClass: "min-item",
	      class: {
	        'active': mitem.checked
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setTime('min', mitem, _vm.mins)
	        }
	      }
	    }, [_vm._v(_vm._s(mitem.value))])
	  })], 2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "button-box"
	  }, [_c('span', {
	    on: {
	      "click": function($event) {
	        _vm.showInfo.check = false
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.option.buttons ? _vm.option.buttons.cancel : 'Cancel'))]), _vm._v(" "), _c('span', {
	    on: {
	      "click": _vm.picked
	    }
	  }, [_vm._v(_vm._s(_vm.option.buttons ? _vm.option.buttons.ok : 'Ok'))])])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),

/***/ 738:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.initialized) ? _c('div', [(_vm.documentReady) ? _c('div', [_c('h2', [_vm._v("Your file is finished")])]) : (_vm.isWaitingWire) ? _c('div', [_c('h2', [_vm._v("We are wainting for the payment")])]) : (_vm.paymentDone) ? _c('div', [_c('h2', [_vm._v("Your file has to be completed")])]) : (_vm.isInReview) ? _c('div', [_c('h2', [_vm._v("Your file is processing")])]) : (!_vm.hasValues) ? _c('div', [_vm._m(0), _vm._v(" "), _c('h2', {
	    staticStyle: {
	      "text-align": "center"
	    }
	  }, [_vm._v("Simplified procedure to appeal after a visa refusal.")]), _vm._v(" "), _c('h3', {
	    staticStyle: {
	      "text-align": "center",
	      "font-size": "1.3em",
	      "font-weight": "400"
	    }
	  }, [_vm._v("Your appeal file in 4 steps")]), _vm._v(" "), _vm._m(1)]) : _c('div', [_c('h2', [_vm._v("Continue your file")])]), _vm._v(" "), (!_vm.displayUserForm) ? _c('div', {
	    staticStyle: {
	      "margin": "16px 0px"
	    }
	  }, [(_vm.values && (_vm.values.id_user_prenom || _vm.values.id_user_nom || _vm.values.id_user_mail || _vm.values.id_user_phnum)) ? _c('div', [_c('div', {
	    staticClass: "light-frame",
	    staticStyle: {
	      "display": "flex",
	      "justify-content": "space-between"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "padding": "16px 16px"
	    }
	  }, [_c('div', {
	    staticClass: "md-headline"
	  }, [_vm._v(_vm._s(_vm.values.id_user_prenom) + " " + _vm._s(_vm.values.id_user_nom))]), _vm._v(" "), _c('div', {
	    staticClass: "md-caption"
	  }, [_vm._v(_vm._s(_vm.values.id_user_adress_street) + ", " + _vm._s(_vm.values.id_user_adress_city) + ", " + _vm._s(_vm.values.id_user_adress_country))]), _vm._v(" "), _c('div', {
	    staticClass: "md-caption"
	  }, [_vm._v(_vm._s(_vm.values.id_user_mail))]), _vm._v(" "), _c('div', {
	    staticClass: "md-caption"
	  }, [_vm._v(_vm._s(_vm.values.id_user_phnum))])]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "padding": "16px 0px"
	    }
	  }, [_c('md-button', {
	    staticClass: "md-icon-button",
	    on: {
	      "click": function($event) {
	        _vm.displayUserForm = true
	      }
	    }
	  }, [_c('md-icon', [_vm._v("mode_edit")])], 1)], 1)])]) : _vm._e()]) : _c('div', {
	    staticClass: "light-frame",
	    staticStyle: {
	      "padding": "16px",
	      "margin": "16px 0px"
	    }
	  }, [_c('user-form', {
	    ref: "userForm",
	    attrs: {
	      "questions": _vm.questions,
	      "values": _vm.values,
	      "error-messages": _vm.errorMessages
	    }
	  }), _vm._v(" "), (_vm.userFormHasError) ? _c('div', {
	    staticStyle: {
	      "color": "red"
	    }
	  }, [_vm._v("\n      Complètez le formulaire.\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "margin-top": "48px"
	    }
	  }, [_c('md-button', {
	    staticClass: "md-raised md-primary large-button",
	    on: {
	      "click": function($event) {
	        return _vm.onClickValidate()
	      }
	    }
	  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), (_vm.dateLimite) ? _c('div', {
	    staticClass: "light-frame date-limit",
	    style: ({
	      color: _vm.remainingDays > 0 && _vm.remainingDays <= 7 ? 'white' : 'black',
	      backgroundColor: _vm.remainingDays > 0 && _vm.remainingDays <= 7 ? 'red' : 'white'
	    })
	  }, [_c('div', {
	    staticStyle: {
	      "font-size": "1.1em",
	      "text-align": "center",
	      "padding": "16px 8px"
	    }
	  }, [_vm._v("Deadline to send your appeal "), _c('b', [_vm._v(_vm._s(_vm.dateLimiteStr))])]), _vm._v(" "), (_vm.remainingDays > 0) ? _c('div', {
	    staticStyle: {
	      "font-size": "1.5em",
	      "font-weight": "500",
	      "padding": "0px 8px 16px 8px"
	    }
	  }, [_vm._v("Only " + _vm._s(_vm.remainingDaysStr))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.purchases), function(purchase) {
	    return _c('div', [(purchase == 'VISA') ? _c('md-card', {
	      staticClass: "light-frame"
	    }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
	      staticClass: "md-title"
	    }, [_vm._v("Help with your visa application file")]), _vm._v(" "), _c('div', {
	      staticClass: "md-subhead"
	    }, [_vm._v("Help with your visa application file. 10 minutes questionnaire, cover letter, online procedure, online support.")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
	      attrs: {
	        "src": "/static/contract.svg"
	      }
	    })])], 1)], 1) : _vm._e(), _vm._v(" "), (purchase == 'CRRV') ? _c('md-card', {
	      staticClass: "light-frame"
	    }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
	      staticClass: "md-title"
	    }, [_vm._v(" Appeal to the Appeals Board on Visa Refusals")]), _vm._v(" "), _c('div', {
	      staticClass: "md-subhead"
	    }, [_vm._v(" appeal to the Appeals Board on Visa Refusals.  10 minutes questionnaire, cover letter, online procedure, online support.")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
	      attrs: {
	        "src": "/static/contract.svg"
	      }
	    })])], 1)], 1) : _vm._e(), _vm._v(" "), (purchase == 'TA') ? _c('md-card', {
	      staticClass: "light-frame"
	    }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
	      staticClass: "md-title"
	    }, [_vm._v("Appeal to the Administrative Court of Nantes")]), _vm._v(" "), _c('div', {
	      staticClass: "md-subhead"
	    }, [_vm._v("Appeal to the Administrative Court of Nantes.  10 minutes questionnaire, cover letter, online procedure, online support")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
	      attrs: {
	        "src": "/static/contract.svg"
	      }
	    })])], 1)], 1) : _vm._e(), _vm._v(" "), (purchase == 'PREMIUM') ? _c('md-card', {
	      staticClass: "light-frame"
	    }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
	      staticClass: "md-title"
	    }, [_vm._v(" Premium Pack ")]), _vm._v(" "), _c('div', {
	      staticClass: "md-subhead"
	    }, [_vm._v("You are assisted and defended by a specialised lawyer.")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
	      attrs: {
	        "src": "/static/lawyer.svg"
	      }
	    })])], 1)], 1) : _vm._e()], 1)
	  }), _vm._v(" "), (_vm.documentReady) ? _c('div', [_c('p', {
	    staticStyle: {
	      "text-align": "left"
	    }
	  }, [_vm._v("\n       Your file has been checked by our lawyers.\n    ")]), _vm._v(" "), (_vm.purchases.includes('CRRV')) ? _c('div', {
	    staticClass: "centered-child"
	  }, [_vm._m(2), _vm._v(" "), _vm._m(3)]) : (_vm.purchases.includes('TA')) ? _c('div', {
	    staticClass: "centered-child"
	  }, [_vm._m(4), _vm._v(" "), _vm._m(5)]) : _vm._e()]) : (_vm.paymentDone) ? _c('div', [_c('p', [_vm._v("\n     Your file is almost ready. You need to add the attached documents whiwh will support the contestation. Once donce, yor file will be sent to our experts who will verify everything and send it back to you by email.\n    ")])]) : (_vm.isWaitingWire) ? _c('div', [_c('p', [_vm._v("\n      We are waiting for your payment before preparing all the documents.\n    ")])]) : (_vm.isInReview) ? _c('div', [_c('p', [_vm._v("\n      Your file is being processing by our team. We will send you an email when it will be ready to be sent to the administration.\n    ")])]) : (_vm.hasValues) ? _c('div', [_c('p', [_vm._v("\n     First of all, you can fill your file in order to propose you the best service according to your situation.\n    ")])]) : _vm._e(), _vm._v(" "), (_vm.isWaitingWire) ? _c('div', [_c('p', {
	    staticStyle: {
	      "color": "white",
	      "background-color": "red",
	      "text-align": "center",
	      "padding": "16px",
	      "font-size": "1.2em",
	      "font-weight": "500"
	    }
	  }, [_vm._v("\n     We are wainting for the payment of " + _vm._s(_vm.values.id_virement_amount) + "€ before finishing your file.\n    ")]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "text-align": "center",
	      "padding": "16px 16px 8px 16px",
	      "font-size": "1.2em",
	      "border": "1px solid #eee"
	    }
	  }, [_vm._v("\n     If you have a friend who have a payment card like MasterCard, VISA ou AMEX, he/she can pay for you.\n      Send him/her this link:\n      "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "pay-url"
	  }, [_vm._v(_vm._s(_vm.payURL))]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "margin-top": "8px",
	      "display": "flex",
	      "flex-wrap": "wrap",
	      "justify-content": "center"
	    }
	  }, [_c('md-button', {
	    on: {
	      "click": function($event) {
	        return _vm.onCopy()
	      }
	    }
	  }, [_vm._v("Copy")]), _vm._v(" "), _c('md-button', {
	    on: {
	      "click": function($event) {
	        return _vm.onEmail()
	      }
	    }
	  }, [_vm._v("Send by email")])], 1)]), _vm._v(" "), (_vm.values.id_virement_type == 'wire') ? _c('div', {
	    staticClass: "light-frame visa-frame"
	  }, [_c('h3', [_vm._v("Payment by international bank transfer")]), _vm._v(" "), _c('p', [_vm._v("To proceed the pyament you have to make a international bank transfer on GetMyVisaToFrance account")]), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "padding-left": "16px"
	    }
	  }, [_c('b', [_vm._v("Amount: " + _vm._s(_vm.values.id_virement_amount) + "€")]), _c('br'), _vm._v(" "), _c('b', [_vm._v("IBAN : DE06100110012626269080")]), _c('br'), _vm._v(" "), _c('b', [_vm._v("BIC/SWIFT : NTSBDEB1XXX")])])]) : _vm._e(), _vm._v(" "), (_vm.values.id_virement_type == 'mandat-express') ? _c('div', {
	    staticClass: "light-frame visa-frame"
	  }, [_c('h3', [_vm._v("Payment by Express Money Order ")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "padding-left": "16px"
	    }
	  }, [_c('b', [_vm._v("AMount: " + _vm._s(_vm.values.id_virement_amount) + "€")]), _c('br'), _vm._v(" "), _c('b', [_vm._v("Name of the company : OCTAGRAM SAS")]), _c('br'), _vm._v(" "), _c('b', [_vm._v("Adress : 59 rue Chardon Lagache 75016 Paris")])])]) : _vm._e(), _vm._v(" "), (_vm.values.id_virement_type == 'western-union') ? _c('div', {
	    staticClass: "light-frame visa-frame"
	  }, [_c('h3', [_vm._v("Payment by Western Union")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', {
	    staticStyle: {
	      "padding-left": "16px"
	    }
	  }, [_c('b', [_vm._v("Amount: " + _vm._s(_vm.values.id_virement_amount) + "€")]), _c('br'), _vm._v(" "), _c('b', [_vm._v("First name : Alexandre, René, Georges")]), _c('br'), _vm._v(" "), _c('b', [_vm._v("Last name : GRUX")]), _c('br'), _vm._v(" "), _c('b', [_vm._v("Adress : 59 rue Chardon Lagache 75016 Paris")])])]) : _vm._e(), _vm._v(" "), _vm._m(8)]) : (_vm.documentReady) ? _c('div', [_c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "margin-top": "0px",
	      "align-items": "center",
	      "flex-direction": "column"
	    }
	  }, [_c('md-button', {
	    staticClass: "md-accent",
	    on: {
	      "click": function($event) {
	        return _vm.onClickView()
	      }
	    }
	  }, [_vm._v("Download the document")])], 1)]) : (!_vm.isInReview) ? _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "margin-top": "32px"
	    }
	  }, [(_vm.hasValues) ? _c('div', [_c('md-button', {
	    staticClass: "md-raised md-primary large-button",
	    on: {
	      "click": function($event) {
	        return _vm.onClickComplete()
	      }
	    }
	  }, [_vm._v("Complete your file")]), _vm._v(" "), (_vm.purchases && _vm.purchases.length > 0) ? _c('div', [_c('md-button', {
	    staticClass: "md-raised md-primary large-button",
	    on: {
	      "click": function($event) {
	        return _vm.onClickConsult()
	      }
	    }
	  }, [_vm._v("Change your answers")])], 1) : _vm._e(), _vm._v(" "), (_vm.hasValueFiles) ? _c('div', [_c('md-button', {
	    staticClass: "md-raised md-primary large-button",
	    on: {
	      "click": function($event) {
	        return _vm.onClickRender()
	      }
	    }
	  }, [_vm._v("Finish your appeal")])], 1) : _vm._e()], 1) : _c('div', {
	    staticStyle: {
	      "display": "flex",
	      "width": "100%",
	      "align-items": "center",
	      "flex-direction": "column"
	    }
	  }, [_c('div', [_c('md-button', {
	    staticClass: "md-raised md-primary large-button",
	    on: {
	      "click": function($event) {
	        return _vm.onClickStart()
	      }
	    }
	  }, [_vm._v("Continue")])], 1)])]) : _vm._e()], 2) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "padding-bottom": "16px"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "width": "100%",
	      "max-width": "200px"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/justice.svg",
	      "width": "100%"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container1234"
	  }, [_c('div', {
	    staticClass: "item1234"
	  }, [_c('span', {
	    staticClass: "badge1234"
	  }, [_vm._v("1")]), _vm._v(" "), _c('div', {
	    staticClass: "right1234"
	  }, [_c('span', {
	    staticStyle: {
	      "font-size": "1.3em"
	    }
	  }, [_vm._v("Qualification")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "display": "block",
	      "margin-top": "4px"
	    }
	  }, [_vm._v("Thanks to our online questionnaire, you will check if you are still able to appeal and see which appeal procedure you need.")])])]), _vm._v(" "), _c('div', {
	    staticClass: "item1234"
	  }, [_c('span', {
	    staticClass: "badge1234"
	  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
	    staticClass: "right1234"
	  }, [_c('span', {
	    staticStyle: {
	      "font-size": "1.3em"
	    }
	  }, [_vm._v("Payment")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "display": "block",
	      "margin-top": "4px"
	    }
	  }, [_vm._v("Choose one service (standard or premium) and make the payment online or by order money.")])])]), _vm._v(" "), _c('div', {
	    staticClass: "item1234"
	  }, [_c('span', {
	    staticClass: "badge1234"
	  }, [_vm._v("3")]), _vm._v(" "), _c('div', {
	    staticClass: "right1234"
	  }, [_c('span', {
	    staticStyle: {
	      "font-size": "1.3em"
	    }
	  }, [_vm._v("Creation of the file")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "display": "block",
	      "margin-top": "4px"
	    }
	  }, [_vm._v("You prepare your file by adding all the documents suggested according to your situation.")])])]), _vm._v(" "), _c('div', {
	    staticClass: "item1234"
	  }, [_c('span', {
	    staticClass: "badge1234"
	  }, [_vm._v("4")]), _vm._v(" "), _c('div', {
	    staticClass: "right1234"
	  }, [_c('span', {
	    staticStyle: {
	      "font-size": "1.3em"
	    }
	  }, [_vm._v("Processing and mailing")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "display": "block",
	      "margin-top": "4px"
	    }
	  }, [_vm._v("Your file is ready and has been checked by our experts. You just need to print it and send it to the address indicated.")])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticStyle: {
	      "text-align": "left"
	    }
	  }, [_vm._v("\n        You can now "), _c('strong', [_vm._v("download")]), _vm._v("\n        the document, print it in "), _c('strong', [_vm._v("1 copy")]), _vm._v(",  "), _c('strong', [_vm._v("sign")]), _vm._v(" it, add the "), _c('strong', [_vm._v("attached documents")]), _vm._v(" and send it\n        by "), _c('strong', [_vm._v("registered post with acknowledgement of receipt")]), _vm._v(" to this address :\n      ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticStyle: {
	      "display": "inline-block",
	      "text-align": "center",
	      "border": "1px solid",
	      "padding": "16px 32px"
	    }
	  }, [_vm._v("\n        Commission contre les refus de visa d'entrée en France"), _c('br'), _vm._v("\n        BP 83609"), _c('br'), _vm._v("\n        44036 Nantes Cedex 01"), _c('br'), _vm._v("\n        France"), _c('br')])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticStyle: {
	      "text-align": "left"
	    }
	  }, [_vm._v("\n          You can now "), _c('strong', [_vm._v("download")]), _vm._v("\n         the document, print it in "), _c('strong', [_vm._v("4 copies")]), _vm._v(",  "), _c('strong', [_vm._v("sign")]), _vm._v(" it, add the"), _c('strong', [_vm._v("attached documents")]), _vm._v("  and send it\n          by "), _c('strong', [_vm._v("registered post with acknowledgement of receipt")]), _vm._v(" to this address:\n      ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticStyle: {
	      "display": "inline-block",
	      "text-align": "center",
	      "border": "1px solid",
	      "padding": "16px 32px"
	    }
	  }, [_vm._v("\n        Tribunal administratif de Nantes, Monsieur et Madame le Greffier"), _c('br'), _vm._v("\n        BP 24111"), _c('br'), _vm._v("\n        44041 Nantes Cedex 1"), _c('br'), _vm._v("\n        France"), _c('br')])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("To proceed the payment you have to go "), _c('u', [_vm._v("in a post office")]), _vm._v(" to make an international Express Money Order \n       on the OCTAGRAM SAS account, GetMyVIsaToFrance oprator.")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("To proceed the payment you have to go "), _c('u', [_vm._v("in a Western Union agency")]), _vm._v(" to make the transfer\n       to the legal representative of the OCTAGRAM SAS company, GetMyVIsaToFrance oprator.")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', {
	    staticStyle: {
	      "color": "white",
	      "background-color": "#2196F3",
	      "text-align": "center",
	      "padding": "16px",
	      "font-size": "1.2em",
	      "font-weight": "500"
	    }
	  }, [_vm._v("\n     incase of problem with the payment, please call our account service au :"), _c('br'), _vm._v(" "), _c('a', {
	    staticStyle: {
	      "color": "white",
	      "font-size": "1.4em",
	      "line-height": "1.5em"
	    },
	    attrs: {
	      "href": "tel:+33977218845"
	    }
	  }, [_vm._v("+33 977 218 845")])])
	}]}

/***/ }),

/***/ 739:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "width": "100%",
	      "height": "100%"
	    }
	  }, [_vm._m(0), _vm._v(" "), (_vm.recoursType == 'visa') ? _c('div', [_c('h2', [_vm._v("Apply for a visa for France")]), _vm._v(" "), _c('p', [_vm._v("You did not apply for a visa yet. Our team can help you to build your visa application file and write a cover letter for you")])]) : _c('div', [_c('h2', [_vm._v("You are able to appeal after your visa refusal! ")]), _vm._v(" "), _c('p', [_vm._v("Deadlines are respected, we can help you with your visa appeal file.")])]), _vm._v(" "), _c('p', [_vm._v("You can choose the service that corresponds to your needs")]), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "display": "flex",
	      "flex-wrap": "wrap",
	      "justify-content": "space-between",
	      "margin": "16px 0px"
	    }
	  }, [(_vm.recoursType == 'visa') ? _c('md-card', {
	    staticClass: "card-layout light-frame"
	  }, [_c('md-card-media', {
	    staticStyle: {
	      "padding": "16px",
	      "display": "flex",
	      "justify-content": "center"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "max-width": "140px"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/contract.svg"
	    }
	  })])]), _vm._v(" "), _c('md-card-header', {
	    staticStyle: {
	      "flex-grow": "2"
	    }
	  }, [_c('div', {
	    staticClass: "md-title",
	    staticStyle: {
	      "text-align": "center",
	      "padding-bottom": "8px"
	    }
	  }, [_vm._v("Help for your visa application file"), _c('br'), _vm._v("120€")]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v("Help for your visa application that you will have to send by yourself. A 10 minutes questionnaire, cover letter, online procedure, online support.")])]), _vm._v(" "), _c('md-card-actions', [_c('md-button', {
	    on: {
	      "click": function($event) {
	        return _vm.onClickDetails()
	      }
	    }
	  }, [_vm._v("Details")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-raised md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.onClickSelect('VISA')
	      }
	    }
	  }, [_vm._v("Choose")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.recoursType == 'crrv') ? _c('md-card', {
	    staticClass: "card-layout light-frame"
	  }, [_c('md-card-media', {
	    staticStyle: {
	      "padding": "16px",
	      "display": "flex",
	      "justify-content": "center"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "max-width": "140px"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/contract.svg"
	    }
	  })])]), _vm._v(" "), _c('md-card-header', {
	    staticStyle: {
	      "flex-grow": "2"
	    }
	  }, [_c('div', {
	    staticClass: "md-title",
	    staticStyle: {
	      "text-align": "center",
	      "padding-bottom": "8px"
	    }
	  }, [_vm._v("Board after visa refusal"), _c('br'), _vm._v("299€")]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v("Appeal to the Appeals Board on Visa Refusals. 10-minutes questionnaire, online procedure, online support.")])]), _vm._v(" "), _c('md-card-actions', [_c('md-button', {
	    on: {
	      "click": function($event) {
	        return _vm.onClickDetails()
	      }
	    }
	  }, [_vm._v("Details")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-raised md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.onClickSelect('CRRV')
	      }
	    }
	  }, [_vm._v("Choose")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.recoursType == 'ta') ? _c('md-card', {
	    staticClass: "card-layout light-frame"
	  }, [_c('md-card-media', {
	    staticStyle: {
	      "padding": "16px",
	      "display": "flex",
	      "justify-content": "center"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "max-width": "140px"
	    }
	  }, [_c('img', {
	    attrs: {
	      "width": "100%",
	      "src": "/static/contract.svg"
	    }
	  })])]), _vm._v(" "), _c('md-card-header', {
	    staticStyle: {
	      "flex-grow": "2"
	    }
	  }, [_c('div', {
	    staticClass: "md-title",
	    staticStyle: {
	      "text-align": "center",
	      "padding-bottom": "8px"
	    }
	  }, [_vm._v("Appeal to the Administrative Court Nantes"), _c('br'), _vm._v("299€")]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v("Appeal to the Administrative Court of Nantes.  10-minutes questionnaire, online procedure, online support.")])]), _vm._v(" "), _c('md-card-actions', [_c('md-button', {
	    on: {
	      "click": function($event) {
	        return _vm.onClickDetails()
	      }
	    }
	  }, [_vm._v("Details")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-raised md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.onClickSelect('TA')
	      }
	    }
	  }, [_vm._v("Choisir")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-card', {
	    staticClass: "card-layout light-frame"
	  }, [_c('md-card-media', {
	    staticStyle: {
	      "padding": "16px",
	      "display": "flex",
	      "justify-content": "center"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "max-width": "140px"
	    }
	  }, [_c('img', {
	    attrs: {
	      "width": "100%",
	      "src": "/static/lawyer.svg"
	    }
	  })])]), _vm._v(" "), _c('md-card-header', {
	    staticStyle: {
	      "flex-grow": "2"
	    }
	  }, [_c('div', {
	    staticClass: "md-title",
	    staticStyle: {
	      "text-align": "center",
	      "padding-bottom": "8px"
	    }
	  }, [_vm._v(" Premium Pack"), _c('br'), _vm._v("999€")]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v("You are assisted and defended by a specialised lawyer..")])]), _vm._v(" "), _c('md-card-actions', [_c('md-button', {
	    on: {
	      "click": function($event) {
	        return _vm.onClickDetails()
	      }
	    }
	  }, [_vm._v("Details")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-raised md-primary",
	    on: {
	      "click": function($event) {
	        return _vm.onClickSelect('PREMIUM')
	      }
	    }
	  }, [_vm._v("Choose")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "light-frame",
	    staticStyle: {
	      "background-color": "#fff",
	      "padding": "16px"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "display": "flex",
	      "align-items": "center",
	      "justify-content": "center",
	      "align-content": "center",
	      "flex-wrap": "wrap"
	    }
	  }, [_c('img', {
	    staticStyle: {
	      "height": "32px"
	    },
	    attrs: {
	      "src": "/static/trustedpilot.jpg",
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "display": "flex"
	    }
	  }, [_c('svg', {
	    staticClass: "star"
	  }, [_c('use', {
	    attrs: {
	      "xlink:href": "#svg-star"
	    }
	  })]), _vm._v(" "), _c('svg', {
	    staticClass: "star"
	  }, [_c('use', {
	    attrs: {
	      "xlink:href": "#svg-star"
	    }
	  })]), _vm._v(" "), _c('svg', {
	    staticClass: "star"
	  }, [_c('use', {
	    attrs: {
	      "xlink:href": "#svg-star"
	    }
	  })]), _vm._v(" "), _c('svg', {
	    staticClass: "star"
	  }, [_c('use', {
	    attrs: {
	      "xlink:href": "#svg-star"
	    }
	  })]), _vm._v(" "), _c('svg', {
	    staticClass: "star"
	  }, [_c('use', {
	    attrs: {
	      "xlink:href": "#svg-star-half"
	    }
	  })])]), _vm._v(" "), _vm._m(1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "padding-bottom": "16px"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "width": "100%",
	      "max-width": "200px"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/trophy.svg",
	      "width": "100%"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "cursor": "pointer",
	      "padding": "8px 16px",
	      "font-size": "1.1em"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "https://fr.trustpilot.com/review/getmyvisatofrance.com",
	      "target": "_black"
	    }
	  }, [_vm._v("Consulter les avis clients")])])
	}]}

/***/ }),

/***/ 740:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v("Pieces to download")]), _vm._v(" "), _vm._l((_vm.questionsWithFile), function(q) {
	    return _c('div', _vm._l((q.files(_vm.values)), function(f) {
	      return _c('div', {
	        staticClass: "light-frame"
	      }, [_c('div', {
	        staticStyle: {
	          "display": "flex",
	          "align-items": "center",
	          "justify-content": "space-between"
	        }
	      }, [_c('div', {
	        staticClass: "md-body-2",
	        domProps: {
	          "innerHTML": _vm._s(f.label.en)
	        }
	      }), _vm._v(" "), _c('div', {
	        on: {
	          "click": function($event) {
	            return _vm.onClickUpload($event)
	          }
	        }
	      }, [_c('input', {
	        staticStyle: {
	          "display": "none"
	        },
	        attrs: {
	          "type": "file",
	          "accept": "application/pdf,image/*",
	          "multiple": ""
	        },
	        on: {
	          "click": function($event) {
	            return _vm.fileInputClick($event, f.id)
	          },
	          "change": function($event) {
	            return _vm.fileInputChange($event, f.id)
	          }
	        }
	      }), _vm._v(" "), _c('md-button', {
	        staticClass: "md-icon-button md-raised md-primary md-mini",
	        staticStyle: {
	          "margin": "16px 0px 16px 16px"
	        }
	      }, [_c('md-icon', [_vm._v("file_upload")])], 1)], 1)]), _vm._v(" "), (_vm.values._files && _vm.values._files[f.id] && _vm.values._files[f.id]) ? _c('div', _vm._l((_vm.values._files[f.id]), function(file) {
	        return _c('div', {
	          staticStyle: {
	            "display": "flex",
	            "align-items": "center"
	          }
	        }, [_c('md-button', {
	          staticClass: "md-icon-button",
	          on: {
	            "click": function($event) {
	              return _vm.removeFile(f.id, file.hashname)
	            }
	          }
	        }, [_c('md-icon', [_vm._v("delete")])], 1), _vm._v(" "), _c('md-button', {
	          staticClass: "md-accent",
	          on: {
	            "click": function($event) {
	              return _vm.onClickShowFile(file.hashname)
	            }
	          }
	        }, [_vm._v(_vm._s(file.filename))])], 1)
	      }), 0) : _vm._e()])
	    }), 0)
	  }), _vm._v(" "), _vm._l((_vm.uploadingFiles), function(percent, name) {
	    return _c('div', [_vm._v("\n    Download" + _vm._s(name) + " : " + _vm._s(percent) + "%\n  ")])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "margin-top": "48px"
	    }
	  }, [_c('md-button', {
	    staticClass: "md-raised md-primary large-button",
	    on: {
	      "click": function($event) {
	        return _vm.onClickContinue()
	      }
	    }
	  }, [_vm._v("Continue")])], 1)], 2)
	},staticRenderFns: []}

/***/ }),

/***/ 741:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v("Confirmer l'envoi")]), _vm._v(" "), (_vm.documentReady) ? _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "margin-top": "48px",
	      "color": "white",
	      "background-color": "red"
	    }
	  }, [_c('div', {
	    staticClass: "md-headline"
	  }, [_vm._v("Dossier déjà validé")])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "margin-top": "48px",
	      "align-items": "center",
	      "flex-direction": "column"
	    }
	  }, [_c('md-button', {
	    staticClass: "md-accent",
	    on: {
	      "click": function($event) {
	        return _vm.onClickView()
	      }
	    }
	  }, [_vm._v("Visualiser le PDF")]), _vm._v(" "), (!_vm.confirmed && !_vm.documentReady) ? _c('md-button', {
	    staticClass: "md-raised md-primary large-button",
	    attrs: {
	      "disabled": !_vm.pdfOpened || _vm.loading
	    },
	    on: {
	      "click": function($event) {
	        return _vm.onClickConfirm()
	      }
	    }
	  }, [_vm._v("Confirmer l'envoi au Client")]) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),

/***/ 742:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "width": "100%",
	      "height": "100%"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Your file cannot be processed")]), _vm._v(" "), _c('p', [_vm._v("We cannot work on your file for an appeal procedure after a visa refusal. There are different reasons :")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v("\n  If you have made a mistake in your answers , you can "), _c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_vm._v("restart")]), _vm._v(" the questionnaire\n  or contact us by email "), _c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.onClickContact()
	      }
	    }
	  }, [_vm._v("contact-visa@getmyvisatofrance.com")]), _vm._v(" to ask for our expert opinion.\n  ")], 1), _vm._v(" "), _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "margin-top": "0px",
	      "align-items": "center",
	      "flex-direction": "column"
	    }
	  }, [_c('md-button', {
	    staticClass: "md-raised md-primary large-button",
	    on: {
	      "click": function($event) {
	        return _vm.onClickContact()
	      }
	    }
	  }, [_vm._v("Contact us")])], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "padding-bottom": "16px"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "width": "100%",
	      "max-width": "200px"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/justice-scale.svg",
	      "width": "100%"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', [_c('li', [_vm._v("The appeal has to be done within the "), _c('b', [_vm._v("2 months after ")]), _vm._v(" your visa refusal or after your appeal to the Appeals Board on Visa Refusals.")]), _vm._v(" "), _c('li', [_vm._v("You indicated that your visa has not been refused ! We can't do anything for you")])])
	}]}

/***/ }),

/***/ 743:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.screen) ? _c('screen-view', {
	    attrs: {
	      "sessionId": _vm.$route.params.sessionId,
	      "screen": _vm.screen,
	      "questions": _vm.questions,
	      "screens": _vm.screens,
	      "values": _vm.values,
	      "error-messages": _vm.errorMessages
	    },
	    on: {
	      "transition-to-prev-screen": function($event) {
	        return _vm.prevScreen()
	      },
	      "transition-to-next-screen": function($event) {
	        return _vm.nextScreen($event)
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 744:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h2', [_vm._v("Overview of the first page of your appeal")]), _vm._v(" "), _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "margin": "32px 0px"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "display": "block"
	    }
	  }, [_c('canvas', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.pageRendered),
	      expression: "pageRendered"
	    }],
	    staticStyle: {
	      "border": "1px solid #ddd"
	    },
	    attrs: {
	      "id": "pdfcanvas"
	    }
	  })]), _vm._v(" "), (!_vm.pageRendered) ? _c('div', {
	    staticStyle: {
	      "max-width": "300px",
	      "border": "1px solid #ddd",
	      "border-radius": "2px",
	      "padding": "16px 32px",
	      "text-align": "center",
	      "margin": "16px"
	    }
	  }, [_vm._v(" \n      Please wait, we are making the overview of your appeal.\n      "), _c('br'), _vm._v(" "), _c('i', {
	    staticClass: "fa fa-gear fa-spin",
	    staticStyle: {
	      "font-size": "32px",
	      "margin-top": "16px",
	      "color": "#888"
	    }
	  })]) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "margin-top": "48px"
	    }
	  }, [_c('md-button', {
	    staticClass: "md-raised md-primary large-button",
	    on: {
	      "click": function($event) {
	        return _vm.onContinue()
	      }
	    }
	  }, [_vm._v("Continue")])], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('p', [_vm._v("\n    The document represents "), _c('u', [_vm._v("a draft")]), _vm._v(" of your appeal.\n    Your "), _c('u', [_vm._v(" final ")]), _vm._v(" appeal will be sent to the administration once the file is completely done.\n    ")])])
	}]}

/***/ }),

/***/ 745:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "width": "100%",
	      "height": "100%"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Your file needs a personalised help.")]), _vm._v(" "), _c('p', [_vm._v("We advise you to contact our experts for a personnalised procedure.")]), _vm._v(" "), _c('p', [_vm._v("\n  You can "), _c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_vm._v("restart")]), _vm._v(" another procedure\n  or contact us by email "), _c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.onClickContact()
	      }
	    }
	  }, [_vm._v("contact-visa@getmyvisatofrance.com")]), _vm._v(" to have an appointment with our experts \n  ")], 1), _vm._v(" "), _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "margin-top": "0px",
	      "align-items": "center",
	      "flex-direction": "column"
	    }
	  }, [_c('md-button', {
	    staticClass: "md-raised md-primary large-button",
	    on: {
	      "click": function($event) {
	        return _vm.onClickContact()
	      }
	    }
	  }, [_vm._v("Contact us")])], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "padding-bottom": "16px"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "width": "100%",
	      "max-width": "200px"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/team.svg",
	      "width": "100%"
	    }
	  })])])
	}]}

/***/ }),

/***/ 746:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "width": "100%",
	      "height": "100%"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Personalised help.")]), _vm._v(" "), _c('p', [_vm._v("Our experts are going to contact you for a visa appeal personalised procedure.")]), _vm._v(" "), _c('p', [_vm._v("\n  If you have some questions you can contact us by email "), _c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.onClickContact()
	      }
	    }
	  }, [_vm._v("contact-visa@getmyvisatofrance.com")]), _vm._v(". \n  ")])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "padding-bottom": "16px"
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "width": "100%",
	      "max-width": "200px"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/team.svg",
	      "width": "100%"
	    }
	  })])])
	}]}

/***/ }),

/***/ 747:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "centered-child",
	    staticStyle: {
	      "padding-bottom": "16px"
	    }
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('md-card', {
	    staticClass: "light-frame",
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v("With MasterCard, VISA, AMEX")]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v("\n             You need to have a payment card like MasterCard, VISA ou AMEX."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n             You will receive your appeal within the next 48 hours.\n           ")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
	    staticStyle: {
	      "max-width": "240px"
	    },
	    attrs: {
	      "src": "/static/credit-card.svg"
	    }
	  })])], 1), _vm._v(" "), _c('md-card-media', {
	    staticStyle: {
	      "padding": "16px",
	      "display": "flex",
	      "justify-content": "center"
	    }
	  }, [_c('md-button', {
	    staticClass: "md-raised md-primary large-button",
	    on: {
	      "click": function($event) {
	        return _vm.onClick('stripe')
	      }
	    }
	  }, [_vm._v("Choose")])], 1)], 1), _vm._v(" "), _c('md-card', {
	    staticClass: "light-frame",
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('md-card-header', [_c('md-card-header-text', [_c('div', {
	    staticClass: "md-title"
	  }, [_vm._v("Ask a friend to pay for you")]), _vm._v(" "), _c('div', {
	    staticClass: "md-subhead"
	  }, [_vm._v("\n            You know someone whocan pay for you witha payment card like MasterCard, VISA ou AMEX."), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n            You will receive your appeal within the next 48 hours.\n           ")])]), _vm._v(" "), _c('md-card-media', [_c('img', {
	    staticStyle: {
	      "max-width": "240px"
	    },
	    attrs: {
	      "src": "/static/credit-card2.svg"
	    }
	  })])], 1), _vm._v(" "), _c('md-card-media', {
	    staticStyle: {
	      "padding": "16px",
	      "display": "flex",
	      "justify-content": "center"
	    }
	  }, [_c('md-button', {
	    staticClass: "md-raised md-primary large-button",
	    on: {
	      "click": function($event) {
	        return _vm.onClick('stripe-friend')
	      }
	    }
	  }, [_vm._v("Choose")])], 1)], 1)], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "padding-top": "16px"
	    }
	  }, [_c('h2', [_vm._v("Choose your means of payment")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticStyle: {
	      "width": "100%"
	    }
	  }, [_c('p', {
	    staticStyle: {
	      "font-size": "16px",
	      "padding-bottom": "16px"
	    }
	  }, [_vm._v("\n         You need to pay before making your appeal")])])
	}]}

/***/ }),

/***/ 753:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),

/***/ 754:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),

/***/ 755:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),

/***/ 756:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),

/***/ 757:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),

/***/ 758:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })

});


// WEBPACK FOOTER //
// static/js/main.f0904c0b29dcae0571c6.js